export const SUPPORTED_LOCALES = ['uk', 'en', 'pl', 'de', 'fr', 'es'] as const;
export type Locale = typeof SUPPORTED_LOCALES[number];

export const translations: Record<Locale, Record<string, string>> = {
  uk: {
    'nav.board': 'Дошки',
    'nav.myCards': 'Мої картки',
    'nav.profile': 'Профіль',
    'nav.faq': 'FAQ',
    'nav.help': 'Довідка',
    'nav.community': 'Спільнота',
    'nav.logout': 'Вийти',
    'nav.greeting': 'Привіт, {name}',
    'nav.menu': 'Меню',
    'nav.language': 'Мова',
    'common.save': 'Зберегти',
    'common.cancel': 'Скасувати',
    'common.delete': 'Видалити',
    'common.search': 'Пошук',
    'common.loading': 'Завантаження...',
    'common.error': 'Виникла помилка',
    'common.actionFailed': 'Дія не виконалась. Спробуйте ще раз.',
    'common.retry': 'Повторити',
    'common.close': 'Закрити',
    'common.add': 'Додати',
    'common.assigned': 'Призначено',
    'common.notAssigned': 'Не призначено',
    'common.create': 'Створити',
    'common.update': 'Оновити',
    'common.copyLink': 'Скопіювати посилання',
    'common.share': 'Поділитися',
    'common.clear': 'Очистити',
    'common.noConnection': 'Немає зʼєднання',
    'common.saving': 'Зберігаємо...',
    'common.unknown': 'невідомо',
    'common.linkCopied': 'Посилання скопійовано',
    'common.copySuffix': ' (копія)',
    'common.copy': 'Копіювати',
    'common.copying': 'Копіювання...',
    'common.edit': 'Редагувати',
    'common.creating': 'Створення...',
    'common.confirmDelete': 'Видалити?',
    'common.redirecting': 'Перенаправлення...',
    'common.or': 'або',
    'auth.welcome': 'Ласкаво просимо',
    'auth.createAccount': 'Створити акаунт',
    'auth.joinBoardly': 'Приєднуйтесь до Boardly та керуйте завданнями ефективно.',
    'auth.enterDetails': 'Введіть свої дані, щоб увійти в систему.',
    'auth.firstName': "Ім'я",
    'auth.lastName': 'Прізвище',
    'auth.email': 'Email',
    'auth.username': 'Логін',
    'auth.password': 'Пароль',
    'auth.placeholderFirstName': 'Іван',
    'auth.placeholderLastName': 'Петренко',
    'auth.placeholderUsername': 'Ваш логін',
    'auth.placeholderPassword': '********',
    'auth.forgotPassword': 'Забули пароль?',
    'auth.processing': 'Обробка...',
    'auth.signUp': 'Зареєструватися',
    'auth.signIn': 'Увійти',
    'auth.hasAccount': 'Вже є акаунт?',
    'auth.noAccount': 'Немає акаунту?',
    'auth.googleError': 'Не вдалося увійти через Google.',
    'auth.loginError': 'Помилка авторизації.',
    'auth.registerSuccessTitle': 'Успішна реєстрація!',
    'auth.registerSuccessHint': 'Ми надіслали лист для підтвердження на {email}. Перевірте пошту.',
    'auth.backToLogin': 'Повернутися до входу',
    'auth.organizationOptional': 'Організація (необов\'язково)',
    'auth.usernameOrEmail': 'Логін або Email',
    'auth.policyPrefix': 'Я погоджуюся з',
    'auth.policyLink': 'політикою конфіденційності',
    'auth.googleSignIn': 'Увійти через Google',
    'auth.preview.todoTitle': 'До виконання',
    'auth.preview.todoCard': 'Дизайн сторінки входу',
    'auth.preview.progressTitle': 'У процесі',
    'auth.preview.progressCard': 'Реалізувати drag & drop',
    'auth.preview.doneTitle': 'Готово',
    'auth.preview.doneCard': 'Створення дошки',
    'passwordReset.title': 'Відновлення паролю',
    'passwordReset.description': 'Введіть вашу електронну пошту, і ми надішлемо вам посилання для відновлення доступу.',
    'passwordReset.successTitle': 'Лист відправлено!',
    'passwordReset.successHint': 'Перевірте вашу пошту (або консоль розробника Django), щоб знайти посилання для скидання паролю.',
    'passwordReset.successDetail': 'Ми надіслали інструкції на {email}. Перевірте «Вхідні» та «Спам».',
    'passwordReset.backToLogin': 'Повернутися до входу',
    'passwordReset.emailLabel': 'Email',
    'passwordReset.emailPlaceholder': 'name@example.com',
    'passwordReset.submit': 'Відновити пароль',
    'passwordReset.sending': 'Відправка...',
    'passwordReset.remembered': 'Я згадав пароль',
    'passwordReset.error': 'Не вдалося знайти користувача з таким email або сталася помилка.',
    'resetConfirm.title': 'Новий пароль',
    'resetConfirm.description': 'Створіть новий надійний пароль для вашого акаунту.',
    'resetConfirm.successTitle': 'Успішно!',
    'resetConfirm.successHint': 'Пароль змінено. Зараз вас перенаправить на сторінку входу...',
    'resetConfirm.successAction': 'Увійти з новим паролем',
    'resetConfirm.newPasswordLabel': 'Новий пароль',
    'resetConfirm.newPasswordPlaceholder': 'Мінімум 8 символів',
    'resetConfirm.confirmPasswordLabel': 'Підтвердження паролю',
    'resetConfirm.confirmPasswordPlaceholder': 'Повторіть пароль',
    'resetConfirm.submit': 'Змінити пароль',
    'resetConfirm.saving': 'Збереження...',
    'resetConfirm.errorMismatch': 'Паролі не співпадають',
    'resetConfirm.errorPassword': 'Пароль: {message}',
    'resetConfirm.errorInvalidLink': 'Посилання для скидання недійсне або застаріло.',
    'resetConfirm.errorUnknown': 'Сталася невідома помилка. Спробуйте ще раз.',
    'lang.uk': 'Українська',
    'lang.en': 'English',
    'lang.pl': 'Polski',
    'lang.de': 'Deutsch',
    'lang.fr': 'Français',
    'lang.es': 'Español',
    'board.archive': 'Архівувати дошку',
    'board.archiveConfirm': 'Архівувати дошку?',
    'board.archivedSuffix': '(архів)',
    'board.create.newButton': '+ Нова дошка',
    'board.create.titlePlaceholder': 'Назва дошки',
    'board.create.titleLabel': 'Назва дошки',
    'board.create.titleInputPlaceholder': 'Введіть назву...',
    'board.create.typeTitle': 'Що створити?',
    'board.create.typeIntro': 'Оберіть формат простору перед початком роботи.',
    'board.create.kanbanTitle': 'Канбан',
    'board.create.kanbanDescription': 'Можливість роботи як особисто, так і разом з командою.',
    'board.create.calendarTitle': 'Календар',
    'board.create.calendarDescription': 'Особистий зручний простір для роботи, відстеження звичок, статистики виконаних задач та багато іншого.',
    'board.empty.title': 'Створіть першу дошку',
    'board.empty.subtitle': 'Додайте дошку, щоб почати роботу.',
    'board.menu': 'Меню дошки',
    'board.menu.changeBackground': 'Змінити фон',
    'board.menu.members': 'Учасники',
    'board.menu.archived': 'Архівовані елементи',
    'board.menu.inviteTitle': 'Запросити',
    'board.account.title': 'Акаунт',
    'board.account.changeAccount': 'Змінити акаунт',
    'board.account.profile': 'Профіль',
    'board.account.settings': 'Налаштування',
    'board.account.backgrounds': 'Фони',
    'board.account.logout': 'Вийти',
    'board.filters': 'Фільтри',
    'board.select.title': 'Вибір дошки',
    'board.settings': 'Налаштування дошки',
    'board.error.loadDetails': 'Не вдалося завантажити деталі дошки.',
    'board.unarchive': 'Відновити дошку',
    'board.unarchiveConfirm': 'Відновити дошку?',
    'board.deleteConfirm': 'Видалити дошку?',
    'board.delete': 'Видалити дошку',
    'board.leave': 'Покинути дошку',
    'board.joining': 'Приєднання до дошки...',
    'board.background.title': 'Фон дошки',
    'board.background.upload': 'Завантажити зображення',
    'board.background.reset': 'Скинути',
    'board.background.apply': 'Застосувати',
    'board.background.urlPlaceholder': 'Вставте URL зображення...',
    'board.background.colorSelected': 'Обраний колір',
    'board.background.gradientSelected': 'Обраний градієнт',
    'board.background.imageSelected': 'Обране зображення',
    'board.background.invalidFile': 'Оберіть файл зображення.',
    'board.background.tooLarge': 'Файл завеликий (макс {size} МБ).',
    'board.background.uploadHint': 'PNG, JPG - до 5 МБ - мінімум 1920 на 1080',
    'board.background.colors': 'Кольори',
    'board.background.gradients': 'Градієнти',
    'board.background.images': 'Зображення',
    'board.background.default': 'За замовчуванням',
    'board.background.slate': 'Сланець',
    'board.background.charcoal': 'Вугілля',
    'board.background.indigo': 'Індиго',
    'board.background.emerald': 'Смарагд',
    'board.background.warmLight': 'Теплий світлий',
    'board.background.gradient.sunset': 'Захід',
    'board.background.gradient.ocean': 'Океан',
    'board.background.gradient.forest': 'Ліс',
    'board.background.gradient.blush': 'Румʼянець',
    'board.background.gradient.night': 'Ніч',
    'board.background.gradient.dawn': 'Світанок',
    'calendar.backToBoards': 'Повернутися до дошок',
    'calendar.kicker': 'Особистий календар',
    'calendar.title': 'Календар задач',
    'calendar.defaultTitle': 'Мій календар',
    'calendar.addCalendar': 'Додати календар',
    'calendar.addPersonalCalendar': 'Додати особистий календар',
    'calendar.addPersonalCalendarDescription': 'Один календар для вашого акаунта: перегляд задач на місяць, тиждень і день без змішування з командними дошками.',
    'calendar.previewTitle': 'Міні-перегляд календаря',
    'calendar.addTask': 'Додати задачу',
    'calendar.month': 'Місяць',
    'calendar.week': 'Тиждень',
    'calendar.day': 'День',
    'calendar.personalSpace': 'Особистий простір',
    'calendar.viewSwitcher': 'Перемикач вигляду календаря',
    'calendar.view.month': 'Місяць',
    'calendar.view.week': 'Тиждень',
    'calendar.view.day': 'День',
    'calendar.sidebarTitle': 'Робоча структура',
    'calendar.sidebarDescription': 'Тут будуть задачі, звички та статистика виконання. Логіку додамо на наступному етапі.',
    'calendar.stats.completed': 'виконаних задач',
    'calendar.stats.habits': 'звичок у трекінгу',
    'calendar.emptyTitle': 'Поки без задач',
    'calendar.emptyDescription': 'Календар готовий для майбутньої логіки задач, звичок і статистики.',
    'calendar.emptySlot': 'Вільно',
    'calendar.dayDetails': 'Опис задач дня',
    'calendar.dayDetailsEmpty': 'Після додавання логіки тут буде детальна інформація про задачі, час виконання, чеклисти та нотатки.',
    'calendar.task.create': 'Нова задача календаря',
    'calendar.task.edit': 'Редагування задачі',
    'calendar.task.add': 'Додати задачу',
    'calendar.task.title': 'Назва',
    'calendar.task.description': 'Опис',
    'calendar.task.duration': 'Час виконання: години та хвилини',
    'calendar.task.startAt': 'Почати роботу з',
    'calendar.task.deadline': 'Дедлайн',
    'calendar.task.repeat': 'Повторення',
    'calendar.task.repeatDetails': 'Час і день повторення',
    'calendar.task.repeatDay': 'День',
    'calendar.task.customRepeat': 'Налаштовуване повторення',
    'calendar.task.priority': 'Пріоритет',
    'calendar.task.headerColor': 'Колір шапки задачі',
    'calendar.task.labels': 'Мітки',
    'calendar.task.newLabelName': 'Назва мітки',
    'calendar.task.checklists': 'Чек-листи',
    'calendar.task.attachments': 'Вкладення',
    'calendar.task.addAttachment': 'Додати вкладення',
    'calendar.task.addFromBoard': 'Додати в календар',
    'calendar.task.errorTitle': 'Вкажіть назву задачі.',
    'calendar.task.errorDuration': 'Вкажіть час виконання.',
    'calendar.task.autoStartNotice': 'Час початку не вказано, тому задачу поставлено на найближчий вільний слот.',
    'calendar.task.collisionNotice': 'Обраний час зайнятий, тому задачу перенесено на найближчий вільний слот.',
    'calendar.task.noFutureOccurrences': 'Немає наступних запланованих задач для цієї серії.',
    'calendar.task.scopeSaveConfirm': 'Зберегти зміни для всіх наступних повторень? Натисніть "Скасувати", щоб змінити тільки поточну задачу.',
    'calendar.task.scopeDeleteConfirm': 'Видалити всі повторення цієї задачі? Натисніть "Скасувати", щоб видалити тільки поточну.',
    'calendar.task.deleteConfirm': 'Видалити задачу?',
    'calendar.task.saveCurrent': 'Зберегти поточну',
    'calendar.task.saveFuture': 'Зберегти всі наступні',
    'calendar.task.deleteCurrent': 'Видалити поточну',
    'calendar.task.deleteFuture': 'Видалити всі наступні',
    'calendar.task.resizeStart': 'Змінити початок задачі',
    'calendar.task.resizeEnd': 'Змінити кінець задачі',
    'calendar.task.overdue': 'Дедлайн прострочено',
    'calendar.task.markComplete': 'Позначити виконаною',
    'calendar.task.markIncomplete': 'Зняти позначку виконання',
    'calendar.task.more': '+{count} ще',
    'calendar.repeat.none': 'Без повторення',
    'calendar.repeat.daily': 'Кожного дня',
    'calendar.repeat.weekly': 'Кожного тижня',
    'calendar.repeat.monthly': 'Кожного місяця',
    'calendar.repeat.custom': 'Налаштувати',
    'calendar.priority.none': 'Без пріоритету',
    'calendar.priority.high': 'Високий',
    'calendar.priority.medium': 'Середній',
    'calendar.priority.low': 'Низький',
    'calendar.weekday.mon': 'Пн',
    'calendar.weekday.tue': 'Вт',
    'calendar.weekday.wed': 'Ср',
    'calendar.weekday.thu': 'Чт',
    'calendar.weekday.fri': 'Пт',
    'calendar.weekday.sat': 'Сб',
    'calendar.weekday.sun': 'Нд',
    'habits.open': 'Завдання на сьогодні',
    'habits.kicker': 'План дня',
    'habits.title': 'Завдання на сьогодні',
    'habits.add': 'Додати задачу',
    'habits.today': 'Сьогодні виконано',
    'habits.todayDescription': 'Показує тільки задачі, які реально заплановані на сьогодні.',
    'habits.emptyTitle': 'На сьогодні задач немає',
    'habits.emptyDescription': 'Задачі зʼявляться тут у той день, коли вони є в розкладі.',
    'habits.noDescription': 'Без опису',
    'habits.mark': 'Виконано сьогодні',
    'habits.unmark': 'Зняти відмітку',
    'habits.monthStats': 'Статистика місяця',
    'habits.monthStatsDescription': 'Виконання кожної звички за днями поточного місяця.',
    'help.title': 'Як ми можемо допомогти?',
    'help.subtitle': 'Знайдіть відповіді в ресурсах підтримки Boardly.',
    'help.featured.title': 'Рекомендований контент',
    'help.featured.item1': 'Що таке схеми прав доступу в Boardly?',
    'help.featured.item2': 'Керуйте доступом користувачів до застосунків',
    'help.featured.item3': 'Зміна email-адрес облікового запису',
    'help.featured.item4': 'Деактивувати керований акаунт',
    'help.featured.item5': 'Підтвердити домен для керування акаунтами',
    'help.featured.item6': 'Налаштувати SAML single sign-on з постачальником ідентичності',
    'help.featured.item7': 'Надати користувачам права адміністратора',
    'help.featured.item8': 'Розібратися з user provisioning',
    'help.featured.item9': 'IP-адреси та домени для хмарних застосунків Boardly',
    'help.resources.title': 'Переглянути ресурси',
    'help.resources.community.title': 'Спільнота',
    'help.resources.community.body': 'Знайдіть відповіді, підтримку й натхнення від інших користувачів Boardly.',
    'help.resources.community.link': 'Відвідати спільноту Boardly',
    'help.resources.status.title': 'Статус системи',
    'help.resources.status.body': 'Перевірте стан наших хмарних застосунків і сервісів.',
    'help.resources.status.link': 'Переглянути статус системи',
    'help.resources.suggestions.title': 'Пропозиції та баг-репорти',
    'help.resources.suggestions.body': 'Перегляньте існуючі пропозиції та звіти про баги.',
    'help.resources.suggestions.link': 'Переглянути пропозиції та баги',
    'help.resources.marketplace.title': 'Маркетплейс застосунків',
    'help.resources.marketplace.body': 'Знайдіть можливості для кастомізації ваших застосунків.',
    'help.resources.marketplace.link': 'Переглянути Marketplace',
    'help.resources.billing.title': 'Оплата та ліцензування',
    'help.resources.billing.body': 'Перегляньте FAQ про оплату та ліцензування.',
    'help.resources.billing.link': 'Переглянути FAQ',
    'help.resources.training.title': 'Навчання та сертифікація',
    'help.resources.training.body': 'Розвивайте навички, покращуйте роботу команди та карʼєру.',
    'help.resources.training.link': 'Переглянути навчання',
    'help.resources.developers.title': 'Розробникам',
    'help.resources.developers.body': 'API-документація та гіди для розробки застосунків і інтеграцій.',
    'help.resources.developers.link': 'Переглянути документацію для розробників',
    'help.resources.enterprise.title': 'Enterprise',
    'help.resources.enterprise.body': 'Дізнайтесь про Boardly Enterprise та продукти Data Center.',
    'help.resources.enterprise.link': 'Переглянути документацію Enterprise',
    'help.resources.government.title': 'Підтримка Government Cloud',
    'help.resources.government.body': 'Технічна та міграційна підтримка для Government-проєктів Boardly.',
    'help.resources.government.link': 'Увійти, щоб звернутися до підтримки',
    'help.resources.success.title': 'Центр успіху',
    'help.resources.success.body': 'Матеріали для впровадження від Boardly та партнерів.',
    'help.resources.success.link': 'Переглянути Центр успіху',
    'help.contact.title': 'Не знаходите потрібну допомогу?',
    'help.contact.button': 'Звʼязатися з підтримкою',
    'help.footer.copyright': 'Copyright © 2026 Boardly',
    'help.footer.accessibility': 'Доступність',
    'help.footer.privacyChoices': 'Ваші налаштування приватності',
    'help.footer.privacyPolicy': 'Політика конфіденційності',
    'help.footer.terms': 'Умови',
    'help.footer.impressum': 'Impressum',
    'help.footer.security': 'Безпека',
    'community.title': 'Створюйте найкраще робоче життя разом',
    'community.subtitle': 'Навчайтесь, спілкуйтесь і зростайте зі спільнотою Boardly.',
    'community.getStarted.title': 'Почнімо',
    'community.getStarted.link': 'Знайти відповіді',
    'community.getStarted.forums.title': 'Форуми',
    'community.getStarted.forums.body': 'Ставте питання та отримуйте допомогу від експертів і колег.',
    'community.getStarted.learning.title': 'Навчання',
    'community.getStarted.learning.body': 'Гайди, туторіали та найкращі практики.',
    'community.getStarted.events.title': 'Події',
    'community.getStarted.events.body': 'Приєднуйтесь до сесій і знайомтеся зі спільнотою наживо.',
    'community.getStarted.champions.title': 'Чемпіони',
    'community.getStarted.champions.body': 'Звʼязок із досвідченими користувачами та амбасадорами.',
    'community.advice.title': 'Отримайте поради та звʼязок',
    'community.advice.body': 'Форуми спільноти — чудове місце, щоб отримати відповіді від експертів і колег. Знаходьте рішення або ставте власні запитання.',
    'community.back': 'Назад',
    'community.kicker.forums': 'Форуми спільноти',
    'community.learning.title': 'Розвивайте навички з гнучким навчанням',
    'community.learning.body': 'Наші безкоштовні курси on-demand допомагають опановувати застосунки Atlassian і працювати швидше. Розвивайтесь разом з instructor-led навчанням і сертифікаціями Atlassian.',
    'community.learning.longBody': 'Формуйте глибоку експертизу у вашій команді завдяки структурованим матеріалам, покроковим практикам і реальним прикладам. Навчальні треки охоплюють як базові, так і просунуті сценарії, щоб ви могли швидко застосовувати знання в щоденній роботі. Поглиблюйте навички, оптимізуйте процеси та досягайте стабільних результатів у продуктивності.',
    'community.redesign.hero.title': 'Організуйте завдання та вирішуйте їх звідусіль.',
    'community.redesign.hero.subtitle': 'Організуйте проєкти, підвищуйте продуктивність і працюйте ще ефективніше з нашим застосунком.',
    'community.redesign.hero.cta': 'Зареєструватись безкоштовно!',
    'community.redesign.preview.todo.title': 'До виконання',
    'community.redesign.preview.todo.task1': 'Дизайн сторінки входу',
    'community.redesign.preview.todo.task2': 'Створити робочу дошку',
    'community.redesign.preview.todo.task3': 'Налаштувати сповіщення',
    'community.redesign.preview.progress.title': 'У процесі',
    'community.redesign.preview.progress.task': 'Реалізувати drag & drop',
    'community.redesign.preview.done.title': 'Готово',
    'community.redesign.basicFunctions': 'Базові функції',
    'community.redesign.sources.title': 'Джерела продуктивності',
    'community.redesign.sources.subtitle': 'Працюйте ефективніше з дошками, картами та автоматизацією, навіть у дорозі.',
    'community.redesign.sources.imageAlt': 'Попередній перегляд дошки з задачами',
    'community.redesign.moveTasks.title': 'Рухайте задачі',
    'community.redesign.moveTasks.body': 'Легко переміщуйте задачі за допомогою drag & drop.',
    'community.redesign.actions.heading': 'Від повідомлень до дій',
    'community.redesign.actions.subtitle': 'Збирайте важливі сповіщення в одному місці та перетворюйте їх на продуктивні задачі.',
    'community.redesign.actions.messages.title': 'Ваші повідомлення зі Slack',
    'community.redesign.actions.messages.body': 'Швидко перетворюйте повідомлення на задачі.',
    'community.redesign.actions.automation.title': 'Використовуйте автоматизацію',
    'community.redesign.actions.automation.body': 'Автоматизуйте задачі за допомогою розумних рекомендацій.',
    'community.redesign.actions.communicate.title': 'Оперативна комунікація',
    'community.redesign.actions.communicate.body': 'Спілкуйтеся з командою в реальному часі.',
    'community.redesign.more.heading': 'Робіть більше з Boardly',
    'community.redesign.more.subtitle': 'Налаштовуйте застосунок під себе через інтеграції, автоматизацію та гнучкі робочі процеси.',
    'community.redesign.more.integrations.title': 'Інтеграції',
    'community.redesign.more.integrations.body': 'Підключайте улюблені інструменти.',
    'community.redesign.more.automation.title': 'Автоматизація',
    'community.redesign.more.automation.body': 'Налаштовуйте автоматичні дії.',
    'community.redesign.more.customization.title': 'Кастомізація',
    'community.redesign.more.customization.body': 'Підлаштовуйте дошки під свої задачі.',
    'community.redesign.more.mobile.title': 'Мобільність',
    'community.redesign.more.mobile.body': 'Працюйте будь-де в одному застосунку.',
    'community.redesign.signup.title': 'Почніть з Boardly вже сьогодні',
    'community.redesign.signup.note': 'Вводячи email, я приймаю умови та',
    'community.redesign.signup.privacy': 'Політику конфіденційності',
    'toolbar.searchPlaceholder': 'Пошук по дошці',
    'toolbar.actions': 'Дії дошки',
    'toolbar.matches': 'збігів',
    'toolbar.noMatches': 'Нічого не знайдено',
    'filters.title': 'Фільтри',
    'filters.membersLabel': 'Учасники',
    'filters.membersAll': 'Всі учасники',
    'filters.labelsLabel': 'Мітки',
    'filters.labelsAll': 'Всі мітки',
    'filters.dueLabel': 'Дедлайн',
    'filters.dueAny': 'Будь-який дедлайн',
    'filters.dueOverdue': 'Прострочені',
    'filters.dueToday': 'На сьогодні',
    'filters.dueWeek': 'На тиждень',
    'filters.dueNone': 'Без дедлайну',
    'filters.completedLabel': 'Статус',
    'filters.completedAll': 'Всі',
    'filters.completedOnly': 'Завершені',
    'filters.incompleteOnly': 'Незавершені',
    'filters.reset': 'Скинути',
    'filters.apply': 'Застосувати',
    'archive.cards': 'Архівні картки',
    'archive.lists': 'Архівні списки',
    'archive.showCards': 'Показати архівні картки',
    'archive.hideCards': 'Приховати архівні картки',
    'archive.showLists': 'Показати архівні списки',
    'archive.hideLists': 'Приховати архівні списки',
    'archive.badge': 'Архів',
    'list.addButton': '+ Додати список',
    'list.create.placeholder': 'Назва списку',
    'list.create.submit': 'Створити список',
    'list.empty.noneTitle': 'Немає списків',
    'list.empty.noneSubtitle': 'Створіть перший список, щоб додавати картки.',
    'list.empty.archivedTitle': 'Списки в архіві',
    'list.empty.archivedSubtitle': 'Увімкніть показ архівів, щоб їх побачити.',
    'list.empty.showArchived': 'Показати архівні списки',
    'list.menu': 'Меню списку',
    'list.menu.addCard': 'Додати картку',
    'list.menu.move': 'Переміщення списку',
    'list.menu.moveAll': 'Перемістити всі картки',
    'list.menu.sort': 'Сортувати за...',
    'list.menu.subscribe': 'Підписатися',
    'list.menu.unsubscribe': 'Відписатися',
    'list.menu.movePrompt': 'Введіть нову позицію списку',
    'list.menu.moveAllPrompt': 'Вкажіть ID списку, куди перемістити всі картки',
    'list.menu.sortPrompt': 'Оберіть сортування',
    'list.menu.sortByDue': 'За дедлайном',
    'list.menu.sortByTitle': 'За назвою',
    'list.menu.comingSoon': 'Скоро буде доступно',
    'list.menu.automation': 'Автоматизація',
    'list.menu.automationAdd': 'Коли картку додано в список...',
    'list.menu.automationDaily': 'Щодня, сортувати за...',
    'list.menu.automationRule': 'Створити правило',
    'list.menu.archiveAllCards': 'Архівувати всі картки у списку',
    'list.menu.devCanAddCards': 'Девелопер може додавати картки',
    'list.menu.devCannotAddCards': 'Девелопер не може додавати картки',
    'list.rename': 'Перейменувати',
    'list.copy': 'Копіювати список',
    'list.archive': 'Архівувати список',
    'list.unarchive': 'Відновити список',
    'list.color.title': 'Змінити колір',
    'list.color.none': 'Без кольору',
    'list.collapse': 'Згорнути',
    'list.moveLeft': 'Перемістити ліворуч',
    'list.moveRight': 'Перемістити праворуч',
    'list.position': 'Позиція',
    'list.archiveConfirm': 'Архівувати список?',
    'list.archiveAllCardsConfirm': 'Архівувати всі картки у цьому списку?',
    'list.unarchiveConfirm': 'Відновити список?',
    'card.create.newButton': '+ Нова задача',
    'card.create.placeholder': 'Назва задачі...',
    'card.descriptionPlaceholder': 'Додайте опис',
    'card.descriptionTitle': 'Опис',
    'card.descriptionEmpty': 'Опис відсутній.',
    'card.dueDate': 'Дедлайн',
    'card.dueDateRemove': 'Видалити дедлайн',
    'card.dueDatePreview': 'Обрано: {date}',
    'card.dueDateRequired': 'Оберіть дату дедлайну',
    'card.empty': 'Немає карток',
    'card.menu': 'Меню картки',
    'card.menu.move': 'Переміщення',
    'card.menu.copy': 'Копіювання',
    'card.menu.share': 'Поділитися',
    'card.menu.mirror': 'Дзеркало',
    'card.menu.template': 'Створити шаблон',
    'card.menu.subscribe': 'Підписатися',
    'card.menu.copyLinkPrompt': 'Скопіюйте посилання вручну',
    'card.menu.archive': 'Архівація',
    'card.menu.delete': 'Видалити',
    'card.move.title': 'Переміщення картки',
    'card.move.list': 'Список',
    'card.move.position': 'Позиція',
    'card.move.button': 'Перемістити',
    'card.moveToList': 'Перемістити в список',
    'card.copy': 'Копіювати картку',
    'card.archive': 'Архівувати',
    'card.unarchive': 'Відновити',
    'card.inList': 'У списку',
    'card.members': 'Виконавці',
    'card.completedBadge': 'ВИКОНАНО',
    'card.complete': 'Позначити як виконану',
    'card.uncomplete': 'Позначити як невиконану',
    'card.private': 'Приватна картка',
    'card.overdue.days': '(Прострочено на {count} дн.)',
    'card.overdue.hours': '(Прострочено на {count} год.)',
    'card.overdue.minutes': '(Прострочено на {count} хв.)',
    'card.moveUp': 'Перемістити вгору',
    'card.moveDown': 'Перемістити вниз',
    'card.moveLeft': 'Перемістити ліворуч',
    'card.moveRight': 'Перемістити праворуч',
    'card.sidebar.participation': 'Участь',
    'card.sidebar.join': 'Приєднатися',
    'card.sidebar.leave': 'Покинути',
    'card.joinError': 'Не вдалося приєднатися',
    'card.sidebar.add': 'Додати',
    'card.sidebar.actions': 'Дії',
    'card.cover.title': 'Обкладинка',
    'card.cover.remove': 'Прибрати обкладинку',
    'card.colorTitle': 'Колір картки',
    'card.colorHint': 'Оберіть колір або скиньте до стандартного.',
    'card.color.none': 'Без кольору',
    'card.color.sun': 'Сонце',
    'card.color.rose': 'Рожевий',
    'card.color.sky': 'Небо',
    'card.color.violet': 'Фіолетовий',
    'card.color.emerald': 'Смарагд',
    'card.color.teal': 'Бірюза',
    'card.color.slate': 'Сланець',
    'card.quick.add': 'Додати',
    'card.quick.addHint': 'Додайте через праву панель',
    'card.quick.dates': 'Дати',
    'card.quick.checklist': 'Чек-лист',
    'card.quick.attach': 'Вкладення',
    'card.quick.members': 'Учасники',
    'card.quick.comingSoon': 'Скоро буде доступно',
    'card.watch': 'Стежити',
    'card.add.title': 'Додати до картки',
    'card.add.labels': 'Мітки',
    'card.add.labelsHint': 'Прокрутіть до міток нижче',
    'card.add.dates': 'Дати',
    'card.add.checklist': 'Чек-лист',
    'card.add.members': 'Учасники',
    'card.add.attachments': 'Вкладення',
    'card.cover.size': 'Розмір',
    'card.cover.size.full': 'Повна',
    'card.cover.size.header': 'Шапка',
    'card.cover.colors': 'Кольори',
    'card.cover.colorblind': 'Увімкнути режим дальтонізму',
    'card.cover.colorblind.enable': 'Увімкнути режим дальтонізму',
    'card.cover.colorblind.disable': 'Вимкнути режим дальтонізму',
    'checklist.title': 'Чек-лист',
    'checklist.titlePlaceholder': 'Назва чек-листа',
    'checklist.itemPlaceholder': 'Нова підзадача',
    'checklist.addItem': 'Додати елемент',
    'checklist.add': 'Додати чек-лист',
    'checklist.hint': 'Чек-лист зберігається одразу після додавання пунктів.',
    'checklist.empty': 'Чек-лист ще не створено.',
    'checklist.deleteConfirm': 'Видалити цей чек-лист?',
    'checklist.hideCompleted': 'Сховати відмічені пункти',
    'checklist.showCompleted': 'Показати відмічені пункти',
    'checklist.hiddenDoneOnly': 'Усі виконані пункти приховано.',
    'checklist.copy.title': 'Копіювати підзадачі',
    'checklist.copy.selectCard': 'Оберіть картку',
    'checklist.createPopoverTitle': 'Додати список',
    'checklist.nameLabel': 'Назва',
    'checklist.copy.fromLabel': 'Копіювати елемент з...',
    'checklist.copy.none': 'Відсутній',
    'checklist.copy.emptySource': 'У вибраній картці немає підзадач для копіювання.',
    'checklist.copy.append': 'Додати в кінець',
    'checklist.copy.replace': 'Замінити всі',
    'attachments.title': 'Вкладення',
    'attachments.empty': 'Поки немає вкладень.',
    'attachments.add': 'Додати файл',
    'comments.title': 'Коментарі',
    'comments.activityTitle': 'Коментарі і події',
    'comments.showDetails': 'Показати подробиці',
    'comments.hideDetails': 'Сховати подробиці',
    'comments.empty': 'Поки що немає коментарів.',
    'comments.add': 'Додати коментар',
    'comments.answer': 'Відповісти',
    'comments.send': 'Надіслати',
    'comments.react': 'Реакція',
    'comments.addReaction': 'Додати реакцію',
    'comments.reactionPicker': 'Вибір емодзі',
    'comment.placeholder': 'Напишіть коментар...',
    'labels.title': 'Мітки',
    'labels.empty': 'Ще немає міток.',
    'labels.newPlaceholder': 'Нова мітка',
    'labels.add': 'Додати мітку',
    'labels.newPrompt': 'Назва нової мітки:',
    'labels.deleteConfirm': 'Видалити цю мітку? Вона зникне з усіх карток.',
    'labels.hint': 'Мітки зберігаються після натискання кнопки {action}.',
    'members.title': 'Учасники',
    'members.modalTitle': 'Учасники дошки',
    'members.inviteTitle': 'Запросити',
    'members.searchPlaceholder': "Ім'я, нік або email",
    'members.addListTitle': 'Додати список',
    'members.searchParticipants': 'Пошук учасників',
    'members.boardMembersTitle': 'Учасники дошки',
    'members.searching': 'Пошук...',
    'members.refreshing': 'Оновлюємо список учасників...',
    'members.empty': 'Нікого не знайдено.',
    'members.inviteEmail': 'Запросити по email',
    'members.adding': 'Додаємо...',
    'members.removing': 'Видалення...',
    'members.roleOwner': 'Власник',
    'members.roleAdmin': 'Адмін',
    'members.roleMember': 'Учасник',
    'members.roleDeveloper': 'Розробник',
    'members.roleViewer': 'Глядач',
    'members.roleLabel': 'Роль',
    'members.permissionsHint': 'Додавати учасників можуть лише власник або адмін.',
    'members.viewerCannotBeAssigned': 'Глядачів не можна призначати на картки.',
    'members.shareAria': 'Поділитися',
    'members.more': 'Ще {count}',
    'members.viewActivity': 'Подивитись дії на дошці',
    'members.makeAdmin': 'Зробити адміністратором',
    'members.removeAdmin': 'Зняти адміністратора',
    'members.removeFromBoard': 'Видалити з дошки',
    'members.workspaceParticipants': 'Учасники робочого простору',
    'members.guests': 'Гості',
    'members.activityTitle': 'Дії користувача: {name}',
    'members.activityEmpty': 'Немає дій на цій дошці.',
    'permissions.title': 'Права розробника',
    'permissions.devCreateCards': 'Розробник може створювати картки',
    'permissions.devEditAssigned': 'Розробник може редагувати призначені картки',
    'permissions.devArchiveAssigned': 'Розробник може архівувати призначені картки',
    'permissions.devJoinCard': 'Розробник може приєднуватися до чужих карток',
    'permissions.devCreateLists': 'Розробник може створювати списки',
    'hotkeys.hint': 'Гарячі клавіші: Ctrl+K',
    'hotkeys.aria': 'Гарячі клавіші',
    'command.title': 'Команди',
    'command.placeholder': 'Пошук команд',
    'command.empty': 'Нічого не знайдено',
    'command.createCard': 'Створити картку',
    'command.createList': 'Створити список',
    'command.createBoard': 'Створити дошку',
    'command.goProfile': 'Перейти в профіль',
    'command.goMyCards': 'Перейти в мої картки',
    'command.goFaq': 'Відкрити FAQ',
    'myCards.title': 'Мої картки',
    'myCards.loading': 'Завантажуємо картки...',
    'myCards.loadError': 'Не вдалося завантажити картки.',
    'myCards.emptyAssigned': 'Поки що немає призначених карток.',
    'myCards.emptyList': 'Немає карток для показу.',
    'myCards.boardFallback': 'Без назви',
    'myCards.boardUnavailable': 'Дошка недоступна.',
    'myCards.boardArchived': 'Дошка в архіві',
    'landing.nav.sections': 'Навігація секціями лендингу',
    'landing.nav.goTo': 'Перейти до секції {number}',
    'landing.nav.product': 'Навігація продуктом',
    'landing.nav.problems': 'Проблеми',
    'landing.nav.workflow': 'Як працює',
    'landing.eyebrow': 'Одна система для дошок, календаря і задач',
    'landing.hero.line1': 'Плануйте роботу',
    'landing.hero.line2': 'без хаосу',
    'landing.hero.line3': 'між дошками й календарем.',
    'landing.hero.description': 'Boardly допомагає тримати командні задачі, особисті дедлайни, звички, чек-листи, мітки й вкладення в одному зрозумілому просторі.',
    'landing.cta.note': 'Стартуйте з дошки або особистого календаря.',
    'landing.mock.title': 'Робочий простір',
    'landing.mock.kanban': 'Kanban-дошка',
    'landing.mock.calendar': 'Календар',
    'landing.mock.focus': 'Фокус-задача',
    'landing.mock.focusNote': 'зайнято у дні',
    'landing.problem.kicker': 'Навіщо це потрібно',
    'landing.problem.heading': 'Boardly прибирає типові провали в організації роботи.',
    'landing.problem.subtitle': 'Коли задачі живуть у різних місцях, дедлайни губляться, а команді складно зрозуміти реальний стан роботи.',
    'landing.problem.scattered.title': 'Задачі розкидані',
    'landing.problem.scattered.body': 'Дошки, особисті плани, вкладення й чек-листи часто зберігаються окремо. Boardly збирає їх у єдину структуру.',
    'landing.problem.deadlines.title': 'Дедлайни не видно',
    'landing.problem.deadlines.body': 'Картка може бути важливою, але без календаря складно оцінити, коли саме її виконувати і скільки часу вона займе.',
    'landing.problem.team.title': 'Командна робота змішується з особистою',
    'landing.problem.team.body': 'Kanban підходить для команди, календар — для особистого фокусу. Boardly розділяє ці сценарії, але залишає їх поруч.',
    'landing.solution.kicker': 'Рішення',
    'landing.solution.heading': 'Дошки для команд, календар для фокусу, задачі з повним контекстом.',
    'landing.solution.subtitle': 'Система побудована навколо реального процесу: створити задачу, уточнити деталі, поставити в час, виконати й відстежити результат.',
    'landing.solution.kanban.title': 'Kanban для процесу',
    'landing.solution.kanban.body': 'Створюйте дошки, списки й картки для особистої або командної роботи.',
    'landing.solution.calendar.title': 'Календар для часу',
    'landing.solution.calendar.body': 'Плануйте день, тиждень і місяць, бачте тривалість задач і вільні слоти.',
    'landing.solution.tasks.title': 'Задача з деталями',
    'landing.solution.tasks.body': 'Назва, опис, дедлайн, старт, пріоритет, мітки, чек-листи й вкладення залишаються в одному місці.',
    'landing.solution.focus.title': 'Особистий контроль',
    'landing.solution.focus.body': 'Відстежуйте звички, повторювані задачі й виконання без змішування з командними дошками.',
    'landing.workflow.kicker': 'Логіка роботи',
    'landing.workflow.heading': 'Від ідеї до виконання — без втрати контексту.',
    'landing.workflow.plan': 'Зафіксуйте задачу на дошці або одразу в календарі.',
    'landing.workflow.schedule': 'Оберіть дату, час початку, тривалість і дедлайн.',
    'landing.workflow.execute': 'Працюйте з чек-листами, мітками, пріоритетом і вкладеннями.',
    'landing.workflow.review': 'Переглядайте день, тиждень або місяць і контролюйте виконання.',
    'landing.signup.title': 'Створіть простір, де задачі не губляться.',
    'landing.signup.subtitle': 'Почніть з Kanban-дошки для команди або з особистого календаря для власного ритму.',
    'landing.cta.openApp': 'Перейти до роботи',
    'landing.cta.signUp': 'Зареєструватися безкоштовно!',
    'faq.title': 'FAQ',
    'faq.q1': 'Як створити нову дошку?',
    'faq.a1': 'Натисніть "+ Нова дошка" на сторінці борду.',
    'faq.q2': 'Як додати список?',
    'faq.a2': 'Натисніть "+ Додати список" на панелі борду.',
    'faq.q3': 'Як запросити учасників?',
    'faq.a3': 'Відкрийте Поділитися та додайте людей за імʼям або email.',
    'faq.q4': 'Де знайти мої картки?',
    'faq.a4': 'Перейдіть у розділ Мої картки у верхньому меню.',
    'profile.tabsLabel': 'Розділи профілю',
    'profile.tabs.profile': 'Профіль',
    'profile.tabs.activity': 'Активність',
    'profile.tabs.settings': 'Налаштування',
    'profile.authRequiredTitle': 'Потрібна авторизація',
    'profile.authRequiredHint': 'Увійдіть, щоб переглядати профіль.',
    'profile.avatarAlt': 'Аватар користувача',
    'profile.avatar.change': 'Змінити аватар',
    'profile.avatar.remove': 'Видалити аватар',
    'profile.sections.profile': 'Профіль',
    'profile.sections.activity': 'Активність',
    'profile.sections.settings': 'Налаштування',
    'profile.settings.subtitle': 'Керуйте налаштуваннями акаунта',
    'profile.activity.subtitle': 'Відстежуйте активність на ваших дошках',
    'profile.settings.general': 'Загальні',
    'profile.settings.language': 'Мова',
    'profile.settings.clearCache': 'Очистити кеш',
    'profile.settings.cacheDescription': 'Видаляє кеш та тимчасові дані сайту',
    'profile.settings.notifications': 'Сповіщення',
    'profile.settings.desktopNotifications': 'Gmail сповіщення',
    'profile.settings.assignedToTask': 'Призначено на задачу',
    'profile.settings.dueDateApproaching': 'Наближається термін',
    'profile.settings.addedToBoard': 'Додано на дошку',
    'profile.settings.manageEmail': 'Керувати email-налаштуваннями',
    'profile.settings.appearance': 'Вигляд',
    'profile.settings.theme': 'Тема',
    'profile.settings.dark': 'Темна',
    'profile.settings.light': 'Світла',
    'profile.settings.defaultBoardView': 'Вид дошки за замовчуванням',
    'profile.settings.kanban': 'Канбан',
    'profile.settings.calendar': 'Календар',
    'profile.settings.manageIntegrations': 'Керувати інтеграціями',
    'profile.settings.security': 'Безпека',
    'profile.settings.twoFactor': 'Двофакторна автентифікація',
    'profile.settings.requireVerification': 'Потрібна перевірка входу',
    'profile.settings.additionalVerification': 'Додаткова email-перевірка для нових входів',
    'profile.settings.sessionTimeout': 'Тайм-аут сесії',
    'profile.settings.sessionTimeout1h': 'Після 1 години неактивності',
    'profile.settings.saveChanges': 'Зберегти зміни',
    'profile.settings.cacheCleared': 'Кеш очищено',
    'profile.settings.comingSoon': 'Скоро буде доступно',
    'profile.emailPrefs.title': 'Email-налаштування',
    'profile.emailPrefs.subtitle': 'Оберіть, які листи ви хочете отримувати',
    'profile.emailPrefs.enableEmail': 'Email-сповіщення',
    'profile.emailPrefs.assignedToTask': 'Призначено на задачу',
    'profile.emailPrefs.dueDateApproaching': 'Наближається термін',
    'profile.emailPrefs.addedToBoard': 'Додано на дошку',
    'profile.integrations.title': 'Інтеграції',
    'profile.integrations.subtitle': 'Підключіть сервіси для роботи з Boardly',
    'profile.integrations.connect': 'Підключити',
    'profile.integrations.slack': 'Сповіщення у Slack та швидкі дії',
    'profile.integrations.calendar': 'Синхронізація дедлайнів з календарем',
    'profile.integrations.github': 'Звʼязок задач із репозиторіями',
    'profile.fields.firstName': "Ім'я",
    'profile.fields.lastName': 'Прізвище',
    'profile.fields.organization': 'Організація',
    'profile.fields.nickname': 'Нікнейм',
    'profile.fields.theme': 'Тема',
    'profile.fields.themeToggle': 'Перемикач теми',
    'profile.fields.language': 'Мова',
    'profile.fields.emailNotifications': 'Email-сповіщення',
    'profile.notifications.on': 'Увімкнено',
    'profile.notifications.off': 'Вимкнено',
    'profile.theme.dark': 'Темна',
    'profile.theme.light': 'Світла',
    'profile.saveSettings': 'Зберегти налаштування',
    'profile.saving': 'Збереження...',
    'profile.activity.empty': 'Наразі активності немає.',
    'profile.activity.loadMore': 'Завантажити ще',
    'profile.activity.type': 'Тип: {type}',
    'profile.logoutAll': 'Вийти з усіх пристроїв',
    'profile.logoutAllHint': 'Функція в розробці',
    'profile.errors.requiredName': "Ім'я та прізвище обовʼязкові.",
    'profile.errors.saveFailed': 'Не вдалося зберегти профіль.',
    'profile.errors.imageOnly': 'Підтримуються лише зображення.',
    'profile.errors.avatarUploadFailed': 'Не вдалося завантажити аватар.',
    'profile.errors.avatarRemoveFailed': 'Не вдалося видалити аватар.',
    'profile.errors.activityLoad': 'Не вдалося завантажити активність.',
    'profile.toast.saved': 'Профіль збережено',
    'profile.toast.avatarUpdated': 'Аватар оновлено',
    'profile.toast.avatarRemoved': 'Аватар видалено',
    'profile.time.justNow': 'щойно',
    'profile.time.minutesAgo': '{count} хв тому',
    'profile.time.hoursAgo': '{count} год тому',
    'profile.time.daysAgo': '{count} дн тому',
    'profile.tabs.privacy': 'Політика конфіденційності',
    'profile.backToMain': 'Назад на головну',
    'profile.header.title': 'Налаштування профілю',
    'profile.header.subtitle': 'Керуйте особистою інформацією',
    'profile.privacy.title': 'Політика конфіденційності профілю',
    'profile.privacy.subtitle': 'Захищайте свої персональні дані',
    'profile.section.personalInfo': 'Особиста інформація',
    'profile.section.passwordChange': 'Зміна паролю',
    'profile.section.workInfo': 'Інформація про роботу',
    'profile.section.access': 'Доступ',
    'profile.fields.email': 'Email',
    'profile.fields.currentPassword': 'Поточний пароль',
    'profile.fields.bio': 'Про себе',
    'profile.fields.public': 'Публічно',
    'profile.placeholders.organization': 'Роль / Компанія',
    'profile.placeholders.bio': 'Розкажіть про себе',
    'profile.actions.changePassword': 'Змінити пароль',
    'profile.actions.deactivate': 'Деактивувати акаунт',
    'profile.userFallback': 'Користувач',
    'profile.confirmDelete': 'Ви впевнені, що хочете видалити акаунт? Цю дію неможливо скасувати.',
    'profile.deactivate.title': '!УВАГА!',
    'profile.deactivate.message': 'Цю дію неможливо скасувати. Ви впевнені, що хочете деактивувати акаунт?',
    'profile.deactivate.confirm': 'Деактивувати',
    'profile.deactivate.close': 'Закрити',
    'activity.context.onBoard': 'на дошці {board}',
    'activity.context.toList': 'до {list}',
    'activity.context.fromList': 'з {list}',
    'activity.context.inList': 'у {list}',
    'activity.context.inChecklist': 'у чек-листі {checklist}',
    'activity.context.onCard': 'на картці {card}',
    'activity.noDate': 'без дати',
    'activity.create_board': '{actor} створив(ла) дошку {board}',
    'activity.rename_board': '{actor} перейменував(ла) дошку {board}',
    'activity.update_board': '{actor} оновив(ла) дошку {board}',
    'activity.archive_board': '{actor} архівував(ла) дошку {board}',
    'activity.unarchive_board': '{actor} відновив(ла) дошку {board}',
    'activity.create_list': '{actor} додав(ла) список {list}{context}',
    'activity.rename_list': '{actor} перейменував(ла) список {list}',
    'activity.move_list': '{actor} переніс(ла) список {list}{context}',
    'activity.archive_list': '{actor} архівував(ла) список {list}',
    'activity.unarchive_list': '{actor} відновив(ла) список {list}',
    'activity.copy_list': '{actor} скопіював(ла) список {source} → {target}',
    'activity.create_card': '{actor} додав(ла) картку {card}{context}',
    'activity.move_card': '{actor} переніс(ла) картку {card}{from}{to}',
    'activity.archive_card': '{actor} архівував(ла) картку {card}{context}',
    'activity.unarchive_card': '{actor} відновив(ла) картку {card}{context}',
    'activity.update_card': '{actor} оновив(ла) картку {card}',
    'activity.update_card_description': '{actor} оновив(ла) опис картки {card}',
    'activity.update_card_due_date': '{actor} змінив(ла) дедлайн картки {card} з {before} на {after}',
    'activity.copy_card': '{actor} скопіював(ла) картку {source} → {target}',
    'activity.complete_card': 'Учасник {actor} позначив цю картку як завершену',
    'activity.uncomplete_card': 'Учасник {actor} зняв позначку завершення з цієї картки',
    'activity.checklist.unchecked': '{actor} позначив(ла) як не зроблене {item}{checklist}{card}',
    'activity.checklist.checked': '{actor} позначив(ла) як зроблене {item}{checklist}{card}',
    'activity.add_checklist_item': '{actor} додав(ла) підзадачу {item}{checklist}{card}',
    'activity.update_checklist_item': '{actor} відредагував(ла) підзадачу {item}{checklist}{card}',
    'activity.add_comment': '{actor} залишив(ла) коментар {comment}{card}',
    'activity.labels.added': 'додав(ла) мітки: {labels}',
    'activity.labels.removed': 'видалив(ла) мітки: {labels}',
    'activity.labels.updated': 'оновив(ла) мітки',
    'activity.update_card_labels': '{actor} {changes} для картки {card}',
    'activity.create_label': '{actor} створив(ла) мітку {label}{context}',
    'activity.update_label': '{actor} оновив(ла) мітку {label}{context}',
    'activity.delete_label': '{actor} видалив(ла) мітку {label}{context}',
    'activity.update_profile': '{actor} оновив(ла) профіль',
    'activity.update_avatar': '{actor} оновив(ла) аватар',
    'activity.remove_avatar': '{actor} видалив(ла) аватар',
    'activity.default': '{actor} виконав(ла) дію {target}',
    'privacy.summaryTitle': 'Ця політика конфіденційності допоможе вам зрозуміти:',
    'privacy.body.p1': 'Ваша приватність важлива для нас. Ця політика конфіденційності пояснює, як Boardly та наші корпоративні афілійовані компанії збирають, використовують, передають і захищають вашу інформацію, коли ви користуєтесь нашими продуктами, сервісами, вебсайтами або іншим чином взаємодієте з нами (перелік корпоративних афілійованих компаній Atlassian наведено в розділі List of Subsidiaries у найновішій формі 10-K Atlassian, доступній у вкладці SEC Filings після вибору фільтра “Annual Filings” на відповідній сторінці). Ми пропонуємо широкий спектр продуктів, включно з нашими хмарними та програмними рішеннями. У цій політиці ми називаємо всі ці продукти разом з іншими сервісами та вебсайтами «Сервісами».',
    'privacy.body.p2': 'Ця політика конфіденційності також пояснює ваш вибір щодо того, як ми використовуємо інформацію про вас, зокрема як ви можете заперечити проти певних способів використання інформації про вас і як отримати доступ до певної інформації про вас та оновити її. Якщо ви не погоджуєтеся з цією політикою конфіденційності, не отримуйте доступ і не використовуйте наші Сервіси та не взаємодійте з будь-яким іншим аспектом нашого бізнесу.',
    'privacy.footer.accessibility': 'Доступність',
    'privacy.footer.choices': 'Ваш вибір конфіденційності',
    'privacy.footer.policy': 'Політика конфіденційності',
    'privacy.footer.terms': 'Умови',
    'privacy.footer.data': 'Вихідні дані',
    'privacy.footer.security': 'Безпека',
    'errors.boardUpdate': 'Помилка оновлення дошки: {message}',
    'errors.listsLoad': 'Помилка списків: {message}',
    'errors.cardsLoad': 'Помилка карток: {message}',
    'confirm.deleteCard': 'Видалити задачу?',
    'prompt.copyLink': 'Скопіюйте посилання:',
    'toast.membersUpdateFailed': 'Не вдалося оновити учасників.',
    'toast.cardsReloadFailed': 'Не вдалося оновити картки.',
    'toast.joinFailed': 'Не вдалося приєднатися до дошки.',
    'toast.checklistSaveFailed': 'Не вдалося зберегти чек-лист.',
    'toast.checklistDeleteFailed': 'Не вдалося видалити чек-лист.',
    'toast.checklistItemAddFailed': 'Не вдалося додати пункт чек-листа.',
    'toast.labelCreateFailed': 'Не вдалося створити мітку.',
    'toast.commentAddFailed': 'Не вдалося додати коментар.',
    'toast.commentDeleteFailed': 'Не вдалося видалити коментар.',
    'toast.attachmentAdded': 'Вкладення додано',
    'toast.attachmentAddFailed': 'Не вдалося додати вкладення.',
    'toast.attachmentDeleteFailed': 'Не вдалося видалити вкладення.',
    'toast.memberAddFailed': 'Не вдалося додати учасника.',
    'toast.memberRoleFailed': 'Не вдалося змінити роль.',
    'toast.memberRemoveFailed': 'Не вдалося видалити учасника.',
    'toast.inviteUnavailable': 'Посилання запрошення недоступне.',
    'toast.cardSaveFailed': 'Не вдалося зберегти картку.',
    'toast.cardCopied': 'Картку скопійовано',
    'toast.cardCopyFailed': 'Не вдалося скопіювати картку.',
    'toast.listCopied': 'Список скопійовано',
    'toast.listCopying': 'Копіюємо список...',
    'toast.listCopyFailed': 'Не вдалося скопіювати список.',
    'toast.listMoveFailed': 'Не вдалося перемістити список.',
    'toast.cardCreateFailed': 'Не вдалося створити задачу.',
    'toast.cardMoveFailed': 'Не вдалося перемістити картку.',
    'toast.cardDeleteFailed': 'Не вдалося видалити картку.',
    'toast.cardArchiveFailed': 'Не вдалося змінити статус архіву картки.',
    'toast.boardCreateFailed': 'Не вдалося створити дошку.',
    'toast.boardUpdateFailed': 'Не вдалося оновити дошку.',
    'toast.boardArchiveFailed': 'Не вдалося змінити статус архіву дошки.',
    'toast.listArchiveFailed': 'Не вдалося змінити статус архіву списку.',
    'toast.listCreateFailed': 'Не вдалося створити список.',
    'toast.listRenameFailed': 'Не вдалося перейменувати список.',
  
    'auth.confirmPassword': 'Повторіть пароль',
    'auth.placeholderConfirmPassword': 'Повторіть пароль',
    'auth.showPassword': 'Показати',
    'auth.hidePassword': 'Сховати',
    'auth.invalidCredentials': 'Логін або пароль введено неправильно.',
    'auth.passwordMismatch': 'Паролі не співпадають.',
    'auth.registerError': 'Не вдалося зареєструватися.',
    'auth.invalidEmail': 'Невірний email.',
    'auth.passwordTooShort': 'Пароль має бути не менше {min} символів.',
    'auth.policyRequired': 'Будь ласка, погодьтеся з політикою конфіденційності.',
    'activation.loadingTitle': 'Активація акаунту...',
    'activation.loadingHint': 'Будь ласка, зачекайте.',
    'activation.successTitle': 'Акаунт успішно активовано! 🎉',
    'activation.successHint': 'Тепер ви можете увійти до системи.',
    'activation.signIn': 'Увійти',
    'activation.errorTitle': 'Помилка активації',
    'activation.errorHint': 'Посилання недійсне або термін його дії минув.',
    'activation.back': 'Повернутися',
  },
  en: {
    'nav.board': 'Board',
    'nav.myCards': 'My cards',
    'nav.profile': 'Profile',
    'nav.faq': 'FAQ',
    'nav.help': 'Help',
    'nav.community': 'Community',
    'nav.logout': 'Log out',
    'nav.greeting': 'Hi, {name}',
    'nav.menu': 'Menu',
    'nav.language': 'Language',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.search': 'Search',
    'common.loading': 'Loading...',
    'common.error': 'Something went wrong',
    'common.actionFailed': 'Action failed. Please try again.',
    'common.retry': 'Try again',
    'common.close': 'Close',
    'common.add': 'Add',
    'common.assigned': 'Assigned',
    'common.notAssigned': 'Not assigned',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.copyLink': 'Copy link',
    'common.share': 'Share',
    'common.clear': 'Clear',
    'common.noConnection': 'No connection',
    'common.saving': 'Saving...',
    'common.unknown': 'unknown',
    'common.linkCopied': 'Link copied',
    'common.copySuffix': ' (copy)',
    'common.copy': 'Copy',
    'common.copying': 'Copying...',
    'common.edit': 'Edit',
    'common.creating': 'Creating...',
    'common.confirmDelete': 'Delete?',
    'common.redirecting': 'Redirecting...',
    'common.or': 'or',
    'auth.welcome': 'Welcome',
    'auth.createAccount': 'Create account',
    'auth.joinBoardly': 'Join Boardly and manage tasks efficiently.',
    'auth.enterDetails': 'Enter your details to sign in.',
    'auth.firstName': 'First name',
    'auth.lastName': 'Last name',
    'auth.email': 'Email',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.placeholderFirstName': 'John',
    'auth.placeholderLastName': 'Doe',
    'auth.placeholderUsername': 'Your username',
    'auth.placeholderPassword': '********',
    'auth.forgotPassword': 'Forgot password?',
    'auth.processing': 'Processing...',
    'auth.signUp': 'Sign up',
    'auth.signIn': 'Sign in',
    'auth.hasAccount': 'Already have an account?',
    'auth.noAccount': "Don't have an account?",
    'auth.googleError': 'Google sign-in failed.',
    'auth.loginError': 'Authentication failed.',
    'auth.registerSuccessTitle': 'Registration successful!',
    'auth.registerSuccessHint': 'We sent a confirmation email to {email}. Please check your inbox.',
    'auth.backToLogin': 'Back to sign in',
    'auth.organizationOptional': 'Organization (optional)',
    'auth.usernameOrEmail': 'Username or Email',
    'auth.policyPrefix': 'I agree to the',
    'auth.policyLink': 'Privacy Policy',
    'auth.googleSignIn': 'Sign in with Google',
    'auth.preview.todoTitle': 'To do',
    'auth.preview.todoCard': 'Login page design',
    'auth.preview.progressTitle': 'In progress',
    'auth.preview.progressCard': 'Implement drag & drop',
    'auth.preview.doneTitle': 'Done',
    'auth.preview.doneCard': 'Board creation',
    'passwordReset.title': 'Reset password',
    'passwordReset.description': 'Enter your email and we will send you a link to restore access.',
    'passwordReset.successTitle': 'Email sent!',
    'passwordReset.successHint': 'Check your inbox (or the Django dev console) for the reset link.',
    'passwordReset.successDetail': 'We sent instructions to {email}. Check your inbox and spam.',
    'passwordReset.backToLogin': 'Back to sign in',
    'passwordReset.emailLabel': 'Email',
    'passwordReset.emailPlaceholder': 'name@example.com',
    'passwordReset.submit': 'Reset password',
    'passwordReset.sending': 'Sending...',
    'passwordReset.remembered': 'I remembered my password',
    'passwordReset.error': 'We could not find a user with that email or something went wrong.',
    'resetConfirm.title': 'New password',
    'resetConfirm.description': 'Create a new strong password for your account.',
    'resetConfirm.successTitle': 'Success!',
    'resetConfirm.successHint': 'Your password has been changed. Redirecting to the sign-in page...',
    'resetConfirm.successAction': 'Sign in with new password',
    'resetConfirm.newPasswordLabel': 'New password',
    'resetConfirm.newPasswordPlaceholder': 'At least 8 characters',
    'resetConfirm.confirmPasswordLabel': 'Confirm password',
    'resetConfirm.confirmPasswordPlaceholder': 'Repeat your password',
    'resetConfirm.submit': 'Change password',
    'resetConfirm.saving': 'Saving...',
    'resetConfirm.errorMismatch': 'Passwords do not match',
    'resetConfirm.errorPassword': 'Password: {message}',
    'resetConfirm.errorInvalidLink': 'The reset link is invalid or has expired.',
    'resetConfirm.errorUnknown': 'Something went wrong. Please try again.',
    'lang.uk': 'Ukrainian',
    'lang.en': 'English',
    'lang.pl': 'Polish',
    'lang.de': 'German',
    'lang.fr': 'French',
    'lang.es': 'Spanish',
    'board.archive': 'Archive board',
    'board.archiveConfirm': 'Archive this board?',
    'board.archivedSuffix': '(archived)',
    'board.create.newButton': '+ New board',
    'board.create.titlePlaceholder': 'Board name',
    'board.create.titleLabel': 'Board title',
    'board.create.titleInputPlaceholder': 'Enter a title...',
    'board.create.typeTitle': 'What do you want to create?',
    'board.create.typeIntro': 'Choose a workspace format before you start.',
    'board.create.kanbanTitle': 'Kanban',
    'board.create.kanbanDescription': 'Work personally or together with a team.',
    'board.create.calendarTitle': 'Calendar',
    'board.create.calendarDescription': 'A personal and convenient workspace for work, habit tracking, completed task statistics, and much more.',
    'board.empty.title': 'Create your first board',
    'board.empty.subtitle': 'Add a board to get started.',
    'board.menu': 'Board menu',
    'board.menu.changeBackground': 'Change background',
    'board.menu.members': 'Members',
    'board.menu.archived': 'Archived items',
    'board.menu.inviteTitle': 'Invite',
    'board.account.title': 'Account',
    'board.account.changeAccount': 'Change account',
    'board.account.profile': 'Profile',
    'board.account.settings': 'Settings',
    'board.account.backgrounds': 'Backgrounds',
    'board.account.logout': 'Log Out',
    'board.filters': 'Filters',
    'board.select.title': 'Select board',
    'board.settings': 'Board settings',
    'board.error.loadDetails': 'Failed to load board details.',
    'board.unarchive': 'Restore board',
    'board.unarchiveConfirm': 'Restore this board?',
    'board.deleteConfirm': 'Delete board?',
    'board.delete': 'Delete board',
    'board.leave': 'Leave board',
    'board.joining': 'Joining board...',
    'board.background.title': 'Board background',
    'board.background.upload': 'Upload image',
    'board.background.reset': 'Reset',
    'board.background.apply': 'Apply',
    'board.background.urlPlaceholder': 'Paste image URL...',
    'board.background.colorSelected': 'Color selected',
    'board.background.gradientSelected': 'Gradient selected',
    'board.background.imageSelected': 'Image selected',
    'board.background.invalidFile': 'Please choose an image file.',
    'board.background.tooLarge': 'File is too large (max {size} MB).',
    'board.background.uploadHint': 'PNG, JPG - up to 5 MB - minimum 1920 by 1080',
    'board.background.colors': 'Colors',
    'board.background.gradients': 'Gradients',
    'board.background.images': 'Images',
    'board.background.default': 'Default',
    'board.background.slate': 'Slate',
    'board.background.charcoal': 'Charcoal',
    'board.background.indigo': 'Indigo',
    'board.background.emerald': 'Emerald',
    'board.background.warmLight': 'Warm light',
    'board.background.gradient.sunset': 'Sunset',
    'board.background.gradient.ocean': 'Ocean',
    'board.background.gradient.forest': 'Forest',
    'board.background.gradient.blush': 'Blush',
    'board.background.gradient.night': 'Night',
    'board.background.gradient.dawn': 'Dawn',
    'calendar.backToBoards': 'Back to boards',
    'calendar.kicker': 'Personal calendar',
    'calendar.title': 'Task calendar',
    'calendar.defaultTitle': 'My calendar',
    'calendar.addCalendar': 'Add calendar',
    'calendar.addPersonalCalendar': 'Add a personal calendar',
    'calendar.addPersonalCalendarDescription': 'One calendar for your account: view tasks by month, week, and day without mixing it with team boards.',
    'calendar.previewTitle': 'Calendar preview',
    'calendar.addTask': 'Add task',
    'calendar.month': 'Month',
    'calendar.week': 'Week',
    'calendar.day': 'Day',
    'calendar.personalSpace': 'Personal space',
    'calendar.viewSwitcher': 'Calendar view switcher',
    'calendar.view.month': 'Month',
    'calendar.view.week': 'Week',
    'calendar.view.day': 'Day',
    'calendar.sidebarTitle': 'Work structure',
    'calendar.sidebarDescription': 'Tasks, habits, and completion statistics will appear here. Logic will be added in the next stage.',
    'calendar.stats.completed': 'completed tasks',
    'calendar.stats.habits': 'habits in tracking',
    'calendar.emptyTitle': 'No tasks yet',
    'calendar.emptyDescription': 'The calendar is ready for future task, habit, and statistics logic.',
    'calendar.emptySlot': 'Free',
    'calendar.dayDetails': 'Day task details',
    'calendar.dayDetailsEmpty': 'After logic is added, detailed task information, execution time, checklists, and notes will appear here.',
    'calendar.task.create': 'New calendar task',
    'calendar.task.edit': 'Edit task',
    'calendar.task.add': 'Add task',
    'calendar.task.title': 'Title',
    'calendar.task.description': 'Description',
    'calendar.task.duration': 'Execution time: hours and minutes',
    'calendar.task.startAt': 'Start work at',
    'calendar.task.deadline': 'Deadline',
    'calendar.task.repeat': 'Repeat',
    'calendar.task.repeatDetails': 'Repeat time and day',
    'calendar.task.repeatDay': 'Day',
    'calendar.task.customRepeat': 'Custom repeat',
    'calendar.task.priority': 'Priority',
    'calendar.task.headerColor': 'Task header color',
    'calendar.task.labels': 'Labels',
    'calendar.task.newLabelName': 'Label name',
    'calendar.task.checklists': 'Checklists',
    'calendar.task.attachments': 'Attachments',
    'calendar.task.addAttachment': 'Add attachment',
    'calendar.task.addFromBoard': 'Add to calendar',
    'calendar.task.errorTitle': 'Enter a task title.',
    'calendar.task.errorDuration': 'Enter execution time.',
    'calendar.task.autoStartNotice': 'Start time was not set, so the task was placed into the nearest free slot.',
    'calendar.task.collisionNotice': 'Selected time is busy, so the task was moved to the nearest free slot.',
    'calendar.task.noFutureOccurrences': 'There are no following scheduled tasks for this series.',
    'calendar.task.scopeSaveConfirm': 'Save changes for all future repeats? Press Cancel to change only the current task.',
    'calendar.task.scopeDeleteConfirm': 'Delete all repeats of this task? Press Cancel to delete only the current one.',
    'calendar.task.deleteConfirm': 'Delete task?',
    'calendar.task.saveCurrent': 'Save current',
    'calendar.task.saveFuture': 'Save all following',
    'calendar.task.deleteCurrent': 'Delete current',
    'calendar.task.deleteFuture': 'Delete all following',
    'calendar.task.resizeStart': 'Resize task start',
    'calendar.task.resizeEnd': 'Resize task end',
    'calendar.task.overdue': 'Deadline overdue',
    'calendar.task.markComplete': 'Mark complete',
    'calendar.task.markIncomplete': 'Mark incomplete',
    'calendar.task.more': '+{count} more',
    'calendar.repeat.none': 'No repeat',
    'calendar.repeat.daily': 'Every day',
    'calendar.repeat.weekly': 'Every week',
    'calendar.repeat.monthly': 'Every month',
    'calendar.repeat.custom': 'Custom',
    'calendar.priority.none': 'No priority',
    'calendar.priority.high': 'High',
    'calendar.priority.medium': 'Medium',
    'calendar.priority.low': 'Low',
    'calendar.weekday.mon': 'Mon',
    'calendar.weekday.tue': 'Tue',
    'calendar.weekday.wed': 'Wed',
    'calendar.weekday.thu': 'Thu',
    'calendar.weekday.fri': 'Fri',
    'calendar.weekday.sat': 'Sat',
    'calendar.weekday.sun': 'Sun',
    'habits.open': 'Tasks for today',
    'habits.kicker': 'Day plan',
    'habits.title': 'Tasks for today',
    'habits.add': 'Add task',
    'habits.today': 'Completed today',
    'habits.todayDescription': 'Shows only tasks that are actually scheduled for today.',
    'habits.emptyTitle': 'No tasks for today',
    'habits.emptyDescription': 'Tasks appear here on the day they are scheduled.',
    'habits.noDescription': 'No description',
    'habits.mark': 'Done today',
    'habits.unmark': 'Unmark',
    'habits.monthStats': 'Monthly statistics',
    'habits.monthStatsDescription': 'Completion for each habit across the current month.',
    'help.title': 'How can we help?',
    'help.subtitle': 'Find answers with Boardly support resources',
    'help.featured.title': 'Featured content',
    'help.featured.item1': 'What are permission schemes in Boardly?',
    'help.featured.item2': 'Control how users get access to apps',
    'help.featured.item3': 'Change Atlassian account email addresses',
    'help.featured.item4': 'Deactivate a managed account',
    'help.featured.item5': 'Verify a domain to manage accounts',
    'help.featured.item6': 'Configure SAML single sign-on with an identity provider',
    'help.featured.item7': 'Give users admin permissions',
    'help.featured.item8': 'Understand user provisioning',
    'help.featured.item9': 'IP addresses and domains for Boardly cloud apps',
    'help.resources.title': 'Browse resources',
    'help.resources.community.title': 'Community',
    'help.resources.community.body': 'Find answers, support, and inspiration from other Boardly users.',
    'help.resources.community.link': 'Visit Boardly Community',
    'help.resources.status.title': 'System Status',
    'help.resources.status.body': 'Check the health of our cloud apps and services.',
    'help.resources.status.link': 'View system status',
    'help.resources.suggestions.title': 'Suggestions and bug reports',
    'help.resources.suggestions.body': 'Find existing feature suggestions and bug reports.',
    'help.resources.suggestions.link': 'View suggestions and bugs',
    'help.resources.marketplace.title': 'Marketplace apps',
    'help.resources.marketplace.body': 'Find features to customize your apps.',
    'help.resources.marketplace.link': 'View Marketplace',
    'help.resources.billing.title': 'Billing and licensing',
    'help.resources.billing.body': 'See FAQs about billing and licensing.',
    'help.resources.billing.link': 'View FAQs',
    'help.resources.training.title': 'Training and Certification',
    'help.resources.training.body': 'Develop new skills, improve your team’s work, and advance your professional career.',
    'help.resources.training.link': 'View training',
    'help.resources.developers.title': 'Developers',
    'help.resources.developers.body': 'Find API documentation and guides for developing apps and integrations.',
    'help.resources.developers.link': 'View developer docs',
    'help.resources.enterprise.title': 'Enterprise',
    'help.resources.enterprise.body': 'Learn about Boardly Enterprise and its Data Center products.',
    'help.resources.enterprise.link': 'View enterprise documentation',
    'help.resources.government.title': 'Government Cloud Support',
    'help.resources.government.body': 'Get technical and migration support for a Boardly Government project.',
    'help.resources.government.link': 'Log in to contact support',
    'help.resources.success.title': 'Success Central',
    'help.resources.success.body': 'Get help adopting your apps with a library of content authored by Boardly and partner experts.',
    'help.resources.success.link': 'View Success Central',
    'help.contact.title': 'Not finding the help you need?',
    'help.contact.button': 'Contact support',
    'help.footer.copyright': 'Copyright © 2026 Boardly',
    'help.footer.accessibility': 'Accessibility',
    'help.footer.privacyChoices': 'Your Privacy Choices',
    'help.footer.privacyPolicy': 'Privacy Policy',
    'help.footer.terms': 'Terms',
    'help.footer.impressum': 'Impressum',
    'help.footer.security': 'Security',
    'community.title': 'Create your best work life, together',
    'community.subtitle': 'Learn, connect, and grow with the Boardly community.',
    'community.getStarted.title': 'Get started',
    'community.getStarted.link': 'Find answers',
    'community.getStarted.forums.title': 'Forums',
    'community.getStarted.forums.body': 'Ask questions and get help from experts and peers.',
    'community.getStarted.learning.title': 'Learning',
    'community.getStarted.learning.body': 'Guides, tutorials, and best practices to level up.',
    'community.getStarted.events.title': 'Events',
    'community.getStarted.events.body': 'Join sessions and meet the community live.',
    'community.getStarted.champions.title': 'Champions',
    'community.getStarted.champions.body': 'Connect with power users and advocates.',
    'community.advice.title': 'Get advice and connect',
    'community.advice.body': 'Community forums are a great place for getting the answers you need from experts and peers. Find solutions or ask your own questions.',
    'community.back': 'Back',
    'community.kicker.forums': 'Community Forums',
    'community.learning.title': 'Grow your skills with flexible learning',
    'community.learning.body': 'Our free on-demand courses help you learn Atlassian apps and get work done faster. Level up with instructor-led training and Atlassian certifications.',
    'community.learning.longBody': 'Build practical expertise with structured learning paths, real-world examples, and guided best practices. From fundamentals to advanced workflows, these resources help your team apply knowledge quickly, improve collaboration, and deliver better outcomes with confidence.',
    'community.redesign.hero.title': 'Organize your tasks and solve them from anywhere.',
    'community.redesign.hero.subtitle': 'Organize projects, increase productivity, and work even more efficiently with our app.',
    'community.redesign.hero.cta': 'Sign up for free!',
    'community.redesign.preview.todo.title': 'To do',
    'community.redesign.preview.todo.task1': 'Design login page',
    'community.redesign.preview.todo.task2': 'Create task board',
    'community.redesign.preview.todo.task3': 'Set up notifications',
    'community.redesign.preview.progress.title': 'In progress',
    'community.redesign.preview.progress.task': 'Implement drag and drop',
    'community.redesign.preview.done.title': 'Done',
    'community.redesign.basicFunctions': 'Basic functions',
    'community.redesign.sources.title': 'Sources of Productivity',
    'community.redesign.sources.subtitle': 'Work more efficiently with our boards, maps, and automation, even on the go.',
    'community.redesign.sources.imageAlt': 'Task board preview',
    'community.redesign.moveTasks.title': 'Move tasks',
    'community.redesign.moveTasks.body': 'Simply move tasks using drag and drop.',
    'community.redesign.actions.heading': 'From messages to actions',
    'community.redesign.actions.subtitle': 'Collect important notifications in one place and turn them into productive tasks.',
    'community.redesign.actions.messages.title': 'Your messages from Slack',
    'community.redesign.actions.messages.body': 'Turn incoming messages into tasks in seconds.',
    'community.redesign.actions.automation.title': 'Use automation',
    'community.redesign.actions.automation.body': 'Automate your tasks with smart recommendations.',
    'community.redesign.actions.communicate.title': 'Communicate promptly',
    'community.redesign.actions.communicate.body': 'Communicate with your team in real time.',
    'community.redesign.more.heading': 'Do more with Boardly',
    'community.redesign.more.subtitle': 'Customize the app to your needs with integrations, automation, and workflow customization.',
    'community.redesign.more.integrations.title': 'Integrations',
    'community.redesign.more.integrations.body': 'Connect your favorite instruments.',
    'community.redesign.more.automation.title': 'Automation',
    'community.redesign.more.automation.body': 'Set up automatic actions.',
    'community.redesign.more.customization.title': 'Customization',
    'community.redesign.more.customization.body': 'Customize the boards to suit your needs.',
    'community.redesign.more.mobile.title': 'Mobile',
    'community.redesign.more.mobile.body': 'Work with one app as you go.',
    'community.redesign.signup.title': 'Get started with Boardly today',
    'community.redesign.signup.note': 'By entering my email address, I accept the terms and',
    'community.redesign.signup.privacy': 'Privacy Policy',
    'toolbar.searchPlaceholder': 'Search this board',
    'toolbar.actions': 'Board actions',
    'toolbar.matches': 'matches',
    'toolbar.noMatches': 'No matches',
    'filters.title': 'Filters',
    'filters.membersLabel': 'Members',
    'filters.membersAll': 'All members',
    'filters.labelsLabel': 'Labels',
    'filters.labelsAll': 'All labels',
    'filters.dueLabel': 'Due date',
    'filters.dueAny': 'Any due date',
    'filters.dueOverdue': 'Overdue',
    'filters.dueToday': 'Due today',
    'filters.dueWeek': 'Due this week',
    'filters.dueNone': 'No due date',
    'filters.completedLabel': 'Status',
    'filters.completedAll': 'All',
    'filters.completedOnly': 'Completed',
    'filters.incompleteOnly': 'Incomplete',
    'filters.reset': 'Reset',
    'filters.apply': 'Apply',
    'archive.cards': 'Archived cards',
    'archive.lists': 'Archived lists',
    'archive.showCards': 'Show archived cards',
    'archive.hideCards': 'Hide archived cards',
    'archive.showLists': 'Show archived lists',
    'archive.hideLists': 'Hide archived lists',
    'archive.badge': 'Archived',
    'list.addButton': '+ Add list',
    'list.create.placeholder': 'List name',
    'list.create.submit': 'Create list',
    'list.empty.noneTitle': 'No lists yet',
    'list.empty.noneSubtitle': 'Create your first list to add cards.',
    'list.empty.archivedTitle': 'Archived lists',
    'list.empty.archivedSubtitle': 'Enable archived view to see them.',
    'list.empty.showArchived': 'Show archived lists',
    'list.menu': 'List menu',
    'list.menu.addCard': 'Add card',
    'list.menu.move': 'Move list',
    'list.menu.moveAll': 'Move all cards in this list',
    'list.menu.sort': 'Sort by...',
    'list.menu.subscribe': 'Subscribe',
    'list.menu.unsubscribe': 'Unsubscribe',
    'list.menu.movePrompt': 'Enter new list position',
    'list.menu.moveAllPrompt': 'Enter destination list ID to move all cards',
    'list.menu.sortPrompt': 'Choose sorting',
    'list.menu.sortByDue': 'By due date',
    'list.menu.sortByTitle': 'By title',
    'list.menu.comingSoon': 'Coming soon',
    'list.menu.automation': 'Automation',
    'list.menu.automationAdd': 'When a card is added to the list...',
    'list.menu.automationDaily': 'Every day, sort by...',
    'list.menu.automationRule': 'Create rule',
    'list.menu.archiveAllCards': 'Archive all cards in this list',
    'list.menu.devCanAddCards': 'Developer can add cards',
    'list.menu.devCannotAddCards': 'Developer cannot add cards',
    'list.rename': 'Rename',
    'list.copy': 'Copy list',
    'list.archive': 'Archive list',
    'list.unarchive': 'Restore list',
    'list.color.title': 'Change color',
    'list.color.none': 'No color',
    'list.collapse': 'Collapse',
    'list.moveLeft': 'Move left',
    'list.moveRight': 'Move right',
    'list.position': 'Position',
    'list.archiveConfirm': 'Archive this list?',
    'list.archiveAllCardsConfirm': 'Archive all cards in this list?',
    'list.unarchiveConfirm': 'Restore this list?',
    'card.create.newButton': '+ New card',
    'card.create.placeholder': 'Card title...',
    'card.descriptionPlaceholder': 'Add a description',
    'card.descriptionTitle': 'Description',
    'card.descriptionEmpty': 'No description.',
    'card.dueDate': 'Due date',
    'card.dueDateRemove': 'Remove due date',
    'card.dueDatePreview': 'Selected: {date}',
    'card.dueDateRequired': 'Please select a due date',
    'card.empty': 'No cards yet',
    'card.menu': 'Card menu',
    'card.menu.move': 'Move',
    'card.menu.copy': 'Copy',
    'card.menu.share': 'Share',
    'card.menu.mirror': 'Mirror',
    'card.menu.template': 'Make template',
    'card.menu.subscribe': 'Subscribe',
    'card.menu.copyLinkPrompt': 'Copy this link manually',
    'card.menu.archive': 'Archive',
    'card.menu.delete': 'Delete',
    'card.move.title': 'Move card',
    'card.move.list': 'List',
    'card.move.position': 'Position',
    'card.move.button': 'Move',
    'card.moveToList': 'Move to list',
    'card.copy': 'Copy card',
    'card.archive': 'Archive',
    'card.unarchive': 'Restore',
    'card.inList': 'In list',
    'card.members': 'Members',
    'card.completedBadge': 'DONE',
    'card.complete': 'Mark complete',
    'card.uncomplete': 'Mark incomplete',
    'card.private': 'Private card',
    'card.overdue.days': '(Overdue by {count} d.)',
    'card.overdue.hours': '(Overdue by {count} h.)',
    'card.overdue.minutes': '(Overdue by {count} min.)',
    'card.moveUp': 'Move up',
    'card.moveDown': 'Move down',
    'card.moveLeft': 'Move left',
    'card.moveRight': 'Move right',
    'card.sidebar.participation': 'Participation',
    'card.sidebar.join': 'Join',
    'card.sidebar.leave': 'Leave',
    'card.joinError': 'Could not join the card.',
    'card.sidebar.add': 'Add',
    'card.sidebar.actions': 'Actions',
    'card.cover.title': 'Cover',
    'card.cover.remove': 'Remove cover',
    'card.colorTitle': 'Card color',
    'card.colorHint': 'Pick a color or reset to default.',
    'card.color.none': 'No color',
    'card.color.sun': 'Sun',
    'card.color.rose': 'Rose',
    'card.color.sky': 'Sky',
    'card.color.violet': 'Violet',
    'card.color.emerald': 'Emerald',
    'card.color.teal': 'Teal',
    'card.color.slate': 'Slate',
    'card.quick.add': 'Add',
    'card.quick.addHint': 'Use the right panel to add',
    'card.quick.dates': 'Dates',
    'card.quick.checklist': 'Checklist',
    'card.quick.attach': 'Attachment',
    'card.quick.members': 'Members',
    'card.quick.comingSoon': 'Coming soon',
    'card.watch': 'Watch',
    'card.add.title': 'Add to card',
    'card.add.labels': 'Labels',
    'card.add.labelsHint': 'Scroll to labels below',
    'card.add.dates': 'Dates',
    'card.add.checklist': 'Checklist',
    'card.add.members': 'Members',
    'card.add.attachments': 'Attachments',
    'card.cover.size': 'Size',
    'card.cover.size.full': 'Full',
    'card.cover.size.header': 'Header',
    'card.cover.colors': 'Colors',
    'card.cover.colorblind': 'Enable colorblind mode',
    'card.cover.colorblind.enable': 'Enable colorblind mode',
    'card.cover.colorblind.disable': 'Disable colorblind mode',
    'checklist.title': 'Checklist',
    'checklist.titlePlaceholder': 'Checklist title',
    'checklist.itemPlaceholder': 'Add an item',
    'checklist.addItem': 'Add an item',
    'checklist.add': 'Add checklist',
    'checklist.hint': 'Checklist saves automatically when you add items.',
    'checklist.empty': 'Checklist not created yet.',
    'checklist.deleteConfirm': 'Delete this checklist?',
    'checklist.hideCompleted': 'Hide checked items',
    'checklist.showCompleted': 'Show checked items',
    'checklist.hiddenDoneOnly': 'All completed items are hidden.',
    'checklist.copy.title': 'Copy checklist items',
    'checklist.copy.selectCard': 'Select a card',
    'checklist.createPopoverTitle': 'Add a list',
    'checklist.nameLabel': 'Name',
    'checklist.copy.fromLabel': 'Copy item from...',
    'checklist.copy.none': 'Missing',
    'checklist.copy.emptySource': 'The selected card has no checklist items to copy.',
    'checklist.copy.append': 'Append to end',
    'checklist.copy.replace': 'Replace all',
    'attachments.title': 'Attachments',
    'attachments.empty': 'No attachments yet.',
    'attachments.add': 'Add file',
    'comments.title': 'Comments',
    'comments.activityTitle': 'Comments & activity',
    'comments.showDetails': 'Show details',
    'comments.hideDetails': 'Hide details',
    'comments.empty': 'No comments yet.',
    'comments.add': 'Add comment',
    'comments.answer': 'Answer',
    'comments.send': 'Send',
    'comments.react': 'React',
    'comments.addReaction': 'Add reaction',
    'comments.reactionPicker': 'Emoji picker',
    'comment.placeholder': 'Write a comment...',
    'labels.title': 'Labels',
    'labels.empty': 'No labels yet.',
    'labels.newPlaceholder': 'New label',
    'labels.add': 'Add label',
    'labels.newPrompt': 'New label name:',
    'labels.deleteConfirm': 'Delete this label? It will be removed from all cards.',
    'labels.hint': 'Labels are saved after clicking {action}.',
    'members.title': 'Members',
    'members.modalTitle': 'Board members',
    'members.inviteTitle': 'Invite',
    'members.searchPlaceholder': 'Name, username, or email',
    'members.addListTitle': 'Add a list',
    'members.searchParticipants': 'Search for participants',
    'members.boardMembersTitle': 'Board members',
    'members.searching': 'Searching...',
    'members.refreshing': 'Refreshing member list...',
    'members.empty': 'No users found.',
    'members.inviteEmail': 'Invite by email',
    'members.adding': 'Adding...',
    'members.removing': 'Removing...',
    'members.roleOwner': 'Owner',
    'members.roleAdmin': 'Admin',
    'members.roleMember': 'Member',
    'members.roleDeveloper': 'Developer',
    'members.roleViewer': 'Viewer',
    'members.roleLabel': 'Role',
    'members.permissionsHint': 'Only owners or admins can add members.',
    'members.viewerCannotBeAssigned': 'Viewers cannot be assigned to cards.',
    'members.shareAria': 'Share',
    'members.more': '{count} more',
    'members.viewActivity': 'View board activity',
    'members.makeAdmin': 'Make admin',
    'members.removeAdmin': 'Remove admin',
    'members.removeFromBoard': 'Remove from board',
    'members.workspaceParticipants': 'Workspace participants',
    'members.guests': 'Guests',
    'members.activityTitle': 'Activity for {name}',
    'members.activityEmpty': 'No activity on this board.',
    'permissions.title': 'Developer permissions',
    'permissions.devCreateCards': 'Developer can create cards',
    'permissions.devEditAssigned': 'Developer can edit assigned cards',
    'permissions.devArchiveAssigned': 'Developer can archive assigned cards',
    'permissions.devJoinCard': 'Developer can join other cards',
    'permissions.devCreateLists': 'Developer can create lists',
    'hotkeys.hint': 'Hotkeys: Ctrl+K',
    'hotkeys.aria': 'Hotkeys',
    'command.title': 'Commands',
    'command.placeholder': 'Search commands',
    'command.empty': 'No commands found',
    'command.createCard': 'Create card',
    'command.createList': 'Create list',
    'command.createBoard': 'Create board',
    'command.goProfile': 'Go to profile',
    'command.goMyCards': 'Go to My cards',
    'command.goFaq': 'Open FAQ',
    'myCards.title': 'My cards',
    'myCards.loading': 'Loading cards...',
    'myCards.loadError': 'Failed to load cards.',
    'myCards.emptyAssigned': "You don't have any assigned cards yet.",
    'myCards.emptyList': 'No cards to display.',
    'myCards.boardFallback': 'Untitled board',
    'myCards.boardUnavailable': 'Board is unavailable.',
    'myCards.boardArchived': 'Board is archived',
    'landing.nav.sections': 'Landing section navigation',
    'landing.nav.goTo': 'Go to section {number}',
    'landing.nav.product': 'Product navigation',
    'landing.nav.problems': 'Problems',
    'landing.nav.workflow': 'Workflow',
    'landing.eyebrow': 'One system for boards, calendar, and tasks',
    'landing.hero.line1': 'Plan work',
    'landing.hero.line2': 'without chaos',
    'landing.hero.line3': 'between boards and calendar.',
    'landing.hero.description': 'Boardly keeps team tasks, personal deadlines, habits, checklists, labels, and attachments inside one clear workspace.',
    'landing.cta.note': 'Start with a board or a personal calendar.',
    'landing.mock.title': 'Workspace',
    'landing.mock.kanban': 'Kanban board',
    'landing.mock.calendar': 'Calendar',
    'landing.mock.focus': 'Focus task',
    'landing.mock.focusNote': 'scheduled today',
    'landing.problem.kicker': 'Why it matters',
    'landing.problem.heading': 'Boardly removes the common gaps in organizing work.',
    'landing.problem.subtitle': 'When tasks live in different places, deadlines disappear and teams lose the real state of work.',
    'landing.problem.scattered.title': 'Tasks are scattered',
    'landing.problem.scattered.body': 'Boards, personal plans, attachments, and checklists often live separately. Boardly brings them into one structure.',
    'landing.problem.deadlines.title': 'Deadlines are hard to see',
    'landing.problem.deadlines.body': 'A card can be important, but without a calendar it is hard to understand when to do it and how much time it takes.',
    'landing.problem.team.title': 'Team work mixes with personal focus',
    'landing.problem.team.body': 'Kanban works for teams, calendar works for personal focus. Boardly separates those scenarios while keeping them connected.',
    'landing.solution.kicker': 'Solution',
    'landing.solution.heading': 'Boards for teams, calendar for focus, tasks with full context.',
    'landing.solution.subtitle': 'The system follows the real workflow: create a task, clarify details, schedule it, complete it, and track the result.',
    'landing.solution.kanban.title': 'Kanban for process',
    'landing.solution.kanban.body': 'Create boards, lists, and cards for personal or team work.',
    'landing.solution.calendar.title': 'Calendar for time',
    'landing.solution.calendar.body': 'Plan a day, week, or month, see task duration and free slots.',
    'landing.solution.tasks.title': 'Tasks with details',
    'landing.solution.tasks.body': 'Title, description, deadline, start time, priority, labels, checklists, and attachments stay in one place.',
    'landing.solution.focus.title': 'Personal control',
    'landing.solution.focus.body': 'Track habits, recurring tasks, and completion without mixing them into team boards.',
    'landing.workflow.kicker': 'Workflow',
    'landing.workflow.heading': 'From idea to completion without losing context.',
    'landing.workflow.plan': 'Capture a task on a board or directly in the calendar.',
    'landing.workflow.schedule': 'Choose date, start time, duration, and deadline.',
    'landing.workflow.execute': 'Work with checklists, labels, priority, and attachments.',
    'landing.workflow.review': 'Review day, week, or month and control completion.',
    'landing.signup.title': 'Create a workspace where tasks do not disappear.',
    'landing.signup.subtitle': 'Start with a Kanban board for a team or a personal calendar for your own rhythm.',
    'landing.cta.openApp': 'Open boards',
    'landing.cta.signUp': 'Sign up for free!',
    'faq.title': 'FAQ',
    'faq.q1': 'How do I create a new board?',
    'faq.a1': 'Click "+ New board" on the board page.',
    'faq.q2': 'How do I add a list?',
    'faq.a2': 'Click "+ Add list" in the board toolbar.',
    'faq.q3': 'How do I invite members?',
    'faq.a3': 'Open Share and add people by name or email.',
    'faq.q4': 'Where can I see my cards?',
    'faq.a4': 'Open My cards from the top menu.',
    'profile.tabsLabel': 'Profile sections',
    'profile.tabs.profile': 'Profile',
    'profile.tabs.activity': 'Activity',
    'profile.tabs.settings': 'Settings',
    'profile.authRequiredTitle': 'Authentication required',
    'profile.authRequiredHint': 'Sign in to view your profile.',
    'profile.avatarAlt': 'User avatar',
    'profile.avatar.change': 'Change avatar',
    'profile.avatar.remove': 'Remove avatar',
    'profile.sections.profile': 'Profile',
    'profile.sections.activity': 'Activity',
    'profile.sections.settings': 'Settings',
    'profile.settings.subtitle': 'Manage your account settings',
    'profile.activity.subtitle': 'Track your and others activity list on your desks',
    'profile.settings.general': 'General',
    'profile.settings.language': 'Language',
    'profile.settings.clearCache': 'Clear cache',
    'profile.settings.cacheDescription': 'Deletes website cache and temporary data',
    'profile.settings.notifications': 'Notifications',
    'profile.settings.desktopNotifications': 'Gmail notifications',
    'profile.settings.assignedToTask': 'Assigned to a task',
    'profile.settings.dueDateApproaching': 'Due date approaching',
    'profile.settings.addedToBoard': 'Added to a board',
    'profile.settings.manageEmail': 'Manage email preferences',
    'profile.settings.appearance': 'Appearance',
    'profile.settings.theme': 'Theme',
    'profile.settings.dark': 'Dark',
    'profile.settings.light': 'Light',
    'profile.settings.defaultBoardView': 'Default board view',
    'profile.settings.kanban': 'Kanban',
    'profile.settings.calendar': 'Calendar',
    'profile.settings.manageIntegrations': 'Manage integrations',
    'profile.settings.security': 'Security',
    'profile.settings.twoFactor': 'Two-factor authentication',
    'profile.settings.requireVerification': 'Require login verification',
    'profile.settings.additionalVerification': 'Additional Email verification for new logins',
    'profile.settings.sessionTimeout': 'Session timeout',
    'profile.settings.sessionTimeout1h': 'After 1 Hour of inactivity',
    'profile.settings.saveChanges': 'Save changes',
    'profile.settings.cacheCleared': 'Cache cleared',
    'profile.settings.comingSoon': 'Coming soon',
    'profile.emailPrefs.title': 'Email preferences',
    'profile.emailPrefs.subtitle': 'Choose which emails you want to receive',
    'profile.emailPrefs.enableEmail': 'Email notifications',
    'profile.emailPrefs.assignedToTask': 'Assigned to a task',
    'profile.emailPrefs.dueDateApproaching': 'Due date approaching',
    'profile.emailPrefs.addedToBoard': 'Added to a board',
    'profile.integrations.title': 'Integrations',
    'profile.integrations.subtitle': 'Connect services to work with Boardly',
    'profile.integrations.connect': 'Connect',
    'profile.integrations.slack': 'Slack alerts and quick actions',
    'profile.integrations.calendar': 'Sync deadlines with your calendar',
    'profile.integrations.github': 'Link tasks with repositories',
    'profile.fields.firstName': 'First name',
    'profile.fields.lastName': 'Last name',
    'profile.fields.organization': 'Organization',
    'profile.fields.nickname': 'Username',
    'profile.fields.theme': 'Theme',
    'profile.fields.themeToggle': 'Theme toggle',
    'profile.fields.language': 'Language',
    'profile.fields.emailNotifications': 'Email notifications',
    'profile.notifications.on': 'On',
    'profile.notifications.off': 'Off',
    'profile.theme.dark': 'Dark',
    'profile.theme.light': 'Light',
    'profile.saveSettings': 'Save settings',
    'profile.saving': 'Saving...',
    'profile.activity.empty': 'No activity for now.',
    'profile.activity.loadMore': 'Load more',
    'profile.activity.type': 'Type: {type}',
    'profile.logoutAll': 'Log out of all devices',
    'profile.logoutAllHint': 'Coming soon',
    'profile.errors.requiredName': 'First and last name are required.',
    'profile.errors.saveFailed': 'Failed to save profile.',
    'profile.errors.imageOnly': 'Only image files are supported.',
    'profile.errors.avatarUploadFailed': 'Failed to upload avatar.',
    'profile.errors.avatarRemoveFailed': 'Failed to remove avatar.',
    'profile.errors.activityLoad': 'Failed to load activity.',
    'profile.toast.saved': 'Profile saved',
    'profile.toast.avatarUpdated': 'Avatar updated',
    'profile.toast.avatarRemoved': 'Avatar removed',
    'profile.time.justNow': 'just now',
    'profile.time.minutesAgo': '{count} min ago',
    'profile.time.hoursAgo': '{count} hr ago',
    'profile.time.daysAgo': '{count} d ago',
    'profile.tabs.privacy': 'Privacy policy',
    'profile.backToMain': 'Back to main page',
    'profile.header.title': 'Profile settings',
    'profile.header.subtitle': 'Manage your personal information',
    'profile.privacy.title': 'Privacy policy profile',
    'profile.privacy.subtitle': 'Protect your personal information',
    'profile.section.personalInfo': 'Personal info',
    'profile.section.passwordChange': 'Password change',
    'profile.section.workInfo': 'Work info',
    'profile.section.access': 'Access',
    'profile.fields.email': 'Email',
    'profile.fields.currentPassword': 'Current password',
    'profile.fields.bio': 'Bio',
    'profile.fields.public': 'Public',
    'profile.placeholders.organization': 'Role / Company',
    'profile.placeholders.bio': 'Tell us about yourself',
    'profile.actions.changePassword': 'Change password',
    'profile.actions.deactivate': 'Deactivate your account',
    'profile.userFallback': 'User',
    'profile.confirmDelete': 'Are you sure you want to delete your account? This action cannot be undone.',
    'profile.deactivate.title': '!ATTENTION!',
    'profile.deactivate.message': 'This action cannot be undone. Are you sure you want to deactivate your account?',
    'profile.deactivate.confirm': 'Deactivate',
    'profile.deactivate.close': 'Close',
    'activity.context.onBoard': 'on board {board}',
    'activity.context.toList': 'to {list}',
    'activity.context.fromList': 'from {list}',
    'activity.context.inList': 'in {list}',
    'activity.context.inChecklist': 'in checklist {checklist}',
    'activity.context.onCard': 'on card {card}',
    'activity.noDate': 'no date',
    'activity.create_board': '{actor} created board {board}',
    'activity.rename_board': '{actor} renamed board {board}',
    'activity.update_board': '{actor} updated board {board}',
    'activity.archive_board': '{actor} archived board {board}',
    'activity.unarchive_board': '{actor} restored board {board}',
    'activity.create_list': '{actor} added list {list}{context}',
    'activity.rename_list': '{actor} renamed list {list}',
    'activity.move_list': '{actor} moved list {list}{context}',
    'activity.archive_list': '{actor} archived list {list}',
    'activity.unarchive_list': '{actor} restored list {list}',
    'activity.copy_list': '{actor} copied list {source} → {target}',
    'activity.create_card': '{actor} added card {card}{context}',
    'activity.move_card': '{actor} moved card {card}{from}{to}',
    'activity.archive_card': '{actor} archived card {card}{context}',
    'activity.unarchive_card': '{actor} restored card {card}{context}',
    'activity.update_card': '{actor} updated card {card}',
    'activity.update_card_description': '{actor} updated card description {card}',
    'activity.update_card_due_date': '{actor} changed due date for card {card} from {before} to {after}',
    'activity.copy_card': '{actor} copied card {source} → {target}',
    'activity.complete_card': 'Member {actor} marked this card as completed',
    'activity.uncomplete_card': 'Member {actor} removed completion mark from this card',
    'activity.checklist.unchecked': '{actor} marked {item} as not done{checklist}{card}',
    'activity.checklist.checked': '{actor} marked {item} as done{checklist}{card}',
    'activity.add_checklist_item': '{actor} added subtask {item}{checklist}{card}',
    'activity.update_checklist_item': '{actor} updated subtask {item}{checklist}{card}',
    'activity.add_comment': '{actor} added comment {comment}{card}',
    'activity.labels.added': 'added labels: {labels}',
    'activity.labels.removed': 'removed labels: {labels}',
    'activity.labels.updated': 'updated labels',
    'activity.update_card_labels': '{actor} {changes} for card {card}',
    'activity.create_label': '{actor} created label {label}{context}',
    'activity.update_label': '{actor} updated label {label}{context}',
    'activity.delete_label': '{actor} deleted label {label}{context}',
    'activity.update_profile': '{actor} updated profile',
    'activity.update_avatar': '{actor} updated avatar',
    'activity.remove_avatar': '{actor} removed avatar',
    'activity.default': '{actor} performed action {target}',
    'privacy.summaryTitle': 'This privacy policy is intended to help you understand:',
    'privacy.body.p1': 'Your privacy matters to us. This privacy policy explains how Boardly, and our corporate affiliates collect, use, share, and protect your information when you use our products, services, websites, or otherwise interact with us (a list of Atlassian’s corporate affiliates can be found in the List of Subsidiaries section of Atlassian’s most recent Form 10-K, available under the SEC Filings tab by selecting the “Annual Filings” filter on the page located here). We offer a wide range of products, including our cloud and software products. We refer to all of these products, together with our other services and websites, as "Services" in this privacy policy.',
    'privacy.body.p2': 'This privacy policy also explains your choices surrounding how we use information about you, which includes how you can object to certain uses of information about you and how you can access and update certain information about you. If you do not agree with this privacy policy, do not access or use our Services or interact with any other aspect of our business.',
    'privacy.footer.accessibility': 'Accessibility',
    'privacy.footer.choices': 'Your privacy choices',
    'privacy.footer.policy': 'Privacy policy',
    'privacy.footer.terms': 'Terms',
    'privacy.footer.data': 'Data outputs',
    'privacy.footer.security': 'Security',
    'errors.boardUpdate': 'Failed to update board: {message}',
    'errors.listsLoad': 'Failed to load lists: {message}',
    'errors.cardsLoad': 'Failed to load cards: {message}',
    'confirm.deleteCard': 'Delete this card?',
    'prompt.copyLink': 'Copy this link:',
    'toast.membersUpdateFailed': 'Failed to refresh members.',
    'toast.cardsReloadFailed': 'Failed to refresh cards.',
    'toast.joinFailed': 'Failed to join the board.',
    'toast.checklistSaveFailed': 'Failed to save checklist.',
    'toast.checklistDeleteFailed': 'Failed to delete checklist.',
    'toast.checklistItemAddFailed': 'Failed to add checklist item.',
    'toast.labelCreateFailed': 'Failed to create label.',
    'toast.commentAddFailed': 'Failed to add comment.',
    'toast.commentDeleteFailed': 'Failed to delete comment.',
    'toast.attachmentAdded': 'Attachment added',
    'toast.attachmentAddFailed': 'Failed to add attachment.',
    'toast.attachmentDeleteFailed': 'Failed to delete attachment.',
    'toast.memberAddFailed': 'Failed to add member.',
    'toast.memberRoleFailed': 'Failed to change role.',
    'toast.memberRemoveFailed': 'Failed to remove member.',
    'toast.inviteUnavailable': 'Invite link is unavailable.',
    'toast.cardSaveFailed': 'Failed to save card.',
    'toast.cardCopied': 'Card copied',
    'toast.cardCopyFailed': 'Failed to copy card.',
    'toast.listCopied': 'List copied',
    'toast.listCopying': 'Copying list...',
    'toast.listCopyFailed': 'Failed to copy list.',
    'toast.listMoveFailed': 'Failed to move list.',
    'toast.cardCreateFailed': 'Failed to create card.',
    'toast.cardMoveFailed': 'Failed to move card.',
    'toast.cardDeleteFailed': 'Failed to delete card.',
    'toast.cardArchiveFailed': 'Failed to update card archive status.',
    'toast.boardCreateFailed': 'Failed to create board.',
    'toast.boardUpdateFailed': 'Failed to update board.',
    'toast.boardArchiveFailed': 'Failed to update board archive status.',
    'toast.listArchiveFailed': 'Failed to update list archive status.',
    'toast.listCreateFailed': 'Failed to create list.',
    'toast.listRenameFailed': 'Failed to rename list.',
  
    'auth.confirmPassword': 'Confirm password',
    'auth.placeholderConfirmPassword': 'Confirm password',
    'auth.showPassword': 'Show',
    'auth.hidePassword': 'Hide',
    'auth.invalidCredentials': 'Incorrect username or password.',
    'auth.passwordMismatch': 'Passwords do not match.',
    'auth.registerError': 'Registration failed.',
    'auth.invalidEmail': 'Invalid email address.',
    'auth.passwordTooShort': 'Password must be at least {min} characters.',
    'auth.policyRequired': 'Please accept the privacy policy.',
    'activation.loadingTitle': 'Activating account...',
    'activation.loadingHint': 'Please wait.',
    'activation.successTitle': 'Account activated! 🎉',
    'activation.successHint': 'You can now sign in.',
    'activation.signIn': 'Sign in',
    'activation.errorTitle': 'Activation failed',
    'activation.errorHint': 'The link is invalid or has expired.',
    'activation.back': 'Back',
  },
  pl: {
    'auth.confirmPassword': 'Potwierdź hasło',
    'auth.placeholderConfirmPassword': 'Potwierdź hasło',
    'auth.showPassword': 'Pokaż',
    'auth.hidePassword': 'Ukryj',
    'auth.invalidCredentials': 'Nieprawidłowy login lub hasło.',
    'auth.passwordMismatch': 'Hasła nie są zgodne.',
    'auth.registerError': 'Rejestracja nie powiodła się.',
  },
  de: {
    'auth.confirmPassword': 'Passwort bestätigen',
    'auth.placeholderConfirmPassword': 'Passwort bestätigen',
    'auth.showPassword': 'Anzeigen',
    'auth.hidePassword': 'Ausblenden',
    'auth.invalidCredentials': 'Benutzername oder Passwort ist falsch.',
    'auth.passwordMismatch': 'Passwörter stimmen nicht überein.',
    'auth.registerError': 'Registrierung fehlgeschlagen.',
  },
  fr: {
    'auth.confirmPassword': 'Confirmez le mot de passe',
    'auth.placeholderConfirmPassword': 'Confirmez le mot de passe',
    'auth.showPassword': 'Afficher',
    'auth.hidePassword': 'Masquer',
    'auth.invalidCredentials': 'Identifiant ou mot de passe incorrect.',
    'auth.passwordMismatch': 'Les mots de passe ne correspondent pas.',
    'auth.registerError': 'Inscription impossible.',
  },
  es: {
    'auth.confirmPassword': 'Confirmar contraseña',
    'auth.placeholderConfirmPassword': 'Confirmar contraseña',
    'auth.showPassword': 'Mostrar',
    'auth.hidePassword': 'Ocultar',
    'auth.invalidCredentials': 'Usuario o contraseña incorrectos.',
    'auth.passwordMismatch': 'Las contraseñas no coinciden.',
    'auth.registerError': 'No se pudo registrar.',
  },
};

const baseEn = translations.en;

translations.pl = {
  ...baseEn,
  'nav.board': 'Tablica',
  'nav.myCards': 'Moje karty',
  'nav.profile': 'Profil',
  'nav.faq': 'FAQ',
  'nav.help': 'Pomoc',
  'nav.community': 'Społeczność',
  'nav.logout': 'Wyloguj się',
  'nav.greeting': 'Cześć, {name}',
  'nav.menu': 'Menu',
  'nav.language': 'Język',
  'help.title': 'Jak możemy pomóc?',
  'help.subtitle': 'Znajdź odpowiedzi w zasobach wsparcia Boardly.',
  'help.featured.title': 'Polecane treści',
  'help.featured.item1': 'Czym są schematy uprawnień w Boardly?',
  'help.featured.item2': 'Kontroluj, jak użytkownicy uzyskują dostęp do aplikacji',
  'help.featured.item3': 'Zmień adresy e-mail konta Atlassian',
  'help.featured.item4': 'Dezaktywuj zarządzane konto',
  'help.featured.item5': 'Zweryfikuj domenę, aby zarządzać kontami',
  'help.featured.item6': 'Skonfiguruj SAML single sign-on z dostawcą tożsamości',
  'help.featured.item7': 'Nadaj użytkownikom uprawnienia administratora',
  'help.featured.item8': 'Zrozum provisionowanie użytkowników',
  'help.featured.item9': 'Adresy IP i domeny dla aplikacji chmurowych Boardly',
  'help.resources.title': 'Przeglądaj zasoby',
  'help.resources.community.title': 'Społeczność',
  'help.resources.community.body': 'Znajdź odpowiedzi, wsparcie i inspirację od innych użytkowników Boardly.',
  'help.resources.community.link': 'Odwiedź społeczność Boardly',
  'help.resources.status.title': 'Status systemu',
  'help.resources.status.body': 'Sprawdź stan naszych aplikacji i usług w chmurze.',
  'help.resources.status.link': 'Zobacz status systemu',
  'help.resources.suggestions.title': 'Sugestie i zgłoszenia błędów',
  'help.resources.suggestions.body': 'Zobacz istniejące sugestie funkcji i zgłoszenia błędów.',
  'help.resources.suggestions.link': 'Zobacz sugestie i błędy',
  'help.resources.marketplace.title': 'Aplikacje Marketplace',
  'help.resources.marketplace.body': 'Znajdź funkcje do personalizacji aplikacji.',
  'help.resources.marketplace.link': 'Zobacz Marketplace',
  'help.resources.billing.title': 'Rozliczenia i licencje',
  'help.resources.billing.body': 'Zobacz FAQ dotyczące rozliczeń i licencji.',
  'help.resources.billing.link': 'Zobacz FAQ',
  'help.resources.training.title': 'Szkolenia i certyfikacja',
  'help.resources.training.body': 'Rozwijaj nowe umiejętności, poprawiaj pracę zespołu i karierę.',
  'help.resources.training.link': 'Zobacz szkolenia',
  'help.resources.developers.title': 'Deweloperzy',
  'help.resources.developers.body': 'Dokumentacja API i przewodniki do tworzenia aplikacji i integracji.',
  'help.resources.developers.link': 'Zobacz dokumentację dla deweloperów',
  'help.resources.enterprise.title': 'Enterprise',
  'help.resources.enterprise.body': 'Poznaj Boardly Enterprise i produkty Data Center.',
  'help.resources.enterprise.link': 'Zobacz dokumentację Enterprise',
  'help.resources.government.title': 'Wsparcie Government Cloud',
  'help.resources.government.body': 'Wsparcie techniczne i migracyjne dla projektów Government Boardly.',
  'help.resources.government.link': 'Zaloguj się, aby skontaktować się z pomocą',
  'help.resources.success.title': 'Centrum sukcesu',
  'help.resources.success.body': 'Pomoc we wdrażaniu dzięki bibliotece treści od Boardly i partnerów.',
  'help.resources.success.link': 'Zobacz Centrum sukcesu',
  'help.contact.title': 'Nie znajdujesz potrzebnej pomocy?',
  'help.contact.button': 'Skontaktuj się z pomocą',
  'help.footer.copyright': 'Copyright © 2026 Boardly',
  'help.footer.accessibility': 'Dostępność',
  'help.footer.privacyChoices': 'Twoje wybory prywatności',
  'help.footer.privacyPolicy': 'Polityka prywatności',
  'help.footer.terms': 'Warunki',
  'help.footer.impressum': 'Impressum',
  'help.footer.security': 'Bezpieczeństwo',
  'community.title': 'Twórz najlepsze życie zawodowe razem',
  'community.subtitle': 'Ucz się, łącz i rozwijaj ze społecznością Boardly.',
  'community.getStarted.title': 'Zacznij',
  'community.getStarted.link': 'Znajdź odpowiedzi',
  'community.getStarted.forums.title': 'Fora',
  'community.getStarted.forums.body': 'Zadawaj pytania i otrzymuj pomoc od ekspertów i innych użytkowników.',
  'community.getStarted.learning.title': 'Nauka',
  'community.getStarted.learning.body': 'Poradniki, tutoriale i najlepsze praktyki.',
  'community.getStarted.events.title': 'Wydarzenia',
  'community.getStarted.events.body': 'Dołącz do sesji i poznaj społeczność na żywo.',
  'community.getStarted.champions.title': 'Ambasadorzy',
  'community.getStarted.champions.body': 'Połącz się z zaawansowanymi użytkownikami i ambasadorami.',
  'community.advice.title': 'Uzyskaj porady i nawiąż kontakt',
  'community.advice.body': 'Fora społeczności to świetne miejsce, by uzyskać odpowiedzi od ekspertów i innych użytkowników. Znajdź rozwiązania lub zadawaj własne pytania.',
  'community.back': 'Wstecz',
  'community.kicker.forums': 'Fora społeczności',
  'community.learning.title': 'Rozwijaj umiejętności dzięki elastycznej nauce',
  'community.learning.body': 'Nasze bezpłatne kursy on-demand pomagają szybciej opanować aplikacje Atlassian i pracować efektywniej. Rozwijaj się dzięki szkoleniom prowadzonym przez instruktorów i certyfikacjom Atlassian.',
  'community.learning.longBody': 'Rozwijaj praktyczne kompetencje dzięki uporządkowanym ścieżkom nauki, przykładom z życia i sprawdzonym praktykom. Od podstaw po zaawansowane scenariusze, te materiały pomogą Twojemu zespołowi szybciej wdrażać wiedzę, usprawniać współpracę i osiągać lepsze wyniki.',
  'community.redesign.hero.title': 'Organizuj zadania i realizuj je z dowolnego miejsca.',
  'community.redesign.hero.subtitle': 'Organizuj projekty, zwieksz produktywnosc i pracuj jeszcze efektywniej z nasza aplikacja.',
  'community.redesign.hero.cta': 'Zarejestruj sie za darmo!',
  'community.redesign.preview.todo.title': 'Do zrobienia',
  'community.redesign.preview.todo.task1': 'Zaprojektowac ekran logowania',
  'community.redesign.preview.todo.task2': 'Utworzyc tablice zadan',
  'community.redesign.preview.todo.task3': 'Skonfigurowac powiadomienia',
  'community.redesign.preview.progress.title': 'W trakcie',
  'community.redesign.preview.progress.task': 'Wdrozyc drag and drop',
  'community.redesign.preview.done.title': 'Gotowe',
  'community.redesign.basicFunctions': 'Podstawowe funkcje',
  'community.redesign.sources.title': 'Zrodla produktywnosci',
  'community.redesign.sources.subtitle': 'Pracuj wydajniej z tablicami, mapami i automatyzacjami, nawet w drodze.',
  'community.redesign.sources.imageAlt': 'Podglad tablicy z zadaniami',
  'community.redesign.moveTasks.title': 'Przenos zadania',
  'community.redesign.moveTasks.body': 'Latwo przenos zadania za pomoca drag and drop.',
  'community.redesign.actions.heading': 'Od wiadomosci do dzialan',
  'community.redesign.actions.subtitle': 'Zbieraj wazne powiadomienia w jednym miejscu i zamieniaj je w produktywne zadania.',
  'community.redesign.actions.messages.title': 'Twoje wiadomosci ze Slacka',
  'community.redesign.actions.messages.body': 'Zamieniaj przychodzace wiadomosci w zadania w kilka sekund.',
  'community.redesign.actions.automation.title': 'Uzywaj automatyzacji',
  'community.redesign.actions.automation.body': 'Automatyzuj zadania dzieki inteligentnym podpowiedziom.',
  'community.redesign.actions.communicate.title': 'Szybka komunikacja',
  'community.redesign.actions.communicate.body': 'Komunikuj sie z zespolem w czasie rzeczywistym.',
  'community.redesign.more.heading': 'Rób wiecej z Boardly',
  'community.redesign.more.subtitle': 'Dopasuj aplikacje do swoich potrzeb przez integracje, automatyzacje i konfiguracje workflow.',
  'community.redesign.more.integrations.title': 'Integracje',
  'community.redesign.more.integrations.body': 'Lacz swoje ulubione narzedzia.',
  'community.redesign.more.automation.title': 'Automatyzacja',
  'community.redesign.more.automation.body': 'Ustaw automatyczne akcje.',
  'community.redesign.more.customization.title': 'Personalizacja',
  'community.redesign.more.customization.body': 'Dostosuj tablice do swoich potrzeb.',
  'community.redesign.more.mobile.title': 'Mobilnie',
  'community.redesign.more.mobile.body': 'Pracuj z jedna aplikacja w ruchu.',
  'community.redesign.signup.title': 'Zacznij z Boardly juz dzis',
  'community.redesign.signup.note': 'Podajac adres email, akceptuje warunki oraz',
  'community.redesign.signup.privacy': 'Polityke prywatnosci',
  'common.save': 'Zapisz',
  'common.cancel': 'Anuluj',
  'common.delete': 'Usuń',
  'common.search': 'Szukaj',
  'common.loading': 'Ładowanie...',
  'common.error': 'Wystąpił błąd',
  'common.actionFailed': 'Nie udało się wykonać akcji. Spróbuj ponownie.',
  'common.retry': 'Spróbuj ponownie',
  'common.close': 'Zamknij',
  'common.add': 'Dodaj',
  'common.assigned': 'Przypisano',
  'common.notAssigned': 'Nie przypisano',
  'common.create': 'Utwórz',
  'common.update': 'Aktualizuj',
  'common.copyLink': 'Kopiuj link',
  'common.share': 'Udostępnij',
  'common.clear': 'Wyczyść',
  'common.noConnection': 'Brak połączenia',
  'common.saving': 'Zapisywanie...',
  'common.unknown': 'nieznane',
  'common.linkCopied': 'Link skopiowany',
  'common.copySuffix': ' (kopia)',
  'common.copy': 'Kopiuj',
  'common.copying': 'Kopiowanie...',
  'common.edit': 'Edytuj',
  'common.creating': 'Tworzenie...',
  'common.confirmDelete': 'Usunąć?',
  'common.redirecting': 'Przekierowanie...',
  'common.or': 'lub',
  'auth.welcome': 'Witamy',
  'auth.createAccount': 'Utwórz konto',
  'auth.joinBoardly': 'Dołącz do Boardly i zarządzaj zadaniami skutecznie.',
  'auth.enterDetails': 'Wprowadź dane, aby się zalogować.',
  'auth.firstName': 'Imię',
  'auth.lastName': 'Nazwisko',
  'auth.email': 'Email',
  'auth.username': 'Nazwa użytkownika',
  'auth.password': 'Hasło',
  'auth.placeholderFirstName': 'Jan',
  'auth.placeholderLastName': 'Kowalski',
  'auth.placeholderUsername': 'Twoja nazwa',
  'auth.placeholderPassword': '********',
  'auth.forgotPassword': 'Nie pamiętasz hasła?',
  'auth.processing': 'Przetwarzanie...',
  'auth.signUp': 'Zarejestruj się',
  'auth.signIn': 'Zaloguj się',
  'auth.hasAccount': 'Masz już konto?',
  'auth.noAccount': 'Nie masz konta?',
  'auth.googleError': 'Nie udało się zalogować przez Google.',
  'auth.loginError': 'Błąd autoryzacji.',
  'auth.registerSuccessTitle': 'Rejestracja zakończona!',
  'auth.registerSuccessHint': 'Wysłaliśmy e-mail potwierdzający na {email}. Sprawdź skrzynkę.',
  'auth.backToLogin': 'Wróć do logowania',
  'auth.organizationOptional': 'Organizacja (opcjonalnie)',
  'auth.usernameOrEmail': 'Login lub email',
  'auth.policyPrefix': 'Akceptuję',
  'auth.policyLink': 'politykę prywatności',
  'auth.googleSignIn': 'Zaloguj przez Google',
  'auth.invalidEmail': 'Nieprawidłowy email.',
  'auth.passwordTooShort': 'Hasło musi mieć co najmniej {min} znaków.',
  'auth.policyRequired': 'Zaakceptuj politykę prywatności.',
  'activation.loadingTitle': 'Aktywacja konta...',
  'activation.loadingHint': 'Proszę czekać.',
  'activation.successTitle': 'Konto aktywowane! 🎉',
  'activation.successHint': 'Możesz się teraz zalogować.',
  'activation.signIn': 'Zaloguj się',
  'activation.errorTitle': 'Błąd aktywacji',
  'activation.errorHint': 'Link jest nieprawidłowy lub wygasł.',
  'activation.back': 'Wróć',
  'auth.preview.todoTitle': 'Do zrobienia',
  'auth.preview.todoCard': 'Projekt strony logowania',
  'auth.preview.progressTitle': 'W trakcie',
  'auth.preview.progressCard': 'Zaimplementować drag & drop',
  'auth.preview.doneTitle': 'Gotowe',
  'auth.preview.doneCard': 'Tworzenie tablicy',
  'passwordReset.title': 'Resetowanie hasła',
  'passwordReset.description': 'Wprowadź swój email, a wyślemy link do odzyskania dostępu.',
  'passwordReset.successTitle': 'Wysłano email!',
  'passwordReset.successHint': 'Sprawdź skrzynkę (lub konsolę Django), aby znaleźć link resetu.',
  'passwordReset.successDetail': 'Wysłaliśmy instrukcje na {email}. Sprawdź skrzynkę i spam.',
  'passwordReset.backToLogin': 'Wróć do logowania',
  'passwordReset.emailLabel': 'Email',
  'passwordReset.emailPlaceholder': 'name@example.com',
  'passwordReset.submit': 'Zresetuj hasło',
  'passwordReset.sending': 'Wysyłanie...',
  'passwordReset.remembered': 'Pamiętam hasło',
  'passwordReset.error': 'Nie znaleziono użytkownika z tym emailem lub wystąpił błąd.',
  'resetConfirm.title': 'Nowe hasło',
  'resetConfirm.description': 'Utwórz nowe, silne hasło do swojego konta.',
  'resetConfirm.successTitle': 'Sukces!',
  'resetConfirm.successHint': 'Hasło zostało zmienione. Za chwilę nastąpi przekierowanie do logowania...',
  'resetConfirm.successAction': 'Zaloguj się nowym hasłem',
  'resetConfirm.newPasswordLabel': 'Nowe hasło',
  'resetConfirm.newPasswordPlaceholder': 'Minimum 8 znaków',
  'resetConfirm.confirmPasswordLabel': 'Potwierdź hasło',
  'resetConfirm.confirmPasswordPlaceholder': 'Powtórz hasło',
  'resetConfirm.submit': 'Zmień hasło',
  'resetConfirm.saving': 'Zapisywanie...',
  'resetConfirm.errorMismatch': 'Hasła nie są takie same',
  'resetConfirm.errorPassword': 'Hasło: {message}',
  'resetConfirm.errorInvalidLink': 'Link resetu jest nieprawidłowy lub wygasł.',
  'resetConfirm.errorUnknown': 'Wystąpił nieznany błąd. Spróbuj ponownie.',
  'lang.uk': 'Ukraiński',
  'lang.en': 'Angielski',
  'lang.pl': 'Polski',
  'lang.de': 'Niemiecki',
  'lang.fr': 'Francuski',
  'lang.es': 'Hiszpański',
  'board.archive': 'Zarchiwizuj tablicę',
  'board.archiveConfirm': 'Zarchiwizować tablicę?',
  'board.archivedSuffix': '(archiwum)',
  'board.create.newButton': '+ Nowa tablica',
  'board.create.titlePlaceholder': 'Nazwa tablicy',
  'board.create.titleLabel': 'Nazwa tablicy',
  'board.create.titleInputPlaceholder': 'Wpisz nazwę...',
  'board.empty.title': 'Utwórz pierwszą tablicę',
  'board.empty.subtitle': 'Dodaj tablicę, aby zacząć.',
  'board.menu': 'Menu tablicy',
  'board.menu.changeBackground': 'Zmień tło',
  'board.menu.members': 'Uczestnicy',
  'board.menu.archived': 'Zarchiwizowane elementy',
  'board.menu.inviteTitle': 'Zaproś',
  'board.account.title': 'Konto',
  'board.account.changeAccount': 'Zmień konto',
  'board.account.profile': 'Profil',
  'board.account.settings': 'Ustawienia',
  'board.account.backgrounds': 'Tła',
  'board.account.logout': 'Wyloguj się',
  'board.filters': 'Filtry',
  'board.select.title': 'Wybierz tablice',
  'board.settings': 'Ustawienia tablicy',
  'board.error.loadDetails': 'Nie udało się wczytać szczegółów tablicy.',
  'board.unarchive': 'Przywróć tablicę',
  'board.unarchiveConfirm': 'Przywrócić tablicę?',
  'board.deleteConfirm': 'Usunąć tablicę?',
  'board.delete': 'Usuń tablicę',
  'board.leave': 'Opuść tablicę',
  'board.joining': 'Dołączanie do tablicy...',
  'board.background.title': 'Tło tablicy',
  'board.background.upload': 'Prześlij obraz',
  'board.background.reset': 'Resetuj',
  'board.background.apply': 'Zastosuj',
  'board.background.urlPlaceholder': 'Wklej URL obrazu...',
  'board.background.colorSelected': 'Wybrany kolor',
  'board.background.gradientSelected': 'Wybrany gradient',
  'board.background.imageSelected': 'Wybrany obraz',
  'board.background.invalidFile': 'Wybierz plik graficzny.',
  'board.background.tooLarge': 'Plik jest za duży (maks {size} MB).',
  'board.background.uploadHint': 'PNG, JPG - do 5 MB - minimum 1920 na 1080',
  'board.background.colors': 'Kolory',
  'board.background.gradients': 'Gradienty',
  'board.background.images': 'Obrazy',
  'board.background.default': 'Domyślne',
  'board.background.slate': 'Łupek',
  'board.background.charcoal': 'Węgiel',
  'board.background.indigo': 'Indygo',
  'board.background.emerald': 'Szmaragd',
  'board.background.warmLight': 'Ciepły jasny',
  'board.background.gradient.sunset': 'Zachód',
  'board.background.gradient.ocean': 'Ocean',
  'board.background.gradient.forest': 'Las',
  'board.background.gradient.blush': 'Rumieniec',
  'board.background.gradient.night': 'Noc',
  'board.background.gradient.dawn': 'Świt',
  'toolbar.searchPlaceholder': 'Szukaj na tablicy',
  'toolbar.actions': 'Akcje tablicy',
  'toolbar.matches': 'dopasowań',
  'toolbar.noMatches': 'Brak wyników',
  'filters.title': 'Filtry',
  'filters.membersLabel': 'Uczestnicy',
  'filters.membersAll': 'Wszyscy uczestnicy',
  'filters.labelsLabel': 'Etykiety',
  'filters.labelsAll': 'Wszystkie etykiety',
  'filters.dueLabel': 'Termin',
  'filters.dueAny': 'Dowolny termin',
  'filters.dueOverdue': 'Przeterminowane',
  'filters.dueToday': 'Na dziś',
  'filters.dueWeek': 'Na ten tydzień',
  'filters.dueNone': 'Bez terminu',
  'filters.completedLabel': 'Status',
  'filters.completedAll': 'Wszystkie',
  'filters.completedOnly': 'Zakończone',
  'filters.incompleteOnly': 'Niezakończone',
  'filters.reset': 'Resetuj',
  'filters.apply': 'Zastosuj',
  'archive.cards': 'Zarchiwizowane karty',
  'archive.lists': 'Zarchiwizowane listy',
  'archive.showCards': 'Pokaż zarchiwizowane karty',
  'archive.hideCards': 'Ukryj zarchiwizowane karty',
  'archive.showLists': 'Pokaż zarchiwizowane listy',
  'archive.hideLists': 'Ukryj zarchiwizowane listy',
  'archive.badge': 'Archiwum',
  'list.addButton': '+ Dodaj listę',
  'list.create.placeholder': 'Nazwa listy',
  'list.create.submit': 'Utwórz listę',
  'list.empty.noneTitle': 'Brak list',
  'list.empty.noneSubtitle': 'Utwórz pierwszą listę, aby dodawać karty.',
  'list.empty.archivedTitle': 'Listy w archiwum',
  'list.empty.archivedSubtitle': 'Włącz widok archiwum, aby je zobaczyć.',
  'list.empty.showArchived': 'Pokaż zarchiwizowane listy',
  'list.menu': 'Menu listy',
  'list.menu.addCard': 'Dodaj kartę',
  'list.menu.move': 'Przenieś listę',
  'list.menu.moveAll': 'Przenieś wszystkie karty z tej listy',
  'list.menu.sort': 'Sortuj według...',
  'list.menu.subscribe': 'Subskrybuj',
  'list.menu.unsubscribe': 'Anuluj subskrypcję',
  'list.menu.movePrompt': 'Wpisz nową pozycję listy',
  'list.menu.moveAllPrompt': 'Podaj ID listy docelowej dla wszystkich kart',
  'list.menu.sortPrompt': 'Wybierz sortowanie',
  'list.menu.sortByDue': 'Według terminu',
  'list.menu.sortByTitle': 'Według nazwy',
  'list.menu.comingSoon': 'Wkrótce dostępne',
  'list.menu.automation': 'Automatyzacja',
  'list.menu.automationAdd': 'Gdy karta zostanie dodana do listy...',
  'list.menu.automationDaily': 'Codziennie, sortuj według...',
  'list.menu.automationRule': 'Utwórz regułę',
  'list.menu.archiveAllCards': 'Archiwizuj wszystkie karty z tej listy',
  'list.menu.devCanAddCards': 'Developer może dodawać karty',
  'list.menu.devCannotAddCards': 'Developer nie może dodawać kart',
  'list.rename': 'Zmień nazwę',
  'list.copy': 'Kopiuj listę',
    'list.archive': 'Zarchiwizuj listę',
    'list.unarchive': 'Przywróć listę',
    'list.color.title': 'Zmień kolor',
    'list.color.none': 'Bez koloru',
    'list.collapse': 'Zwiń',
  'list.moveLeft': 'Przesuń w lewo',
  'list.moveRight': 'Przesuń w prawo',
  'list.position': 'Pozycja',
  'list.archiveConfirm': 'Zarchiwizować listę?',
  'list.archiveAllCardsConfirm': 'Zarchiwizować wszystkie karty na tej liście?',
  'list.unarchiveConfirm': 'Przywrócić listę?',
  'card.create.newButton': '+ Nowa karta',
  'card.create.placeholder': 'Tytuł karty...',
  'card.descriptionPlaceholder': 'Dodaj opis',
  'card.descriptionTitle': 'Opis',
  'card.descriptionEmpty': 'Brak opisu.',
  'card.dueDate': 'Termin',
  'card.dueDateRemove': 'Usuń termin',
  'card.dueDatePreview': 'Wybrano: {date}',
  'card.dueDateRequired': 'Wybierz datę terminu',
  'card.empty': 'Brak kart',
  'card.menu': 'Menu karty',
  'card.menu.move': 'Przenieś',
  'card.menu.copy': 'Kopiuj',
  'card.menu.share': 'Udostępnij',
  'card.menu.mirror': 'Lustro',
  'card.menu.template': 'Utwórz szablon',
  'card.menu.subscribe': 'Subskrybuj',
  'card.menu.copyLinkPrompt': 'Skopiuj ten link ręcznie',
  'card.menu.archive': 'Archiwizuj',
  'card.menu.delete': 'Usuń',
  'card.move.title': 'Przenieś kartę',
  'card.move.list': 'Lista',
  'card.move.position': 'Pozycja',
  'card.move.button': 'Przenieś',
  'card.moveToList': 'Przenieś do listy',
  'card.copy': 'Kopiuj kartę',
  'card.archive': 'Zarchiwizuj',
  'card.unarchive': 'Przywróć',
  'card.inList': 'Na liście',
  'card.members': 'Wykonawcy',
  'card.completedBadge': 'WYKONANO',
  'card.private': 'Karta prywatna',
  'card.overdue.days': '(Opóźnione o {count} dni)',
  'card.overdue.hours': '(Opóźnione o {count} godz.)',
  'card.overdue.minutes': '(Opóźnione o {count} min)',
  'card.moveUp': 'Przenieś w górę',
  'card.moveDown': 'Przenieś w dół',
  'card.moveLeft': 'Przenieś w lewo',
  'card.moveRight': 'Przenieś w prawo',
  'card.sidebar.participation': 'Udział',
  'card.sidebar.join': 'Dołącz',
  'card.sidebar.leave': 'Opuść',
  'card.joinError': 'Nie udało się dołączyć do karty.',
  'card.sidebar.add': 'Dodaj',
  'card.sidebar.actions': 'Akcje',
  'card.cover.title': 'Okładka',
  'card.cover.remove': 'Usuń okładkę',
  'card.colorTitle': 'Kolor karty',
  'card.colorHint': 'Wybierz kolor lub przywróć domyślny.',
  'card.color.none': 'Bez koloru',
  'card.color.sun': 'Słońce',
  'card.color.rose': 'Róż',
  'card.color.sky': 'Niebo',
  'card.color.violet': 'Fiolet',
  'card.color.emerald': 'Szmaragd',
  'card.color.teal': 'Turkus',
  'card.color.slate': 'Łupek',
  'card.quick.add': 'Dodaj',
  'card.quick.addHint': 'Dodaj przez panel po prawej',
  'card.quick.dates': 'Daty',
  'card.quick.checklist': 'Lista kontrolna',
    'card.quick.attach': 'Załącznik',
    'card.quick.members': 'Uczestnicy',
    'card.quick.comingSoon': 'Wkrótce',
    'card.watch': 'Obserwuj',
    'card.add.title': 'Dodaj do karty',
    'card.add.labels': 'Etykiety',
    'card.add.labelsHint': 'Przewiń do etykiet poniżej',
    'card.add.dates': 'Daty',
    'card.add.checklist': 'Lista kontrolna',
    'card.add.members': 'Uczestnicy',
    'card.add.attachments': 'Załączniki',
    'card.cover.size': 'Rozmiar',
    'card.cover.size.full': 'Pełny',
    'card.cover.size.header': 'Nagłówek',
    'card.cover.colors': 'Kolory',
    'card.cover.colorblind': 'Włącz tryb daltonizmu',
    'card.cover.colorblind.enable': 'Włącz tryb daltonizmu',
    'card.cover.colorblind.disable': 'Wyłącz tryb daltonizmu',
    'checklist.title': 'Lista kontrolna',
  'checklist.titlePlaceholder': 'Nazwa listy kontrolnej',
  'checklist.itemPlaceholder': 'Nowe zadanie',
  'checklist.add': 'Dodaj listę',
  'checklist.hint': 'Lista zapisuje się automatycznie po dodaniu elementów.',
  'checklist.empty': 'Lista kontrolna nie została utworzona.',
  'checklist.copy.title': 'Kopiuj podzadania',
  'checklist.copy.selectCard': 'Wybierz kartę',
  'checklist.createPopoverTitle': 'Dodaj listę',
  'checklist.nameLabel': 'Nazwa',
  'checklist.copy.fromLabel': 'Kopiuj element z...',
  'checklist.copy.none': 'Brak',
  'checklist.copy.emptySource': 'Wybrana karta nie ma podzadań do skopiowania.',
  'checklist.copy.append': 'Dodaj na koniec',
  'checklist.copy.replace': 'Zastąp wszystkie',
  'attachments.title': 'Załączniki',
  'attachments.empty': 'Brak załączników.',
  'attachments.add': 'Dodaj plik',
  'comments.title': 'Komentarze',
  'comments.activityTitle': 'Komentarze i aktywność',
  'comments.showDetails': 'Pokaż szczegóły',
  'comments.hideDetails': 'Ukryj szczegóły',
  'comments.empty': 'Brak komentarzy.',
  'comments.add': 'Dodaj komentarz',
  'comments.answer': 'Odpowiedz',
  'comments.send': 'Wyślij',
  'comments.react': 'Reakcja',
  'comments.addReaction': 'Dodaj reakcję',
  'comments.reactionPicker': 'Wybór emoji',
  'comment.placeholder': 'Napisz komentarz...',
  'labels.title': 'Etykiety',
  'labels.empty': 'Brak etykiet.',
  'labels.newPlaceholder': 'Nowa etykieta',
  'labels.add': 'Dodaj etykietę',
  'labels.newPrompt': 'Nazwa nowej etykiety:',
  'labels.deleteConfirm': 'Usunąć tę etykietę? Zniknie ze wszystkich kart.',
  'labels.hint': 'Etykiety zapisują się po kliknięciu {action}.',
  'members.title': 'Uczestnicy',
  'members.modalTitle': 'Uczestnicy tablicy',
  'members.inviteTitle': 'Zaproś',
  'members.searchPlaceholder': 'Imię, nazwa użytkownika lub email',
  'members.addListTitle': 'Dodaj listę',
  'members.searchParticipants': 'Szukaj uczestników',
  'members.boardMembersTitle': 'Uczestnicy tablicy',
  'members.searching': 'Wyszukiwanie...',
  'members.refreshing': 'Aktualizowanie listy uczestników...',
  'members.empty': 'Nie znaleziono użytkowników.',
  'members.inviteEmail': 'Zaproś przez email',
  'members.adding': 'Dodawanie...',
  'members.removing': 'Usuwanie...',
  'members.roleOwner': 'Właściciel',
  'members.roleAdmin': 'Administrator',
  'members.roleMember': 'Uczestnik',
  'members.roleDeveloper': 'Developer',
  'members.roleViewer': 'Widz',
  'members.roleLabel': 'Rola',
  'members.permissionsHint': 'Tylko właściciel lub admin mogą dodawać uczestników.',
  'members.viewerCannotBeAssigned': 'Widzów nie można przypisywać do kart.',
  'members.shareAria': 'Udostępnij',
  'members.more': 'Jeszcze {count}',
  'members.viewActivity': 'Zobacz działania na tablicy',
  'members.makeAdmin': 'Ustaw jako administratora',
  'members.removeAdmin': 'Usuń uprawnienia administratora',
  'members.removeFromBoard': 'Usuń z tablicy',
  'members.workspaceParticipants': 'Uczestnicy obszaru roboczego',
  'members.guests': 'Goście',
  'members.activityTitle': 'Aktywność użytkownika: {name}',
  'members.activityEmpty': 'Brak aktywności na tej tablicy.',
  'permissions.title': 'Uprawnienia dewelopera',
  'permissions.devCreateCards': 'Deweloper może tworzyć karty',
  'permissions.devEditAssigned': 'Deweloper może edytować przypisane karty',
  'permissions.devArchiveAssigned': 'Deweloper może archiwizować przypisane karty',
  'permissions.devJoinCard': 'Deweloper może dołączać do cudzych kart',
  'permissions.devCreateLists': 'Deweloper może tworzyć listy',
  'hotkeys.hint': 'Skróty: Ctrl+K',
  'hotkeys.aria': 'Skróty klawiszowe',
  'command.title': 'Polecenia',
  'command.placeholder': 'Szukaj poleceń',
  'command.empty': 'Brak poleceń',
  'command.createCard': 'Utwórz kartę',
  'command.createList': 'Utwórz listę',
  'command.createBoard': 'Utwórz tablicę',
  'command.goProfile': 'Przejdź do profilu',
  'command.goMyCards': 'Przejdź do moich kart',
  'command.goFaq': 'Otwórz FAQ',
  'myCards.title': 'Moje karty',
  'myCards.loading': 'Ładujemy karty...',
  'myCards.loadError': 'Nie udało się załadować kart.',
  'myCards.emptyAssigned': 'Nie masz jeszcze przypisanych kart.',
  'myCards.emptyList': 'Brak kart do wyświetlenia.',
  'myCards.boardFallback': 'Tablica bez tytułu',
  'myCards.boardUnavailable': 'Tablica jest niedostępna.',
  'myCards.boardArchived': 'Tablica jest zarchiwizowana.',
  'landing.hero.line1': 'Zapisuj,',
  'landing.hero.line2': 'porządkuj',
  'landing.hero.line3': 'i wykonuj zadania',
  'landing.hero.line4': 'wszędzie.',
  'landing.copy.line1': 'Zostaw bałagan i chaos za sobą —',
  'landing.copy.line2': 'odblokuj swój potencjał i',
  'landing.copy.line3': 'zwiększ produktywność dzięki Boardly.',
  'landing.cta.openApp': 'Przejdź do tablic',
  'landing.cta.signUp': 'Zarejestruj się za darmo!',
  'faq.title': 'FAQ',
  'faq.q1': 'Jak utworzyć nową tablicę?',
  'faq.a1': 'Kliknij "+ Nowa tablica" na stronie tablic.',
  'faq.q2': 'Jak dodać listę?',
  'faq.a2': 'Kliknij "+ Dodaj listę" w pasku narzędzi tablicy.',
  'faq.q3': 'Jak zaprosić uczestników?',
  'faq.a3': 'Otwórz Udostępnij i dodaj osoby po nazwie lub emailu.',
  'faq.q4': 'Gdzie zobaczę moje karty?',
  'faq.a4': 'Otwórz Moje karty w górnym menu.',
  'profile.tabsLabel': 'Sekcje profilu',
  'profile.tabs.profile': 'Profil',
  'profile.tabs.activity': 'Aktywność',
  'profile.tabs.settings': 'Ustawienia',
  'profile.authRequiredTitle': 'Wymagane logowanie',
  'profile.authRequiredHint': 'Zaloguj się, aby zobaczyć profil.',
  'profile.avatarAlt': 'Avatar użytkownika',
  'profile.avatar.change': 'Zmień avatar',
  'profile.avatar.remove': 'Usuń avatar',
  'profile.sections.profile': 'Profil',
  'profile.sections.activity': 'Aktywność',
  'profile.sections.settings': 'Ustawienia',
  'profile.settings.subtitle': 'Zarządzaj ustawieniami konta',
  'profile.activity.subtitle': 'Śledź aktywność swoją i innych na swoich tablicach',
  'profile.settings.general': 'Ogólne',
  'profile.settings.language': 'Język',
  'profile.settings.clearCache': 'Wyczyść pamięć podręczną',
  'profile.settings.cacheDescription': 'Usuwa pamięć podręczną i dane tymczasowe',
  'profile.settings.notifications': 'Powiadomienia',
  'profile.settings.desktopNotifications': 'Powiadomienia Gmail',
  'profile.settings.assignedToTask': 'Przypisano do zadania',
  'profile.settings.dueDateApproaching': 'Zbliża się termin',
  'profile.settings.addedToBoard': 'Dodano do tablicy',
  'profile.settings.manageEmail': 'Zarządzaj preferencjami email',
  'profile.settings.appearance': 'Wygląd',
  'profile.settings.theme': 'Motyw',
  'profile.settings.dark': 'Ciemny',
  'profile.settings.light': 'Jasny',
  'profile.settings.defaultBoardView': 'Domyślny widok tablicy',
  'profile.settings.kanban': 'Kanban',
  'profile.settings.calendar': 'Kalendarz',
  'profile.settings.manageIntegrations': 'Zarządzaj integracjami',
  'profile.settings.security': 'Bezpieczeństwo',
  'profile.settings.twoFactor': 'Uwierzytelnianie dwuskładnikowe',
  'profile.settings.requireVerification': 'Wymagaj weryfikacji logowania',
  'profile.settings.additionalVerification': 'Dodatkowa weryfikacja email dla nowych logowań',
  'profile.settings.sessionTimeout': 'Limit czasu sesji',
  'profile.settings.sessionTimeout1h': 'Po 1 godzinie bezczynności',
  'profile.settings.saveChanges': 'Zapisz zmiany',
  'profile.settings.cacheCleared': 'Pamięć podręczna wyczyszczona',
  'profile.settings.comingSoon': 'Wkrótce',
  'profile.emailPrefs.title': 'Preferencje e-mail',
  'profile.emailPrefs.subtitle': 'Wybierz, jakie maile chcesz otrzymywać',
  'profile.emailPrefs.enableEmail': 'Powiadomienia e-mail',
  'profile.emailPrefs.assignedToTask': 'Przypisano do zadania',
  'profile.emailPrefs.dueDateApproaching': 'Zbliża się termin',
  'profile.emailPrefs.addedToBoard': 'Dodano do tablicy',
  'profile.integrations.title': 'Integracje',
  'profile.integrations.subtitle': 'Połącz usługi do pracy z Boardly',
  'profile.integrations.connect': 'Połącz',
  'profile.integrations.slack': 'Powiadomienia Slack i szybkie akcje',
  'profile.integrations.calendar': 'Synchronizacja terminów z kalendarzem',
  'profile.integrations.github': 'Połącz zadania z repozytoriami',
  'profile.fields.firstName': 'Imię',
  'profile.fields.lastName': 'Nazwisko',
  'profile.fields.organization': 'Organizacja',
  'profile.fields.nickname': 'Nazwa użytkownika',
  'profile.fields.theme': 'Motyw',
  'profile.fields.themeToggle': 'Przełącznik motywu',
  'profile.fields.language': 'Język',
  'profile.fields.emailNotifications': 'Powiadomienia email',
  'profile.notifications.on': 'Włączone',
  'profile.notifications.off': 'Wyłączone',
  'profile.theme.dark': 'Ciemny',
  'profile.theme.light': 'Jasny',
  'profile.saveSettings': 'Zapisz ustawienia',
  'profile.saving': 'Zapisywanie...',
  'profile.activity.empty': 'Na razie brak aktywności.',
  'profile.activity.loadMore': 'Załaduj więcej',
  'profile.activity.type': 'Typ: {type}',
  'profile.logoutAll': 'Wyloguj ze wszystkich urządzeń',
  'profile.logoutAllHint': 'Wkrótce',
  'profile.errors.requiredName': 'Imię i nazwisko są wymagane.',
  'profile.errors.saveFailed': 'Nie udało się zapisać profilu.',
  'profile.errors.imageOnly': 'Obsługiwane są tylko pliki graficzne.',
  'profile.errors.avatarUploadFailed': 'Nie udało się przesłać avatara.',
  'profile.errors.avatarRemoveFailed': 'Nie udało się usunąć avatara.',
  'profile.errors.activityLoad': 'Nie udało się załadować aktywności.',
  'profile.toast.saved': 'Profil zapisany',
  'profile.toast.avatarUpdated': 'Avatar zaktualizowany',
  'profile.toast.avatarRemoved': 'Avatar usunięty',
  'profile.time.justNow': 'przed chwilą',
  'profile.time.minutesAgo': '{count} min temu',
  'profile.time.hoursAgo': '{count} godz. temu',
  'profile.time.daysAgo': '{count} dni temu',
  'profile.tabs.privacy': 'Polityka prywatności',
  'profile.backToMain': 'Wróć na stronę główną',
  'profile.header.title': 'Ustawienia profilu',
  'profile.header.subtitle': 'Zarządzaj swoimi danymi osobowymi',
  'profile.privacy.title': 'Polityka prywatności profilu',
  'profile.privacy.subtitle': 'Chroń swoje dane osobowe',
  'profile.section.personalInfo': 'Dane osobowe',
  'profile.section.passwordChange': 'Zmiana hasła',
  'profile.section.workInfo': 'Informacje o pracy',
  'profile.section.access': 'Dostęp',
  'profile.fields.email': 'Email',
  'profile.fields.currentPassword': 'Aktualne hasło',
  'profile.fields.bio': 'O mnie',
  'profile.fields.public': 'Publiczne',
  'profile.placeholders.organization': 'Rola / Firma',
  'profile.placeholders.bio': 'Powiedz coś o sobie',
  'profile.actions.changePassword': 'Zmień hasło',
  'profile.actions.deactivate': 'Dezaktywuj konto',
  'profile.userFallback': 'Użytkownik',
  'profile.confirmDelete': 'Czy na pewno chcesz usunąć konto? Tego działania nie można cofnąć.',
  'profile.deactivate.title': '!UWAGA!',
  'profile.deactivate.message': 'Tego działania nie można cofnąć. Czy na pewno chcesz dezaktywować konto?',
  'profile.deactivate.confirm': 'Dezaktywuj',
  'profile.deactivate.close': 'Zamknij',
  'activity.context.onBoard': 'na tablicy {board}',
  'activity.context.toList': 'do {list}',
  'activity.context.fromList': 'z {list}',
  'activity.context.inList': 'w {list}',
  'activity.context.inChecklist': 'w checkliście {checklist}',
  'activity.context.onCard': 'na karcie {card}',
  'activity.noDate': 'bez daty',
  'activity.create_board': '{actor} utworzył(a) tablicę {board}',
  'activity.rename_board': '{actor} zmienił(a) nazwę tablicy {board}',
  'activity.update_board': '{actor} zaktualizował(a) tablicę {board}',
  'activity.archive_board': '{actor} zarchiwizował(a) tablicę {board}',
  'activity.unarchive_board': '{actor} przywrócił(a) tablicę {board}',
  'activity.create_list': '{actor} dodał(a) listę {list}{context}',
  'activity.rename_list': '{actor} zmienił(a) nazwę listy {list}',
  'activity.move_list': '{actor} przeniósł(a) listę {list}{context}',
  'activity.archive_list': '{actor} zarchiwizował(a) listę {list}',
  'activity.unarchive_list': '{actor} przywrócił(a) listę {list}',
  'activity.copy_list': '{actor} skopiował(a) listę {source} → {target}',
  'activity.create_card': '{actor} dodał(a) kartę {card}{context}',
  'activity.move_card': '{actor} przeniósł(a) kartę {card}{from}{to}',
  'activity.archive_card': '{actor} zarchiwizował(a) kartę {card}{context}',
  'activity.unarchive_card': '{actor} przywrócił(a) kartę {card}{context}',
  'activity.update_card': '{actor} zaktualizował(a) kartę {card}',
  'activity.update_card_description': '{actor} zaktualizował(a) opis karty {card}',
  'activity.update_card_due_date': '{actor} zmienił(a) termin karty {card} z {before} na {after}',
  'activity.copy_card': '{actor} skopiował(a) kartę {source} → {target}',
  'activity.complete_card': 'Użytkownik {actor} oznaczył tę kartę jako ukończoną',
  'activity.uncomplete_card': 'Użytkownik {actor} cofnął oznaczenie ukończenia tej karty',
  'activity.checklist.unchecked': '{actor} oznaczył(a) {item} jako niewykonane{checklist}{card}',
  'activity.checklist.checked': '{actor} oznaczył(a) {item} jako wykonane{checklist}{card}',
  'activity.add_checklist_item': '{actor} dodał(a) podzadanie {item}{checklist}{card}',
  'activity.update_checklist_item': '{actor} zaktualizował(a) podzadanie {item}{checklist}{card}',
  'activity.add_comment': '{actor} dodał(a) komentarz {comment}{card}',
  'activity.labels.added': 'dodał(a) etykiety: {labels}',
  'activity.labels.removed': 'usunął(ęła) etykiety: {labels}',
  'activity.labels.updated': 'zaktualizował(a) etykiety',
  'activity.update_card_labels': '{actor} {changes} dla karty {card}',
  'activity.create_label': '{actor} utworzył(a) etykietę {label}{context}',
  'activity.update_label': '{actor} zaktualizował(a) etykietę {label}{context}',
  'activity.delete_label': '{actor} usunął(ęła) etykietę {label}{context}',
  'activity.update_profile': '{actor} zaktualizował(a) profil',
  'activity.update_avatar': '{actor} zaktualizował(a) avatar',
  'activity.remove_avatar': '{actor} usunął(ęła) avatar',
  'activity.default': '{actor} wykonał(a) działanie {target}',
  'privacy.summaryTitle': 'Niniejsza polityka prywatności ma pomóc Ci zrozumieć:',
  'privacy.body.p1': 'Your privacy matters to us. This privacy policy explains how Boardly, and our corporate affiliates collect, use, share, and protect your information when you use our products, services, websites, or otherwise interact with us. We offer a wide range of products, including our cloud and software products. We refer to all of these products, together with our other services and websites, as "Services" in this privacy policy.',
  'privacy.body.p2': 'This privacy policy also explains your choices surrounding how we use information about you, including how you can object to certain uses and how you can access and update certain information. If you do not agree with this privacy policy, do not access or use our Services.',
  'privacy.footer.accessibility': 'Dostępność',
  'privacy.footer.choices': 'Twoje wybory prywatności',
  'privacy.footer.policy': 'Polityka prywatności',
  'privacy.footer.terms': 'Warunki',
  'privacy.footer.data': 'Dane wyjściowe',
  'privacy.footer.security': 'Bezpieczeństwo',
  'errors.boardUpdate': 'Nie udało się zaktualizować tablicy: {message}',
  'errors.listsLoad': 'Nie udało się załadować list: {message}',
  'errors.cardsLoad': 'Nie udało się załadować kart: {message}',
  'confirm.deleteCard': 'Usunąć tę kartę?',
  'prompt.copyLink': 'Skopiuj ten link:',
  'toast.membersUpdateFailed': 'Nie udało się odświeżyć uczestników.',
  'toast.cardsReloadFailed': 'Nie udało się odświeżyć kart.',
  'toast.joinFailed': 'Nie udało się dołączyć do tablicy.',
  'toast.checklistSaveFailed': 'Nie udało się zapisać listy kontrolnej.',
  'toast.checklistDeleteFailed': 'Nie udało się usunąć listy kontrolnej.',
  'toast.checklistItemAddFailed': 'Nie udało się dodać elementu listy.',
  'toast.labelCreateFailed': 'Nie udało się utworzyć etykiety.',
  'toast.commentAddFailed': 'Nie udało się dodać komentarza.',
  'toast.commentDeleteFailed': 'Nie udało się usunąć komentarza.',
  'toast.attachmentAdded': 'Załącznik dodany',
  'toast.attachmentAddFailed': 'Nie udało się dodać załącznika.',
  'toast.attachmentDeleteFailed': 'Nie udało się usunąć załącznika.',
  'toast.memberAddFailed': 'Nie udało się dodać uczestnika.',
  'toast.memberRoleFailed': 'Nie udało się zmienić roli.',
  'toast.memberRemoveFailed': 'Nie udało się usunąć uczestnika.',
  'toast.inviteUnavailable': 'Link zaproszenia jest niedostępny.',
  'toast.cardSaveFailed': 'Nie udało się zapisać karty.',
  'toast.cardCopied': 'Karta skopiowana',
  'toast.cardCopyFailed': 'Nie udało się skopiować karty.',
  'toast.listCopied': 'Lista skopiowana',
  'toast.listCopying': 'Kopiowanie listy...',
  'toast.listCopyFailed': 'Nie udało się skopiować listy.',
  'toast.listMoveFailed': 'Nie udało się przenieść listy.',
  'toast.cardCreateFailed': 'Nie udało się utworzyć karty.',
  'toast.cardMoveFailed': 'Nie udało się przenieść karty.',
  'toast.cardDeleteFailed': 'Nie udało się usunąć karty.',
  'toast.cardArchiveFailed': 'Nie udało się zaktualizować archiwizacji karty.',
  'toast.boardCreateFailed': 'Nie udało się utworzyć tablicy.',
  'toast.boardUpdateFailed': 'Nie udało się zaktualizować tablicy.',
  'toast.boardArchiveFailed': 'Nie udało się zaktualizować archiwizacji tablicy.',
  'toast.listArchiveFailed': 'Nie udało się zaktualizować archiwizacji listy.',
  'toast.listCreateFailed': 'Nie udało się utworzyć listy.',
  'toast.listRenameFailed': 'Nie udało się zmienić nazwy listy.',
};

translations.de = {
  ...baseEn,
  'nav.board': 'Board',
  'nav.myCards': 'Meine Karten',
  'nav.profile': 'Profil',
  'nav.faq': 'FAQ',
  'nav.help': 'Hilfe',
  'nav.community': 'Community',
  'nav.logout': 'Abmelden',
  'nav.greeting': 'Hallo, {name}',
  'nav.menu': 'Menü',
  'nav.language': 'Sprache',
  'help.title': 'Wie können wir helfen?',
  'help.subtitle': 'Finde Antworten in den Support-Ressourcen von Boardly.',
  'help.featured.title': 'Ausgewählte Inhalte',
  'help.featured.item1': 'Was sind Berechtigungsschemata in Boardly?',
  'help.featured.item2': 'Steuere, wie Nutzer Zugriff auf Apps erhalten',
  'help.featured.item3': 'Atlassian-Konto-E-Mail-Adressen ändern',
  'help.featured.item4': 'Verwaltetes Konto deaktivieren',
  'help.featured.item5': 'Domain verifizieren, um Konten zu verwalten',
  'help.featured.item6': 'SAML Single Sign-on mit einem Identity Provider konfigurieren',
  'help.featured.item7': 'Nutzern Admin-Berechtigungen geben',
  'help.featured.item8': 'User Provisioning verstehen',
  'help.featured.item9': 'IP-Adressen und Domains für Boardly-Cloud-Apps',
  'help.resources.title': 'Ressourcen durchsuchen',
  'help.resources.community.title': 'Community',
  'help.resources.community.body': 'Finde Antworten, Support und Inspiration von anderen Boardly-Nutzern.',
  'help.resources.community.link': 'Boardly Community besuchen',
  'help.resources.status.title': 'Systemstatus',
  'help.resources.status.body': 'Überprüfe den Status unserer Cloud-Apps und Services.',
  'help.resources.status.link': 'Systemstatus anzeigen',
  'help.resources.suggestions.title': 'Vorschläge und Bug-Reports',
  'help.resources.suggestions.body': 'Sieh dir bestehende Feature-Vorschläge und Bug-Reports an.',
  'help.resources.suggestions.link': 'Vorschläge und Bugs ansehen',
  'help.resources.marketplace.title': 'Marketplace-Apps',
  'help.resources.marketplace.body': 'Finde Funktionen, um deine Apps anzupassen.',
  'help.resources.marketplace.link': 'Marketplace ansehen',
  'help.resources.billing.title': 'Abrechnung und Lizenzierung',
  'help.resources.billing.body': 'Sieh dir FAQs zu Abrechnung und Lizenzierung an.',
  'help.resources.billing.link': 'FAQs ansehen',
  'help.resources.training.title': 'Training und Zertifizierung',
  'help.resources.training.body': 'Entwickle neue Skills, verbessere die Arbeit deines Teams und deine Karriere.',
  'help.resources.training.link': 'Training ansehen',
  'help.resources.developers.title': 'Entwickler',
  'help.resources.developers.body': 'API-Dokumentation und Guides für Apps und Integrationen.',
  'help.resources.developers.link': 'Developer Docs ansehen',
  'help.resources.enterprise.title': 'Enterprise',
  'help.resources.enterprise.body': 'Erfahre mehr über Boardly Enterprise und Data-Center-Produkte.',
  'help.resources.enterprise.link': 'Enterprise-Dokumentation ansehen',
  'help.resources.government.title': 'Government Cloud Support',
  'help.resources.government.body': 'Technischer und Migrations-Support für Boardly Government-Projekte.',
  'help.resources.government.link': 'Anmelden, um Support zu kontaktieren',
  'help.resources.success.title': 'Success Central',
  'help.resources.success.body': 'Hilfe bei der Einführung mit Inhalten von Boardly und Partnern.',
  'help.resources.success.link': 'Success Central ansehen',
  'help.contact.title': 'Findest du nicht die Hilfe, die du brauchst?',
  'help.contact.button': 'Support kontaktieren',
  'help.footer.copyright': 'Copyright © 2026 Boardly',
  'help.footer.accessibility': 'Barrierefreiheit',
  'help.footer.privacyChoices': 'Deine Datenschutzoptionen',
  'help.footer.privacyPolicy': 'Datenschutzrichtlinie',
  'help.footer.terms': 'Nutzungsbedingungen',
  'help.footer.impressum': 'Impressum',
  'help.footer.security': 'Sicherheit',
  'community.title': 'Gestalte gemeinsam das beste Arbeitsleben',
  'community.subtitle': 'Lerne, vernetze dich und wachse mit der Boardly-Community.',
  'community.getStarted.title': 'Erste Schritte',
  'community.getStarted.link': 'Antworten finden',
  'community.getStarted.forums.title': 'Foren',
  'community.getStarted.forums.body': 'Stelle Fragen und erhalte Hilfe von Experten und Kollegen.',
  'community.getStarted.learning.title': 'Lernen',
  'community.getStarted.learning.body': 'Guides, Tutorials und Best Practices.',
  'community.getStarted.events.title': 'Events',
  'community.getStarted.events.body': 'Nimm an Sessions teil und triff die Community live.',
  'community.getStarted.champions.title': 'Champions',
  'community.getStarted.champions.body': 'Vernetze dich mit Power-Usern und Botschaftern.',
  'community.advice.title': 'Hol dir Rat und vernetze dich',
  'community.advice.body': 'Community-Foren sind ein großartiger Ort, um Antworten von Experten und Kollegen zu bekommen. Finde Lösungen oder stelle deine eigenen Fragen.',
  'community.back': 'Zurück',
  'community.kicker.forums': 'Community-Foren',
  'community.learning.title': 'Entwickle deine Skills mit flexiblem Lernen',
  'community.learning.body': 'Unsere kostenlosen On-Demand-Kurse helfen dir, Atlassian-Apps schneller zu lernen und effizienter zu arbeiten. Verbessere deine Kenntnisse mit Trainer-geführten Schulungen und Atlassian-Zertifizierungen.',
  'community.learning.longBody': 'Baue praxisnahe Expertise mit strukturierten Lernpfaden, realen Beispielen und bewährten Methoden auf. Von Grundlagen bis zu fortgeschrittenen Workflows helfen diese Inhalte deinem Team, Wissen schneller umzusetzen, die Zusammenarbeit zu verbessern und bessere Ergebnisse zu erzielen.',
  'community.redesign.hero.title': 'Organisiere Aufgaben und erledige sie von ueberall.',
  'community.redesign.hero.subtitle': 'Organisiere Projekte, steigere die Produktivitaet und arbeite mit unserer App noch effizienter.',
  'community.redesign.hero.cta': 'Kostenlos registrieren!',
  'community.redesign.preview.todo.title': 'Zu erledigen',
  'community.redesign.preview.todo.task1': 'Login-Seite gestalten',
  'community.redesign.preview.todo.task2': 'Task-Board erstellen',
  'community.redesign.preview.todo.task3': 'Benachrichtigungen einrichten',
  'community.redesign.preview.progress.title': 'In Arbeit',
  'community.redesign.preview.progress.task': 'Drag and drop umsetzen',
  'community.redesign.preview.done.title': 'Erledigt',
  'community.redesign.basicFunctions': 'Basisfunktionen',
  'community.redesign.sources.title': 'Quellen der Produktivitaet',
  'community.redesign.sources.subtitle': 'Arbeite effizienter mit Boards, Karten und Automatisierung, auch unterwegs.',
  'community.redesign.sources.imageAlt': 'Vorschau eines Task-Boards',
  'community.redesign.moveTasks.title': 'Aufgaben verschieben',
  'community.redesign.moveTasks.body': 'Verschiebe Aufgaben einfach per drag and drop.',
  'community.redesign.actions.heading': 'Von Nachrichten zu Aktionen',
  'community.redesign.actions.subtitle': 'Sammle wichtige Benachrichtigungen an einem Ort und verwandle sie in produktive Aufgaben.',
  'community.redesign.actions.messages.title': 'Deine Nachrichten aus Slack',
  'community.redesign.actions.messages.body': 'Mache aus eingehenden Nachrichten in Sekunden Aufgaben.',
  'community.redesign.actions.automation.title': 'Automatisierung nutzen',
  'community.redesign.actions.automation.body': 'Automatisiere Aufgaben mit intelligenten Empfehlungen.',
  'community.redesign.actions.communicate.title': 'Schnell kommunizieren',
  'community.redesign.actions.communicate.body': 'Kommuniziere mit deinem Team in Echtzeit.',
  'community.redesign.more.heading': 'Mehr mit Boardly erreichen',
  'community.redesign.more.subtitle': 'Passe die App mit Integrationen, Automatisierung und Workflow-Anpassung an deine Beduerfnisse an.',
  'community.redesign.more.integrations.title': 'Integrationen',
  'community.redesign.more.integrations.body': 'Verbinde deine wichtigsten Tools.',
  'community.redesign.more.automation.title': 'Automatisierung',
  'community.redesign.more.automation.body': 'Richte automatische Aktionen ein.',
  'community.redesign.more.customization.title': 'Anpassung',
  'community.redesign.more.customization.body': 'Passe Boards an deine Anforderungen an.',
  'community.redesign.more.mobile.title': 'Mobil',
  'community.redesign.more.mobile.body': 'Arbeite unterwegs mit nur einer App.',
  'community.redesign.signup.title': 'Starte noch heute mit Boardly',
  'community.redesign.signup.note': 'Mit Eingabe meiner E-Mail-Adresse akzeptiere ich die Bedingungen und die',
  'community.redesign.signup.privacy': 'Datenschutzrichtlinie',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.search': 'Suchen',
  'common.loading': 'Lädt...',
  'common.error': 'Etwas ist schiefgelaufen',
  'common.actionFailed': 'Aktion fehlgeschlagen. Bitte erneut versuchen.',
  'common.retry': 'Erneut versuchen',
  'common.close': 'Schließen',
  'common.add': 'Hinzufügen',
  'common.assigned': 'Zugewiesen',
  'common.notAssigned': 'Nicht zugewiesen',
  'common.create': 'Erstellen',
  'common.update': 'Aktualisieren',
  'common.copyLink': 'Link kopieren',
  'common.share': 'Teilen',
  'common.clear': 'Leeren',
  'common.noConnection': 'Keine Verbindung',
  'common.saving': 'Speichern...',
  'common.unknown': 'unbekannt',
  'common.linkCopied': 'Link kopiert',
  'common.copySuffix': ' (Kopie)',
  'common.copy': 'Kopieren',
  'common.copying': 'Kopieren...',
  'common.edit': 'Bearbeiten',
  'common.creating': 'Erstellen...',
  'common.confirmDelete': 'Löschen?',
  'common.redirecting': 'Weiterleitung...',
  'common.or': 'oder',
  'auth.welcome': 'Willkommen',
  'auth.createAccount': 'Konto erstellen',
  'auth.joinBoardly': 'Tritt Boardly bei und verwalte Aufgaben effizient.',
  'auth.enterDetails': 'Gib deine Daten ein, um dich anzumelden.',
  'auth.firstName': 'Vorname',
  'auth.lastName': 'Nachname',
  'auth.email': 'E-Mail',
  'auth.username': 'Benutzername',
  'auth.password': 'Passwort',
  'auth.placeholderFirstName': 'Max',
  'auth.placeholderLastName': 'Mustermann',
  'auth.placeholderUsername': 'Dein Benutzername',
  'auth.placeholderPassword': '********',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.processing': 'Verarbeitung...',
  'auth.signUp': 'Registrieren',
  'auth.signIn': 'Anmelden',
  'auth.hasAccount': 'Schon ein Konto?',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.googleError': 'Google-Anmeldung fehlgeschlagen.',
  'auth.loginError': 'Authentifizierung fehlgeschlagen.',
  'auth.registerSuccessTitle': 'Registrierung erfolgreich!',
  'auth.registerSuccessHint': 'Wir haben eine Bestätigungs-E-Mail an {email} gesendet. Bitte Posteingang prüfen.',
  'auth.backToLogin': 'Zur Anmeldung',
  'auth.organizationOptional': 'Organisation (optional)',
  'auth.usernameOrEmail': 'Benutzername oder E-Mail',
  'auth.policyPrefix': 'Ich stimme der',
  'auth.policyLink': 'Datenschutzerklärung',
  'auth.googleSignIn': 'Mit Google anmelden',
  'auth.invalidEmail': 'Ungültige E-Mail-Adresse.',
  'auth.passwordTooShort': 'Passwort muss mindestens {min} Zeichen haben.',
  'auth.policyRequired': 'Bitte stimme der Datenschutzerklärung zu.',
  'activation.loadingTitle': 'Konto wird aktiviert...',
  'activation.loadingHint': 'Bitte warten.',
  'activation.successTitle': 'Konto aktiviert! 🎉',
  'activation.successHint': 'Du kannst dich jetzt anmelden.',
  'activation.signIn': 'Anmelden',
  'activation.errorTitle': 'Aktivierung fehlgeschlagen',
  'activation.errorHint': 'Der Link ist ungültig oder abgelaufen.',
  'activation.back': 'Zurück',
  'auth.preview.todoTitle': 'Zu erledigen',
  'auth.preview.todoCard': 'Design der Login-Seite',
  'auth.preview.progressTitle': 'In Arbeit',
  'auth.preview.progressCard': 'Drag & Drop umsetzen',
  'auth.preview.doneTitle': 'Erledigt',
  'auth.preview.doneCard': 'Board-Erstellung',
  'passwordReset.title': 'Passwort zurücksetzen',
  'passwordReset.description': 'Gib deine E-Mail ein, wir senden dir einen Link zur Wiederherstellung.',
  'passwordReset.successTitle': 'E-Mail gesendet!',
  'passwordReset.successHint': 'Prüfe dein Postfach (oder die Django-Dev-Konsole) auf den Reset-Link.',
  'passwordReset.successDetail': 'Wir haben Anweisungen an {email} gesendet. Bitte Posteingang und Spam prüfen.',
  'passwordReset.backToLogin': 'Zur Anmeldung',
  'passwordReset.emailLabel': 'E-Mail',
  'passwordReset.emailPlaceholder': 'name@example.com',
  'passwordReset.submit': 'Passwort zurücksetzen',
  'passwordReset.sending': 'Senden...',
  'passwordReset.remembered': 'Ich erinnere mich an mein Passwort',
  'passwordReset.error': 'Wir konnten keinen Nutzer mit dieser E-Mail finden oder es ist ein Fehler aufgetreten.',
  'resetConfirm.title': 'Neues Passwort',
  'resetConfirm.description': 'Erstellen Sie ein neues, sicheres Passwort für Ihr Konto.',
  'resetConfirm.successTitle': 'Erfolgreich!',
  'resetConfirm.successHint': 'Dein Passwort wurde geändert. Weiterleitung zur Anmeldung...',
  'resetConfirm.successAction': 'Mit neuem Passwort anmelden',
  'resetConfirm.newPasswordLabel': 'Neues Passwort',
  'resetConfirm.newPasswordPlaceholder': 'Mindestens 8 Zeichen',
  'resetConfirm.confirmPasswordLabel': 'Passwort bestätigen',
  'resetConfirm.confirmPasswordPlaceholder': 'Passwort wiederholen',
  'resetConfirm.submit': 'Passwort ändern',
  'resetConfirm.saving': 'Speichern...',
  'resetConfirm.errorMismatch': 'Passwörter stimmen nicht überein',
  'resetConfirm.errorPassword': 'Passwort: {message}',
  'resetConfirm.errorInvalidLink': 'Der Reset-Link ist ungültig oder abgelaufen.',
  'resetConfirm.errorUnknown': 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
  'lang.uk': 'Ukrainisch',
  'lang.en': 'Englisch',
  'lang.pl': 'Polnisch',
  'lang.de': 'Deutsch',
  'lang.fr': 'Französisch',
  'lang.es': 'Spanisch',
  'board.archive': 'Board archivieren',
  'board.archiveConfirm': 'Dieses Board archivieren?',
  'board.archivedSuffix': '(archiviert)',
  'board.create.newButton': '+ Neues Board',
  'board.create.titlePlaceholder': 'Boardname',
  'board.create.titleLabel': 'Boardtitel',
  'board.create.titleInputPlaceholder': 'Titel eingeben...',
  'board.empty.title': 'Erstelle dein erstes Board',
  'board.empty.subtitle': 'Füge ein Board hinzu, um zu starten.',
  'board.menu': 'Board-Menü',
  'board.menu.changeBackground': 'Hintergrund ändern',
  'board.menu.members': 'Mitglieder',
  'board.menu.archived': 'Archivierte Elemente',
  'board.menu.inviteTitle': 'Einladen',
  'board.account.title': 'Konto',
  'board.account.changeAccount': 'Konto wechseln',
  'board.account.profile': 'Profil',
  'board.account.settings': 'Einstellungen',
  'board.account.backgrounds': 'Hintergründe',
  'board.account.logout': 'Abmelden',
  'board.filters': 'Filter',
  'board.select.title': 'Board auswählen',
  'board.settings': 'Board-Einstellungen',
  'board.error.loadDetails': 'Board-Details konnten nicht geladen werden.',
  'board.unarchive': 'Board wiederherstellen',
  'board.unarchiveConfirm': 'Dieses Board wiederherstellen?',
  'board.deleteConfirm': 'Board löschen?',
  'board.delete': 'Board löschen',
  'board.leave': 'Board verlassen',
  'board.joining': 'Board wird betreten...',
  'board.background.title': 'Board-Hintergrund',
  'board.background.upload': 'Bild hochladen',
  'board.background.reset': 'Zurücksetzen',
  'board.background.apply': 'Anwenden',
  'board.background.urlPlaceholder': 'Bild-URL einfügen...',
  'board.background.colorSelected': 'Farbe gewählt',
  'board.background.gradientSelected': 'Verlauf gewählt',
  'board.background.imageSelected': 'Bild gewählt',
  'board.background.invalidFile': 'Bitte eine Bilddatei auswählen.',
  'board.background.tooLarge': 'Datei ist zu groß (max. {size} MB).',
  'board.background.uploadHint': 'PNG, JPG - bis 5 MB - mindestens 1920 x 1080',
  'board.background.colors': 'Farben',
  'board.background.gradients': 'Verläufe',
  'board.background.images': 'Bilder',
  'board.background.default': 'Standard',
  'board.background.slate': 'Schiefer',
  'board.background.charcoal': 'Holzkohle',
  'board.background.indigo': 'Indigo',
  'board.background.emerald': 'Smaragd',
  'board.background.warmLight': 'Warm hell',
  'board.background.gradient.sunset': 'Sonnenuntergang',
  'board.background.gradient.ocean': 'Ozean',
  'board.background.gradient.forest': 'Wald',
  'board.background.gradient.blush': 'Rosa',
  'board.background.gradient.night': 'Nacht',
  'board.background.gradient.dawn': 'Morgendämmerung',
  'toolbar.searchPlaceholder': 'Dieses Board durchsuchen',
  'toolbar.actions': 'Board-Aktionen',
  'toolbar.matches': 'Treffer',
  'toolbar.noMatches': 'Keine Treffer',
  'filters.title': 'Filter',
  'filters.membersLabel': 'Mitglieder',
  'filters.membersAll': 'Alle Mitglieder',
  'filters.labelsLabel': 'Labels',
  'filters.labelsAll': 'Alle Labels',
  'filters.dueLabel': 'Fälligkeit',
  'filters.dueAny': 'Beliebiges Datum',
  'filters.dueOverdue': 'Überfällig',
  'filters.dueToday': 'Heute fällig',
  'filters.dueWeek': 'Diese Woche',
  'filters.dueNone': 'Kein Datum',
  'filters.completedLabel': 'Status',
  'filters.completedAll': 'Alle',
  'filters.completedOnly': 'Erledigt',
  'filters.incompleteOnly': 'Offen',
  'filters.reset': 'Zurücksetzen',
  'filters.apply': 'Anwenden',
  'archive.cards': 'Archivierte Karten',
  'archive.lists': 'Archivierte Listen',
  'archive.showCards': 'Archivierte Karten anzeigen',
  'archive.hideCards': 'Archivierte Karten ausblenden',
  'archive.showLists': 'Archivierte Listen anzeigen',
  'archive.hideLists': 'Archivierte Listen ausblenden',
  'archive.badge': 'Archiviert',
  'list.addButton': '+ Liste hinzufügen',
  'list.create.placeholder': 'Listenname',
  'list.create.submit': 'Liste erstellen',
  'list.empty.noneTitle': 'Noch keine Listen',
  'list.empty.noneSubtitle': 'Erstelle deine erste Liste, um Karten hinzuzufügen.',
  'list.empty.archivedTitle': 'Archivierte Listen',
  'list.empty.archivedSubtitle': 'Aktiviere die Archivansicht, um sie zu sehen.',
  'list.empty.showArchived': 'Archivierte Listen anzeigen',
  'list.menu': 'Listenmenü',
  'list.menu.addCard': 'Karte hinzufügen',
  'list.menu.move': 'Liste verschieben',
  'list.menu.moveAll': 'Alle Karten in dieser Liste verschieben',
  'list.menu.sort': 'Sortieren nach...',
  'list.menu.subscribe': 'Abonnieren',
  'list.menu.unsubscribe': 'Abo beenden',
  'list.menu.movePrompt': 'Neue Listenposition eingeben',
  'list.menu.moveAllPrompt': 'Ziel-Listen-ID für alle Karten eingeben',
  'list.menu.sortPrompt': 'Sortierung auswählen',
  'list.menu.sortByDue': 'Nach Fälligkeitsdatum',
  'list.menu.sortByTitle': 'Nach Titel',
  'list.menu.comingSoon': 'Demnächst verfügbar',
  'list.menu.automation': 'Automatisierung',
  'list.menu.automationAdd': 'Wenn eine Karte zur Liste hinzugefügt wird...',
  'list.menu.automationDaily': 'Jeden Tag nach ... sortieren',
  'list.menu.automationRule': 'Regel erstellen',
  'list.menu.archiveAllCards': 'Alle Karten in dieser Liste archivieren',
  'list.menu.devCanAddCards': 'Developer kann Karten hinzufügen',
  'list.menu.devCannotAddCards': 'Developer kann keine Karten hinzufügen',
  'list.rename': 'Umbenennen',
  'list.copy': 'Liste kopieren',
    'list.archive': 'Liste archivieren',
    'list.unarchive': 'Liste wiederherstellen',
    'list.color.title': 'Farbe ändern',
    'list.color.none': 'Keine Farbe',
    'list.collapse': 'Einklappen',
  'list.moveLeft': 'Nach links verschieben',
  'list.moveRight': 'Nach rechts verschieben',
  'list.position': 'Position',
  'list.archiveConfirm': 'Diese Liste archivieren?',
  'list.archiveAllCardsConfirm': 'Alle Karten in dieser Liste archivieren?',
  'list.unarchiveConfirm': 'Diese Liste wiederherstellen?',
  'card.create.newButton': '+ Neue Karte',
  'card.create.placeholder': 'Kartentitel...',
  'card.descriptionPlaceholder': 'Beschreibung hinzufügen',
  'card.descriptionTitle': 'Beschreibung',
  'card.descriptionEmpty': 'Keine Beschreibung.',
  'card.dueDate': 'Fälligkeitsdatum',
  'card.dueDateRemove': 'Fälligkeitsdatum entfernen',
  'card.dueDatePreview': 'Ausgewählt: {date}',
  'card.dueDateRequired': 'Bitte ein Fälligkeitsdatum wählen',
  'card.empty': 'Noch keine Karten',
  'card.menu': 'Kartenmenü',
  'card.menu.move': 'Verschieben',
  'card.menu.copy': 'Kopieren',
  'card.menu.share': 'Teilen',
  'card.menu.mirror': 'Spiegeln',
  'card.menu.template': 'Vorlage erstellen',
  'card.menu.subscribe': 'Abonnieren',
  'card.menu.copyLinkPrompt': 'Diesen Link manuell kopieren',
  'card.menu.archive': 'Archivieren',
  'card.menu.delete': 'Löschen',
  'card.move.title': 'Karte verschieben',
  'card.move.list': 'Liste',
  'card.move.position': 'Position',
  'card.move.button': 'Verschieben',
  'card.moveToList': 'In Liste verschieben',
  'card.copy': 'Karte kopieren',
  'card.archive': 'Archivieren',
  'card.unarchive': 'Wiederherstellen',
  'card.inList': 'In Liste',
  'card.members': 'Mitglieder',
  'card.completedBadge': 'ERLEDIGT',
  'card.private': 'Private Karte',
  'card.overdue.days': '(Überfällig um {count} T.)',
  'card.overdue.hours': '(Überfällig um {count} Std.)',
  'card.overdue.minutes': '(Überfällig um {count} Min.)',
  'card.moveUp': 'Nach oben verschieben',
  'card.moveDown': 'Nach unten verschieben',
  'card.moveLeft': 'Nach links verschieben',
  'card.moveRight': 'Nach rechts verschieben',
  'card.sidebar.participation': 'Beteiligung',
  'card.sidebar.join': 'Beitreten',
  'card.sidebar.leave': 'Verlassen',
  'card.joinError': 'Beitritt zur Karte fehlgeschlagen.',
  'card.sidebar.add': 'Hinzufügen',
  'card.sidebar.actions': 'Aktionen',
  'card.cover.title': 'Titelbild',
  'card.cover.remove': 'Titelbild entfernen',
  'card.colorTitle': 'Kartenfarbe',
  'card.colorHint': 'Wahle eine Farbe oder setze sie zuruck.',
  'card.color.none': 'Keine Farbe',
  'card.color.sun': 'Sonne',
  'card.color.rose': 'Rosa',
  'card.color.sky': 'Himmel',
  'card.color.violet': 'Violett',
  'card.color.emerald': 'Smaragd',
  'card.color.teal': 'Turkis',
  'card.color.slate': 'Schiefer',
  'card.quick.add': 'Hinzufügen',
  'card.quick.addHint': 'Über das rechte Panel hinzufügen',
  'card.quick.dates': 'Termine',
  'card.quick.checklist': 'Checkliste',
    'card.quick.attach': 'Anhang',
    'card.quick.members': 'Mitglieder',
    'card.quick.comingSoon': 'Demnächst verfügbar',
    'card.watch': 'Beobachten',
    'card.add.title': 'Zur Karte hinzufügen',
    'card.add.labels': 'Labels',
    'card.add.labelsHint': 'Scrollen Sie zu den Labels unten',
    'card.add.dates': 'Termine',
    'card.add.checklist': 'Checkliste',
    'card.add.members': 'Mitglieder',
    'card.add.attachments': 'Anhänge',
    'card.cover.size': 'Größe',
    'card.cover.size.full': 'Voll',
    'card.cover.size.header': 'Kopfzeile',
    'card.cover.colors': 'Farben',
    'card.cover.colorblind': 'Farbenblind-Modus aktivieren',
    'card.cover.colorblind.enable': 'Farbenblind-Modus aktivieren',
    'card.cover.colorblind.disable': 'Farbenblind-Modus deaktivieren',
    'checklist.title': 'Checkliste',
  'checklist.titlePlaceholder': 'Titel der Checkliste',
  'checklist.itemPlaceholder': 'Eintrag hinzufügen',
  'checklist.add': 'Checkliste hinzufügen',
  'checklist.hint': 'Checkliste wird automatisch gespeichert, sobald du Einträge hinzufügst.',
  'checklist.empty': 'Checkliste noch nicht erstellt.',
  'checklist.copy.title': 'Checklist-Punkte kopieren',
  'checklist.copy.selectCard': 'Karte auswählen',
  'checklist.createPopoverTitle': 'Liste hinzufügen',
  'checklist.nameLabel': 'Name',
  'checklist.copy.fromLabel': 'Element kopieren von...',
  'checklist.copy.none': 'Fehlt',
  'checklist.copy.emptySource': 'Die ausgewählte Karte hat keine Checklisten-Punkte zum Kopieren.',
  'checklist.copy.append': 'Ans Ende anhängen',
  'checklist.copy.replace': 'Alle ersetzen',
  'attachments.title': 'Anhänge',
  'attachments.empty': 'Noch keine Anhänge.',
  'attachments.add': 'Datei hinzufügen',
  'comments.title': 'Kommentare',
  'comments.activityTitle': 'Kommentare & Aktivitäten',
  'comments.showDetails': 'Details anzeigen',
  'comments.hideDetails': 'Details ausblenden',
  'comments.empty': 'Noch keine Kommentare.',
  'comments.add': 'Kommentar hinzufügen',
  'comments.answer': 'Antworten',
  'comments.send': 'Senden',
  'comments.react': 'Reagieren',
  'comments.addReaction': 'Reaktion hinzufügen',
  'comments.reactionPicker': 'Emoji-Auswahl',
  'comment.placeholder': 'Kommentar schreiben...',
  'labels.title': 'Labels',
  'labels.empty': 'Noch keine Labels.',
  'labels.newPlaceholder': 'Neues Label',
  'labels.add': 'Label hinzufügen',
  'labels.newPrompt': 'Neuer Labelname:',
  'labels.deleteConfirm': 'Dieses Label löschen? Es wird von allen Karten entfernt.',
  'labels.hint': 'Labels werden nach dem Klicken auf {action} gespeichert.',
  'members.title': 'Mitglieder',
  'members.modalTitle': 'Board-Mitglieder',
  'members.inviteTitle': 'Einladen',
  'members.searchPlaceholder': 'Name, Benutzername oder E-Mail',
  'members.addListTitle': 'Liste hinzufügen',
  'members.searchParticipants': 'Nach Teilnehmenden suchen',
  'members.boardMembersTitle': 'Board-Mitglieder',
  'members.searching': 'Suchen...',
  'members.refreshing': 'Mitgliederliste wird aktualisiert...',
  'members.empty': 'Keine Nutzer gefunden.',
  'members.inviteEmail': 'Per E-Mail einladen',
  'members.adding': 'Hinzufügen...',
  'members.removing': 'Entfernen...',
  'members.roleOwner': 'Besitzer',
  'members.roleAdmin': 'Admin',
  'members.roleMember': 'Mitglied',
  'members.roleDeveloper': 'Developer',
  'members.roleViewer': 'Zuschauer',
  'members.roleLabel': 'Rolle',
  'members.permissionsHint': 'Nur Besitzer oder Admins können Mitglieder hinzufügen.',
  'members.viewerCannotBeAssigned': 'Zuschauer können keinen Karten zugewiesen werden.',
  'members.shareAria': 'Teilen',
  'members.more': '{count} weitere',
  'members.viewActivity': 'Board-Aktivität ansehen',
  'members.makeAdmin': 'Zum Admin machen',
  'members.removeAdmin': 'Admin entfernen',
  'members.removeFromBoard': 'Vom Board entfernen',
  'members.workspaceParticipants': 'Workspace-Teilnehmende',
  'members.guests': 'Gäste',
  'members.activityTitle': 'Aktivität von {name}',
  'members.activityEmpty': 'Keine Aktivität auf diesem Board.',
  'permissions.title': 'Entwickler-Berechtigungen',
  'permissions.devCreateCards': 'Entwickler kann Karten erstellen',
  'permissions.devEditAssigned': 'Entwickler kann zugewiesene Karten bearbeiten',
  'permissions.devArchiveAssigned': 'Entwickler kann zugewiesene Karten archivieren',
  'permissions.devJoinCard': 'Entwickler kann fremden Karten beitreten',
  'permissions.devCreateLists': 'Entwickler kann Listen erstellen',
  'hotkeys.hint': 'Hotkeys: Ctrl+K',
  'hotkeys.aria': 'Tastenkürzel',
  'command.title': 'Befehle',
  'command.placeholder': 'Befehle suchen',
  'command.empty': 'Keine Befehle gefunden',
  'command.createCard': 'Karte erstellen',
  'command.createList': 'Liste erstellen',
  'command.createBoard': 'Board erstellen',
  'command.goProfile': 'Zum Profil',
  'command.goMyCards': 'Zu meinen Karten',
  'command.goFaq': 'FAQ öffnen',
  'myCards.title': 'Meine Karten',
  'myCards.loading': 'Karten werden geladen...',
  'myCards.loadError': 'Karten konnten nicht geladen werden.',
  'myCards.emptyAssigned': 'Du hast noch keine zugewiesenen Karten.',
  'myCards.emptyList': 'Keine Karten zum Anzeigen.',
  'myCards.boardFallback': 'Board ohne Titel',
  'myCards.boardUnavailable': 'Board ist nicht verfügbar.',
  'myCards.boardArchived': 'Board ist archiviert',
  'landing.hero.line1': 'Erfassen,',
  'landing.hero.line2': 'organisieren',
  'landing.hero.line3': 'und Aufgaben erledigen',
  'landing.hero.line4': 'überall.',
  'landing.copy.line1': 'Lass Chaos und Unordnung hinter dir —',
  'landing.copy.line2': 'entfalte dein Potenzial und',
  'landing.copy.line3': 'steigere deine Produktivität mit Boardly.',
  'landing.cta.openApp': 'Zu den Boards',
  'landing.cta.signUp': 'Kostenlos registrieren!',
  'faq.title': 'FAQ',
  'faq.q1': 'Wie erstelle ich ein neues Board?',
  'faq.a1': 'Klicke "+ Neues Board" auf der Board-Seite.',
  'faq.q2': 'Wie füge ich eine Liste hinzu?',
  'faq.a2': 'Klicke "+ Liste hinzufügen" in der Board-Toolbar.',
  'faq.q3': 'Wie lade ich Mitglieder ein?',
  'faq.a3': 'Öffne Teilen und füge Personen per Name oder E-Mail hinzu.',
  'faq.q4': 'Wo sehe ich meine Karten?',
  'faq.a4': 'Öffne Meine Karten im oberen Menü.',
  'profile.tabsLabel': 'Profilbereiche',
  'profile.tabs.profile': 'Profil',
  'profile.tabs.activity': 'Aktivität',
  'profile.tabs.settings': 'Einstellungen',
  'profile.authRequiredTitle': 'Authentifizierung erforderlich',
  'profile.authRequiredHint': 'Melde dich an, um dein Profil zu sehen.',
  'profile.avatarAlt': 'Benutzeravatar',
  'profile.avatar.change': 'Avatar ändern',
  'profile.avatar.remove': 'Avatar entfernen',
  'profile.sections.profile': 'Profil',
  'profile.sections.activity': 'Aktivität',
  'profile.sections.settings': 'Einstellungen',
  'profile.settings.subtitle': 'Verwalten Sie Ihre Kontoeinstellungen',
  'profile.activity.subtitle': 'Verfolge deine und andere Aktivitäten auf deinen Boards',
  'profile.settings.general': 'Allgemein',
  'profile.settings.language': 'Sprache',
  'profile.settings.clearCache': 'Cache leeren',
  'profile.settings.cacheDescription': 'Löscht Website-Cache und temporäre Daten',
  'profile.settings.notifications': 'Benachrichtigungen',
  'profile.settings.desktopNotifications': 'Gmail-Benachrichtigungen',
  'profile.settings.assignedToTask': 'Einer Aufgabe zugewiesen',
  'profile.settings.dueDateApproaching': 'Fälligkeitsdatum nähert sich',
  'profile.settings.addedToBoard': 'Zum Board hinzugefügt',
  'profile.settings.manageEmail': 'E-Mail-Einstellungen verwalten',
  'profile.settings.appearance': 'Erscheinungsbild',
  'profile.settings.theme': 'Thema',
  'profile.settings.dark': 'Dunkel',
  'profile.settings.light': 'Hell',
  'profile.settings.defaultBoardView': 'Standard-Boardansicht',
  'profile.settings.kanban': 'Kanban',
  'profile.settings.calendar': 'Kalender',
  'profile.settings.manageIntegrations': 'Integrationen verwalten',
  'profile.settings.security': 'Sicherheit',
  'profile.settings.twoFactor': 'Zwei-Faktor-Authentifizierung',
  'profile.settings.requireVerification': 'Anmeldebestätigung erforderlich',
  'profile.settings.additionalVerification': 'Zusätzliche E-Mail-Bestätigung für neue Logins',
  'profile.settings.sessionTimeout': 'Sitzungs-Timeout',
  'profile.settings.sessionTimeout1h': 'Nach 1 Stunde Inaktivität',
  'profile.settings.saveChanges': 'Änderungen speichern',
  'profile.settings.cacheCleared': 'Cache geleert',
  'profile.settings.comingSoon': 'Demnächst verfügbar',
  'profile.emailPrefs.title': 'E-Mail-Einstellungen',
  'profile.emailPrefs.subtitle': 'Wählen Sie, welche E-Mails Sie erhalten möchten',
  'profile.emailPrefs.enableEmail': 'E-Mail-Benachrichtigungen',
  'profile.emailPrefs.assignedToTask': 'Einer Aufgabe zugewiesen',
  'profile.emailPrefs.dueDateApproaching': 'Fälligkeitsdatum nähert sich',
  'profile.emailPrefs.addedToBoard': 'Zum Board hinzugefügt',
  'profile.integrations.title': 'Integrationen',
  'profile.integrations.subtitle': 'Verbinden Sie Dienste mit Boardly',
  'profile.integrations.connect': 'Verbinden',
  'profile.integrations.slack': 'Slack-Benachrichtigungen und Schnellaktionen',
  'profile.integrations.calendar': 'Fristen mit dem Kalender synchronisieren',
  'profile.integrations.github': 'Aufgaben mit Repositories verknüpfen',
  'profile.fields.firstName': 'Vorname',
  'profile.fields.lastName': 'Nachname',
  'profile.fields.organization': 'Organisation',
  'profile.fields.nickname': 'Benutzername',
  'profile.fields.theme': 'Thema',
  'profile.fields.themeToggle': 'Themenumschalter',
  'profile.fields.language': 'Sprache',
  'profile.fields.emailNotifications': 'E-Mail-Benachrichtigungen',
  'profile.notifications.on': 'Ein',
  'profile.notifications.off': 'Aus',
  'profile.theme.dark': 'Dunkel',
  'profile.theme.light': 'Hell',
  'profile.saveSettings': 'Einstellungen speichern',
  'profile.saving': 'Speichern...',
  'profile.activity.empty': 'Zurzeit keine Aktivität.',
  'profile.activity.loadMore': 'Mehr laden',
  'profile.activity.type': 'Typ: {type}',
  'profile.logoutAll': 'Von allen Geräten abmelden',
  'profile.logoutAllHint': 'Demnächst',
  'profile.errors.requiredName': 'Vor- und Nachname sind erforderlich.',
  'profile.errors.saveFailed': 'Profil konnte nicht gespeichert werden.',
  'profile.errors.imageOnly': 'Nur Bilddateien werden unterstützt.',
  'profile.errors.avatarUploadFailed': 'Avatar konnte nicht hochgeladen werden.',
  'profile.errors.avatarRemoveFailed': 'Avatar konnte nicht entfernt werden.',
  'profile.errors.activityLoad': 'Aktivität konnte nicht geladen werden.',
  'profile.toast.saved': 'Profil gespeichert',
  'profile.toast.avatarUpdated': 'Avatar aktualisiert',
  'profile.toast.avatarRemoved': 'Avatar entfernt',
  'profile.time.justNow': 'gerade eben',
  'profile.time.minutesAgo': 'vor {count} Min.',
  'profile.time.hoursAgo': 'vor {count} Std.',
  'profile.time.daysAgo': 'vor {count} Tagen',
  'profile.tabs.privacy': 'Datenschutzerklärung',
  'profile.backToMain': 'Zurück zur Startseite',
  'profile.header.title': 'Profileinstellungen',
  'profile.header.subtitle': 'Verwalte deine persönlichen Informationen',
  'profile.privacy.title': 'Datenschutzprofil',
  'profile.privacy.subtitle': 'Schütze deine persönlichen Daten',
  'profile.section.personalInfo': 'Persönliche Angaben',
  'profile.section.passwordChange': 'Passwort ändern',
  'profile.section.workInfo': 'Arbeitsinformationen',
  'profile.section.access': 'Zugriff',
  'profile.fields.email': 'E-Mail',
  'profile.fields.currentPassword': 'Aktuelles Passwort',
  'profile.fields.bio': 'Über mich',
  'profile.fields.public': 'Öffentlich',
  'profile.placeholders.organization': 'Rolle / Unternehmen',
  'profile.placeholders.bio': 'Erzähl etwas über dich',
  'profile.actions.changePassword': 'Passwort ändern',
  'profile.actions.deactivate': 'Konto deaktivieren',
  'profile.userFallback': 'Benutzer',
  'profile.confirmDelete': 'Möchtest du dein Konto wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'profile.deactivate.title': '!ACHTUNG!',
  'profile.deactivate.message': 'Diese Aktion kann nicht rückgängig gemacht werden. Möchtest du dein Konto wirklich deaktivieren?',
  'profile.deactivate.confirm': 'Deaktivieren',
  'profile.deactivate.close': 'Schließen',
  'activity.context.onBoard': 'auf dem Board {board}',
  'activity.context.toList': 'nach {list}',
  'activity.context.fromList': 'von {list}',
  'activity.context.inList': 'in {list}',
  'activity.context.inChecklist': 'in der Checkliste {checklist}',
  'activity.context.onCard': 'auf der Karte {card}',
  'activity.noDate': 'kein Datum',
  'activity.create_board': '{actor} hat das Board {board} erstellt',
  'activity.rename_board': '{actor} hat das Board {board} umbenannt',
  'activity.update_board': '{actor} hat das Board {board} aktualisiert',
  'activity.archive_board': '{actor} hat das Board {board} archiviert',
  'activity.unarchive_board': '{actor} hat das Board {board} wiederhergestellt',
  'activity.create_list': '{actor} hat die Liste {list}{context} hinzugefügt',
  'activity.rename_list': '{actor} hat die Liste {list} umbenannt',
  'activity.move_list': '{actor} hat die Liste {list}{context} verschoben',
  'activity.archive_list': '{actor} hat die Liste {list} archiviert',
  'activity.unarchive_list': '{actor} hat die Liste {list} wiederhergestellt',
  'activity.copy_list': '{actor} hat die Liste {source} → {target} kopiert',
  'activity.create_card': '{actor} hat die Karte {card}{context} hinzugefügt',
  'activity.move_card': '{actor} hat die Karte {card}{from}{to} verschoben',
  'activity.archive_card': '{actor} hat die Karte {card}{context} archiviert',
  'activity.unarchive_card': '{actor} hat die Karte {card}{context} wiederhergestellt',
  'activity.update_card': '{actor} hat die Karte {card} aktualisiert',
  'activity.update_card_description': '{actor} hat die Beschreibung der Karte {card} aktualisiert',
  'activity.update_card_due_date': '{actor} hat das Fälligkeitsdatum der Karte {card} von {before} auf {after} geändert',
  'activity.copy_card': '{actor} hat die Karte {source} → {target} kopiert',
  'activity.complete_card': 'Mitglied {actor} hat diese Karte als erledigt markiert',
  'activity.uncomplete_card': 'Mitglied {actor} hat die Erledigt-Markierung dieser Karte entfernt',
  'activity.checklist.unchecked': '{actor} hat {item} als nicht erledigt markiert{checklist}{card}',
  'activity.checklist.checked': '{actor} hat {item} als erledigt markiert{checklist}{card}',
  'activity.add_checklist_item': '{actor} hat die Teilaufgabe {item} hinzugefügt{checklist}{card}',
  'activity.update_checklist_item': '{actor} hat die Teilaufgabe {item} aktualisiert{checklist}{card}',
  'activity.add_comment': '{actor} hat den Kommentar {comment} hinzugefügt{card}',
  'activity.labels.added': 'Labels hinzugefügt: {labels}',
  'activity.labels.removed': 'Labels entfernt: {labels}',
  'activity.labels.updated': 'Labels aktualisiert',
  'activity.update_card_labels': '{actor} {changes} für die Karte {card}',
  'activity.create_label': '{actor} hat das Label {label}{context} erstellt',
  'activity.update_label': '{actor} hat das Label {label}{context} aktualisiert',
  'activity.delete_label': '{actor} hat das Label {label}{context} gelöscht',
  'activity.update_profile': '{actor} hat das Profil aktualisiert',
  'activity.update_avatar': '{actor} hat den Avatar aktualisiert',
  'activity.remove_avatar': '{actor} hat den Avatar entfernt',
  'activity.default': '{actor} hat die Aktion {target} ausgeführt',
  'privacy.summaryTitle': 'Diese Datenschutzerklärung soll Ihnen helfen zu verstehen:',
  'privacy.footer.accessibility': 'Barrierefreiheit',
  'privacy.footer.choices': 'Ihre Datenschutzeinstellungen',
  'privacy.footer.policy': 'Datenschutzerklärung',
  'privacy.footer.terms': 'Bedingungen',
  'privacy.footer.data': 'Ausgabedaten',
  'privacy.footer.security': 'Sicherheit',
  'errors.boardUpdate': 'Board konnte nicht aktualisiert werden: {message}',
  'errors.listsLoad': 'Listen konnten nicht geladen werden: {message}',
  'errors.cardsLoad': 'Karten konnten nicht geladen werden: {message}',
  'confirm.deleteCard': 'Diese Karte löschen?',
  'prompt.copyLink': 'Diesen Link kopieren:',
  'toast.membersUpdateFailed': 'Mitglieder konnten nicht aktualisiert werden.',
  'toast.cardsReloadFailed': 'Karten konnten nicht aktualisiert werden.',
  'toast.joinFailed': 'Beitritt zum Board fehlgeschlagen.',
  'toast.checklistSaveFailed': 'Checkliste konnte nicht gespeichert werden.',
  'toast.checklistDeleteFailed': 'Checkliste konnte nicht gelöscht werden.',
  'toast.checklistItemAddFailed': 'Checklistenpunkt konnte nicht hinzugefügt werden.',
  'toast.labelCreateFailed': 'Label konnte nicht erstellt werden.',
  'toast.commentAddFailed': 'Kommentar konnte nicht hinzugefügt werden.',
  'toast.commentDeleteFailed': 'Kommentar konnte nicht gelöscht werden.',
  'toast.attachmentAdded': 'Anhang hinzugefügt',
  'toast.attachmentAddFailed': 'Anhang konnte nicht hinzugefügt werden.',
  'toast.attachmentDeleteFailed': 'Anhang konnte nicht gelöscht werden.',
  'toast.memberAddFailed': 'Mitglied konnte nicht hinzugefügt werden.',
  'toast.memberRoleFailed': 'Rolle konnte nicht geändert werden.',
  'toast.memberRemoveFailed': 'Mitglied konnte nicht entfernt werden.',
  'toast.inviteUnavailable': 'Einladungslink ist nicht verfügbar.',
  'toast.cardSaveFailed': 'Karte konnte nicht gespeichert werden.',
  'toast.cardCopied': 'Karte kopiert',
  'toast.cardCopyFailed': 'Karte konnte nicht kopiert werden.',
  'toast.listCopied': 'Liste kopiert',
  'toast.listCopying': 'Liste wird kopiert...',
  'toast.listCopyFailed': 'Liste konnte nicht kopiert werden.',
  'toast.listMoveFailed': 'Liste konnte nicht verschoben werden.',
  'toast.cardCreateFailed': 'Karte konnte nicht erstellt werden.',
  'toast.cardMoveFailed': 'Karte konnte nicht verschoben werden.',
  'toast.cardDeleteFailed': 'Karte konnte nicht gelöscht werden.',
  'toast.cardArchiveFailed': 'Archivstatus der Karte konnte nicht aktualisiert werden.',
  'toast.boardCreateFailed': 'Board konnte nicht erstellt werden.',
  'toast.boardUpdateFailed': 'Board konnte nicht aktualisiert werden.',
  'toast.boardArchiveFailed': 'Archivstatus des Boards konnte nicht aktualisiert werden.',
  'toast.listArchiveFailed': 'Archivstatus der Liste konnte nicht aktualisiert werden.',
  'toast.listCreateFailed': 'Liste konnte nicht erstellt werden.',
  'toast.listRenameFailed': 'Liste konnte nicht umbenannt werden.',
};

translations.fr = {
  ...baseEn,
  'nav.board': 'Tableau',
  'nav.myCards': 'Mes cartes',
  'nav.profile': 'Profil',
  'nav.faq': 'FAQ',
  'nav.help': 'Aide',
  'nav.community': 'Communauté',
  'nav.logout': 'Se déconnecter',
  'nav.greeting': 'Bonjour, {name}',
  'nav.menu': 'Menu',
  'nav.language': 'Langue',
  'help.title': 'Comment pouvons-nous aider ?',
  'help.subtitle': 'Trouvez des réponses dans les ressources d’assistance Boardly.',
  'help.featured.title': 'Contenu à la une',
  'help.featured.item1': 'Que sont les schémas d’autorisations dans Boardly ?',
  'help.featured.item2': 'Contrôler l’accès des utilisateurs aux applications',
  'help.featured.item3': 'Changer les adresses e-mail du compte Atlassian',
  'help.featured.item4': 'Désactiver un compte géré',
  'help.featured.item5': 'Vérifier un domaine pour gérer les comptes',
  'help.featured.item6': 'Configurer l’authentification unique SAML avec un fournisseur d’identité',
  'help.featured.item7': 'Accorder des permissions d’administrateur',
  'help.featured.item8': 'Comprendre le provisionnement des utilisateurs',
  'help.featured.item9': 'Adresses IP et domaines pour les apps cloud Boardly',
  'help.resources.title': 'Parcourir les ressources',
  'help.resources.community.title': 'Communauté',
  'help.resources.community.body': 'Trouvez des réponses, du support et de l’inspiration auprès d’autres utilisateurs Boardly.',
  'help.resources.community.link': 'Visiter la communauté Boardly',
  'help.resources.status.title': 'Statut du système',
  'help.resources.status.body': 'Vérifiez la santé de nos apps et services cloud.',
  'help.resources.status.link': 'Voir le statut du système',
  'help.resources.suggestions.title': 'Suggestions et rapports de bugs',
  'help.resources.suggestions.body': 'Consultez les suggestions de fonctionnalités et rapports de bugs existants.',
  'help.resources.suggestions.link': 'Voir suggestions et bugs',
  'help.resources.marketplace.title': 'Apps Marketplace',
  'help.resources.marketplace.body': 'Trouvez des fonctionnalités pour personnaliser vos apps.',
  'help.resources.marketplace.link': 'Voir le Marketplace',
  'help.resources.billing.title': 'Facturation et licences',
  'help.resources.billing.body': 'Consultez la FAQ sur la facturation et les licences.',
  'help.resources.billing.link': 'Voir la FAQ',
  'help.resources.training.title': 'Formation et certification',
  'help.resources.training.body': 'Développez de nouvelles compétences, améliorez le travail de votre équipe et votre carrière.',
  'help.resources.training.link': 'Voir les formations',
  'help.resources.developers.title': 'Développeurs',
  'help.resources.developers.body': 'Documentation API et guides pour développer des apps et intégrations.',
  'help.resources.developers.link': 'Voir la doc développeurs',
  'help.resources.enterprise.title': 'Enterprise',
  'help.resources.enterprise.body': 'En savoir plus sur Boardly Enterprise et les produits Data Center.',
  'help.resources.enterprise.link': 'Voir la documentation Enterprise',
  'help.resources.government.title': 'Support Government Cloud',
  'help.resources.government.body': 'Support technique et de migration pour les projets Government Boardly.',
  'help.resources.government.link': 'Se connecter pour contacter le support',
  'help.resources.success.title': 'Success Central',
  'help.resources.success.body': 'Aide à l’adoption avec une bibliothèque de contenus Boardly et partenaires.',
  'help.resources.success.link': 'Voir Success Central',
  'help.contact.title': 'Vous ne trouvez pas l’aide dont vous avez besoin ?',
  'help.contact.button': 'Contacter le support',
  'help.footer.copyright': 'Copyright © 2026 Boardly',
  'help.footer.accessibility': 'Accessibilité',
  'help.footer.privacyChoices': 'Vos choix de confidentialité',
  'help.footer.privacyPolicy': 'Politique de confidentialité',
  'help.footer.terms': 'Conditions',
  'help.footer.impressum': 'Impressum',
  'help.footer.security': 'Sécurité',
  'community.title': 'Créez ensemble votre meilleure vie professionnelle',
  'community.subtitle': 'Apprenez, connectez-vous et progressez avec la communauté Boardly.',
  'community.getStarted.title': 'Bien démarrer',
  'community.getStarted.link': 'Trouver des réponses',
  'community.getStarted.forums.title': 'Forums',
  'community.getStarted.forums.body': 'Posez des questions et obtenez de l’aide d’experts et de pairs.',
  'community.getStarted.learning.title': 'Apprentissage',
  'community.getStarted.learning.body': 'Guides, tutoriels et meilleures pratiques.',
  'community.getStarted.events.title': 'Événements',
  'community.getStarted.events.body': 'Rejoignez des sessions et rencontrez la communauté en direct.',
  'community.getStarted.champions.title': 'Champions',
  'community.getStarted.champions.body': 'Connectez-vous avec des utilisateurs experts et des ambassadeurs.',
  'community.advice.title': 'Recevez des conseils et connectez-vous',
  'community.advice.body': 'Les forums de la communauté sont un excellent endroit pour obtenir des réponses d’experts et de pairs. Trouvez des solutions ou posez vos propres questions.',
  'community.back': 'Retour',
  'community.kicker.forums': 'Forums de la communauté',
  'community.learning.title': 'Développez vos compétences avec un apprentissage flexible',
  'community.learning.body': 'Nos cours gratuits à la demande vous aident à maîtriser les applications Atlassian et à travailler plus vite. Progressez avec des formations animées par des instructeurs et des certifications Atlassian.',
  'community.learning.longBody': 'Développez une expertise concrète grâce à des parcours structurés, des exemples réels et des bonnes pratiques guidées. Des bases aux workflows avancés, ces ressources aident votre équipe à appliquer plus vite les connaissances, mieux collaborer et obtenir de meilleurs résultats.',
  'community.redesign.hero.title': 'Organisez vos taches et traitez-les depuis n importe ou.',
  'community.redesign.hero.subtitle': 'Organisez vos projets, augmentez la productivite et travaillez encore plus efficacement avec notre application.',
  'community.redesign.hero.cta': 'Inscription gratuite !',
  'community.redesign.preview.todo.title': 'A faire',
  'community.redesign.preview.todo.task1': 'Designer la page de connexion',
  'community.redesign.preview.todo.task2': 'Creer un tableau de taches',
  'community.redesign.preview.todo.task3': 'Configurer les notifications',
  'community.redesign.preview.progress.title': 'En cours',
  'community.redesign.preview.progress.task': 'Implementer le drag and drop',
  'community.redesign.preview.done.title': 'Termine',
  'community.redesign.basicFunctions': 'Fonctions de base',
  'community.redesign.sources.title': 'Sources de productivite',
  'community.redesign.sources.subtitle': 'Travaillez plus efficacement avec nos tableaux, cartes et automatisations, meme en deplacement.',
  'community.redesign.sources.imageAlt': 'Apercu du tableau de taches',
  'community.redesign.moveTasks.title': 'Deplacer les taches',
  'community.redesign.moveTasks.body': 'Deplacez les taches simplement avec le drag and drop.',
  'community.redesign.actions.heading': 'Des messages aux actions',
  'community.redesign.actions.subtitle': 'Regroupez les notifications importantes et transformez-les en actions productives.',
  'community.redesign.actions.messages.title': 'Vos messages depuis Slack',
  'community.redesign.actions.messages.body': 'Transformez les messages entrants en taches en quelques secondes.',
  'community.redesign.actions.automation.title': 'Utiliser l automatisation',
  'community.redesign.actions.automation.body': 'Automatisez les taches avec des recommandations intelligentes.',
  'community.redesign.actions.communicate.title': 'Communication rapide',
  'community.redesign.actions.communicate.body': 'Communiquez avec votre equipe en temps reel.',
  'community.redesign.more.heading': 'Faites plus avec Boardly',
  'community.redesign.more.subtitle': 'Adaptez l application a vos besoins avec des integrations, automatisations et workflows personnalises.',
  'community.redesign.more.integrations.title': 'Integrations',
  'community.redesign.more.integrations.body': 'Connectez vos outils favoris.',
  'community.redesign.more.automation.title': 'Automatisation',
  'community.redesign.more.automation.body': 'Mettez en place des actions automatiques.',
  'community.redesign.more.customization.title': 'Personnalisation',
  'community.redesign.more.customization.body': 'Personnalisez les tableaux selon vos besoins.',
  'community.redesign.more.mobile.title': 'Mobile',
  'community.redesign.more.mobile.body': 'Travaillez partout avec une seule application.',
  'community.redesign.signup.title': 'Demarrez avec Boardly des aujourd hui',
  'community.redesign.signup.note': 'En saisissant mon adresse e-mail, j accepte les conditions et la',
  'community.redesign.signup.privacy': 'Politique de confidentialite',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.search': 'Rechercher',
  'common.loading': 'Chargement...',
  'common.error': 'Une erreur est survenue',
  'common.actionFailed': "L'action a échoué. Réessayez.",
  'common.retry': 'Réessayer',
  'common.close': 'Fermer',
  'common.add': 'Ajouter',
  'common.assigned': 'Assigné',
  'common.notAssigned': 'Non assigné',
  'common.create': 'Créer',
  'common.update': 'Mettre à jour',
  'common.copyLink': 'Copier le lien',
  'common.share': 'Partager',
  'common.clear': 'Effacer',
  'common.noConnection': 'Pas de connexion',
  'common.saving': 'Enregistrement...',
  'common.unknown': 'inconnu',
  'common.linkCopied': 'Lien copié',
  'common.copySuffix': ' (copie)',
  'common.copy': 'Copier',
  'common.copying': 'Copie...',
  'common.edit': 'Modifier',
  'common.creating': 'Création...',
  'common.confirmDelete': 'Supprimer ?',
  'common.redirecting': 'Redirection...',
  'common.or': 'ou',
  'auth.welcome': 'Bienvenue',
  'auth.createAccount': 'Créer un compte',
  'auth.joinBoardly': 'Rejoignez Boardly et gérez vos tâches efficacement.',
  'auth.enterDetails': 'Entrez vos informations pour vous connecter.',
  'auth.firstName': 'Prénom',
  'auth.lastName': 'Nom',
  'auth.email': 'E-mail',
  'auth.username': 'Nom d’utilisateur',
  'auth.password': 'Mot de passe',
  'auth.placeholderFirstName': 'Jean',
  'auth.placeholderLastName': 'Dupont',
  'auth.placeholderUsername': 'Votre nom',
  'auth.placeholderPassword': '********',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.processing': 'Traitement...',
  'auth.signUp': 'S’inscrire',
  'auth.signIn': 'Se connecter',
  'auth.hasAccount': 'Vous avez déjà un compte ?',
  'auth.noAccount': 'Pas encore de compte ?',
  'auth.googleError': 'Connexion Google échouée.',
  'auth.loginError': 'Erreur d’authentification.',
  'auth.registerSuccessTitle': 'Inscription réussie !',
  'auth.registerSuccessHint': 'Nous avons envoyé un e-mail de confirmation à {email}. Vérifiez votre boîte de réception.',
  'auth.backToLogin': 'Retour à la connexion',
  'auth.organizationOptional': 'Organisation (facultatif)',
  'auth.usernameOrEmail': 'Nom d\'utilisateur ou e-mail',
  'auth.policyPrefix': 'J\'accepte la',
  'auth.policyLink': 'politique de confidentialité',
  'auth.googleSignIn': 'Se connecter avec Google',
  'auth.invalidEmail': 'Adresse e-mail invalide.',
  'auth.passwordTooShort': 'Le mot de passe doit contenir au moins {min} caractères.',
  'auth.policyRequired': 'Veuillez accepter la politique de confidentialité.',
  'activation.loadingTitle': 'Activation du compte...',
  'activation.loadingHint': 'Veuillez patienter.',
  'activation.successTitle': 'Compte activé ! 🎉',
  'activation.successHint': 'Vous pouvez maintenant vous connecter.',
  'activation.signIn': 'Se connecter',
  'activation.errorTitle': 'Échec de l’activation',
  'activation.errorHint': 'Le lien est invalide ou expiré.',
  'activation.back': 'Retour',
  'auth.preview.todoTitle': 'À faire',
  'auth.preview.todoCard': 'Design de la page de connexion',
  'auth.preview.progressTitle': 'En cours',
  'auth.preview.progressCard': 'Implémenter le drag & drop',
  'auth.preview.doneTitle': 'Terminé',
  'auth.preview.doneCard': 'Création du tableau',
  'passwordReset.title': 'Réinitialiser le mot de passe',
  'passwordReset.description': 'Entrez votre email et nous vous enverrons un lien de réinitialisation.',
  'passwordReset.successTitle': 'Email envoyé !',
  'passwordReset.successHint': 'Vérifiez votre boîte (ou la console Django) pour le lien.',
  'passwordReset.successDetail': 'Nous avons envoyé les instructions à {email}. Vérifiez la boîte de réception et les spams.',
  'passwordReset.backToLogin': 'Retour à la connexion',
  'passwordReset.emailLabel': 'Email',
  'passwordReset.emailPlaceholder': 'name@example.com',
  'passwordReset.submit': 'Réinitialiser le mot de passe',
  'passwordReset.sending': 'Envoi...',
  'passwordReset.remembered': 'Je me souviens du mot de passe',
  'passwordReset.error': 'Impossible de trouver un utilisateur avec cet email ou une erreur est survenue.',
  'resetConfirm.title': 'Nouveau mot de passe',
  'resetConfirm.description': 'Créez un nouveau mot de passe sécurisé pour votre compte.',
  'resetConfirm.successTitle': 'Succès !',
  'resetConfirm.successHint': 'Le mot de passe a été modifié. Redirection vers la connexion...',
  'resetConfirm.successAction': 'Se connecter avec le nouveau mot de passe',
  'resetConfirm.newPasswordLabel': 'Nouveau mot de passe',
  'resetConfirm.newPasswordPlaceholder': 'Au moins 8 caractères',
  'resetConfirm.confirmPasswordLabel': 'Confirmer le mot de passe',
  'resetConfirm.confirmPasswordPlaceholder': 'Répétez le mot de passe',
  'resetConfirm.submit': 'Changer le mot de passe',
  'resetConfirm.saving': 'Enregistrement...',
  'resetConfirm.errorMismatch': 'Les mots de passe ne correspondent pas',
  'resetConfirm.errorPassword': 'Mot de passe : {message}',
  'resetConfirm.errorInvalidLink': 'Le lien de réinitialisation est invalide ou expiré.',
  'resetConfirm.errorUnknown': 'Une erreur inconnue est survenue. Réessayez.',
  'lang.uk': 'Ukrainien',
  'lang.en': 'Anglais',
  'lang.pl': 'Polonais',
  'lang.de': 'Allemand',
  'lang.fr': 'Français',
  'lang.es': 'Espagnol',
  'board.archive': 'Archiver le tableau',
  'board.archiveConfirm': 'Archiver ce tableau ?',
  'board.archivedSuffix': '(archivé)',
  'board.create.newButton': '+ Nouveau tableau',
  'board.create.titlePlaceholder': 'Nom du tableau',
  'board.create.titleLabel': 'Titre du tableau',
  'board.create.titleInputPlaceholder': 'Saisissez un titre...',
  'board.empty.title': 'Créez votre premier tableau',
  'board.empty.subtitle': 'Ajoutez un tableau pour commencer.',
  'board.menu': 'Menu du tableau',
  'board.menu.changeBackground': 'Changer l’arrière-plan',
  'board.menu.members': 'Membres',
  'board.menu.archived': 'Éléments archivés',
  'board.menu.inviteTitle': 'Inviter',
  'board.account.title': 'Compte',
  'board.account.changeAccount': 'Changer de compte',
  'board.account.profile': 'Profil',
  'board.account.settings': 'Paramètres',
  'board.account.backgrounds': 'Arrière-plans',
  'board.account.logout': 'Se déconnecter',
  'board.filters': 'Filtres',
  'board.select.title': 'Choisir un tableau',
  'board.settings': 'Paramètres du tableau',
  'board.error.loadDetails': 'Impossible de charger les détails du tableau.',
  'board.unarchive': 'Restaurer le tableau',
  'board.unarchiveConfirm': 'Restaurer ce tableau ?',
  'board.deleteConfirm': 'Supprimer le tableau ?',
  'board.delete': 'Supprimer le tableau',
  'board.leave': 'Quitter le tableau',
  'board.joining': 'Connexion au tableau...',
  'board.background.title': 'Arrière-plan du tableau',
  'board.background.upload': 'Téléverser une image',
  'board.background.reset': 'Réinitialiser',
  'board.background.apply': 'Appliquer',
  'board.background.urlPlaceholder': 'Collez l’URL de l’image...',
  'board.background.colorSelected': 'Couleur sélectionnée',
  'board.background.gradientSelected': 'Dégradé sélectionné',
  'board.background.imageSelected': 'Image sélectionnée',
  'board.background.invalidFile': 'Veuillez choisir une image.',
  'board.background.tooLarge': 'Fichier trop grand (max {size} Mo).',
  'board.background.uploadHint': 'PNG, JPG - jusqu’à 5 Mo - minimum 1920 x 1080',
  'board.background.colors': 'Couleurs',
  'board.background.gradients': 'Dégradés',
  'board.background.images': 'Images',
  'board.background.default': 'Par défaut',
  'board.background.slate': 'Ardoise',
  'board.background.charcoal': 'Charbon',
  'board.background.indigo': 'Indigo',
  'board.background.emerald': 'Émeraude',
  'board.background.warmLight': 'Clair chaud',
  'board.background.gradient.sunset': 'Coucher de soleil',
  'board.background.gradient.ocean': 'Océan',
  'board.background.gradient.forest': 'Forêt',
  'board.background.gradient.blush': 'Rose',
  'board.background.gradient.night': 'Nuit',
  'board.background.gradient.dawn': 'Aube',
  'toolbar.searchPlaceholder': 'Rechercher sur le tableau',
  'toolbar.actions': 'Actions du tableau',
  'toolbar.matches': 'résultats',
  'toolbar.noMatches': 'Aucun résultat',
  'filters.title': 'Filtres',
  'filters.membersLabel': 'Membres',
  'filters.membersAll': 'Tous les membres',
  'filters.labelsLabel': 'Étiquettes',
  'filters.labelsAll': 'Toutes les étiquettes',
  'filters.dueLabel': 'Échéance',
  'filters.dueAny': 'Toute échéance',
  'filters.dueOverdue': 'En retard',
  'filters.dueToday': 'Pour aujourd’hui',
  'filters.dueWeek': 'Cette semaine',
  'filters.dueNone': 'Sans échéance',
  'filters.completedLabel': 'Statut',
  'filters.completedAll': 'Toutes',
  'filters.completedOnly': 'Terminées',
  'filters.incompleteOnly': 'Incompletes',
  'filters.reset': 'Réinitialiser',
  'filters.apply': 'Appliquer',
  'archive.cards': 'Cartes archivées',
  'archive.lists': 'Listes archivées',
  'archive.showCards': 'Afficher les cartes archivées',
  'archive.hideCards': 'Masquer les cartes archivées',
  'archive.showLists': 'Afficher les listes archivées',
  'archive.hideLists': 'Masquer les listes archivées',
  'archive.badge': 'Archivé',
  'list.addButton': '+ Ajouter une liste',
  'list.create.placeholder': 'Nom de la liste',
  'list.create.submit': 'Créer la liste',
  'list.empty.noneTitle': 'Aucune liste',
  'list.empty.noneSubtitle': 'Créez votre première liste pour ajouter des cartes.',
  'list.empty.archivedTitle': 'Listes archivées',
  'list.empty.archivedSubtitle': 'Activez l’affichage des archives pour les voir.',
  'list.empty.showArchived': 'Afficher les listes archivées',
  'list.menu': 'Menu de la liste',
  'list.menu.addCard': 'Ajouter une carte',
  'list.menu.move': 'Déplacer la liste',
  'list.menu.moveAll': 'Déplacer toutes les cartes de cette liste',
  'list.menu.sort': 'Trier par...',
  'list.menu.subscribe': "S'abonner",
  'list.menu.unsubscribe': 'Se désabonner',
  'list.menu.movePrompt': 'Entrez la nouvelle position de la liste',
  'list.menu.moveAllPrompt': "Entrez l'ID de la liste de destination pour toutes les cartes",
  'list.menu.sortPrompt': 'Choisissez le tri',
  'list.menu.sortByDue': "Par date d'échéance",
  'list.menu.sortByTitle': 'Par titre',
  'list.menu.comingSoon': 'Bientôt disponible',
  'list.menu.automation': 'Automatisation',
  'list.menu.automationAdd': "Quand une carte est ajoutée à la liste...",
  'list.menu.automationDaily': 'Chaque jour, trier par...',
  'list.menu.automationRule': 'Créer une règle',
  'list.menu.archiveAllCards': 'Archiver toutes les cartes de cette liste',
  'list.menu.devCanAddCards': 'Le développeur peut ajouter des cartes',
  'list.menu.devCannotAddCards': 'Le développeur ne peut pas ajouter de cartes',
  'list.rename': 'Renommer',
  'list.copy': 'Copier la liste',
    'list.archive': 'Archiver la liste',
    'list.unarchive': 'Restaurer la liste',
    'list.color.title': 'Changer la couleur',
    'list.color.none': 'Sans couleur',
    'list.collapse': 'Réduire',
  'list.moveLeft': 'Déplacer vers la gauche',
  'list.moveRight': 'Déplacer vers la droite',
  'list.position': 'Position',
  'list.archiveConfirm': 'Archiver cette liste ?',
  'list.archiveAllCardsConfirm': 'Archiver toutes les cartes de cette liste ?',
  'list.unarchiveConfirm': 'Restaurer cette liste ?',
  'card.create.newButton': '+ Nouvelle carte',
  'card.create.placeholder': 'Titre de la carte...',
  'card.descriptionPlaceholder': 'Ajouter une description',
  'card.descriptionTitle': 'Description',
  'card.descriptionEmpty': 'Aucune description.',
  'card.dueDate': 'Date d’échéance',
  'card.dueDateRemove': 'Supprimer l’échéance',
  'card.dueDatePreview': 'Sélectionné : {date}',
  'card.dueDateRequired': 'Sélectionnez une date d’échéance',
  'card.empty': 'Aucune carte',
  'card.menu': 'Menu de la carte',
  'card.menu.move': 'Déplacer',
  'card.menu.copy': 'Copier',
  'card.menu.share': 'Partager',
  'card.menu.mirror': 'Miroir',
  'card.menu.template': 'Créer un modèle',
  'card.menu.subscribe': "S'abonner",
  'card.menu.copyLinkPrompt': 'Copiez ce lien manuellement',
  'card.menu.archive': 'Archiver',
  'card.menu.delete': 'Supprimer',
  'card.move.title': 'Déplacer la carte',
  'card.move.list': 'Liste',
  'card.move.position': 'Position',
  'card.move.button': 'Déplacer',
  'card.moveToList': 'Déplacer vers la liste',
  'card.copy': 'Copier la carte',
  'card.archive': 'Archiver',
  'card.unarchive': 'Restaurer',
  'card.inList': 'Dans la liste',
  'card.members': 'Participants',
  'card.completedBadge': 'TERMINÉ',
  'card.private': 'Carte privée',
  'card.overdue.days': '(En retard de {count} j)',
  'card.overdue.hours': '(En retard de {count} h)',
  'card.overdue.minutes': '(En retard de {count} min)',
  'card.moveUp': 'Déplacer vers le haut',
  'card.moveDown': 'Déplacer vers le bas',
  'card.moveLeft': 'Déplacer vers la gauche',
  'card.moveRight': 'Déplacer vers la droite',
  'card.sidebar.participation': 'Participation',
  'card.sidebar.join': 'Rejoindre',
  'card.sidebar.leave': 'Quitter',
  'card.joinError': 'Impossible de rejoindre la carte.',
  'card.sidebar.add': 'Ajouter',
  'card.sidebar.actions': 'Actions',
  'card.cover.title': 'Couverture',
  'card.cover.remove': 'Supprimer la couverture',
  'card.colorTitle': 'Couleur de la carte',
  'card.colorHint': 'Choisissez une couleur ou réinitialisez.',
  'card.color.none': 'Sans couleur',
  'card.color.sun': 'Soleil',
  'card.color.rose': 'Rose',
  'card.color.sky': 'Ciel',
  'card.color.violet': 'Violet',
  'card.color.emerald': 'Émeraude',
  'card.color.teal': 'Turquoise',
  'card.color.slate': 'Ardoise',
  'card.quick.add': 'Ajouter',
  'card.quick.addHint': 'Ajoutez via le panneau de droite',
  'card.quick.dates': 'Dates',
  'card.quick.checklist': 'Checklist',
    'card.quick.attach': 'Pièce jointe',
    'card.quick.members': 'Membres',
    'card.quick.comingSoon': 'Bientôt disponible',
    'card.watch': 'Suivre',
    'card.add.title': 'Ajouter à la carte',
    'card.add.labels': 'Étiquettes',
    'card.add.labelsHint': 'Faites défiler jusqu’aux étiquettes',
    'card.add.dates': 'Dates',
    'card.add.checklist': 'Checklist',
    'card.add.members': 'Membres',
    'card.add.attachments': 'Pièces jointes',
    'card.cover.size': 'Taille',
    'card.cover.size.full': 'Complète',
    'card.cover.size.header': 'En-tête',
    'card.cover.colors': 'Couleurs',
    'card.cover.colorblind': 'Activer le mode daltonien',
    'card.cover.colorblind.enable': 'Activer le mode daltonien',
    'card.cover.colorblind.disable': 'Désactiver le mode daltonien',
    'checklist.title': 'Checklist',
  'checklist.titlePlaceholder': 'Titre de la checklist',
  'checklist.itemPlaceholder': 'Nouvelle tâche',
  'checklist.add': 'Ajouter une checklist',
  'checklist.hint': 'La checklist est enregistrée automatiquement après l’ajout d’éléments.',
  'checklist.empty': 'Checklist non créée.',
  'checklist.copy.title': 'Copier les éléments',
  'checklist.copy.selectCard': 'Sélectionner une carte',
  'checklist.createPopoverTitle': 'Ajouter une liste',
  'checklist.nameLabel': 'Nom',
  'checklist.copy.fromLabel': 'Copier un élément depuis...',
  'checklist.copy.none': 'Manquant',
  'checklist.copy.emptySource': 'La carte sélectionnée ne contient aucun élément à copier.',
  'checklist.copy.append': 'Ajouter à la fin',
  'checklist.copy.replace': 'Tout remplacer',
  'attachments.title': 'Pièces jointes',
  'attachments.empty': 'Aucune pièce jointe.',
  'attachments.add': 'Ajouter un fichier',
  'comments.title': 'Commentaires',
  'comments.activityTitle': 'Commentaires et activité',
  'comments.showDetails': 'Afficher les détails',
  'comments.hideDetails': 'Masquer les détails',
  'comments.empty': 'Aucun commentaire.',
  'comments.add': 'Ajouter un commentaire',
  'comments.answer': 'Répondre',
  'comments.send': 'Envoyer',
  'comments.react': 'Réagir',
  'comments.addReaction': 'Ajouter une réaction',
  'comments.reactionPicker': 'Sélecteur d’emoji',
  'comment.placeholder': 'Écrire un commentaire...',
  'labels.title': 'Étiquettes',
  'labels.empty': 'Aucune étiquette.',
  'labels.newPlaceholder': 'Nouvelle étiquette',
  'labels.add': 'Ajouter une étiquette',
  'labels.newPrompt': 'Nom de la nouvelle étiquette :',
  'labels.deleteConfirm': 'Supprimer cette étiquette ? Elle sera retirée de toutes les cartes.',
  'labels.hint': 'Les étiquettes sont enregistrées après avoir cliqué sur {action}.',
  'members.title': 'Membres',
  'members.modalTitle': 'Membres du tableau',
  'members.inviteTitle': 'Inviter',
  'members.searchPlaceholder': 'Nom, identifiant ou email',
  'members.addListTitle': 'Ajouter une liste',
  'members.searchParticipants': 'Rechercher des participants',
  'members.boardMembersTitle': 'Membres du tableau',
  'members.searching': 'Recherche...',
  'members.refreshing': 'Actualisation de la liste des membres...',
  'members.empty': 'Aucun utilisateur trouvé.',
  'members.inviteEmail': 'Inviter par email',
  'members.adding': 'Ajout...',
  'members.removing': 'Suppression...',
  'members.roleOwner': 'Propriétaire',
  'members.roleAdmin': 'Admin',
  'members.roleMember': 'Membre',
  'members.roleDeveloper': 'Développeur',
  'members.roleViewer': 'Spectateur',
  'members.roleLabel': 'Rôle',
  'members.permissionsHint': 'Seuls le propriétaire ou les admins peuvent ajouter des membres.',
  'members.viewerCannotBeAssigned': 'Les spectateurs ne peuvent pas être assignés aux cartes.',
  'members.shareAria': 'Partager',
  'members.more': 'Encore {count}',
  'members.viewActivity': "Voir l'activité du tableau",
  'members.makeAdmin': 'Nommer admin',
  'members.removeAdmin': "Retirer le rôle d'admin",
  'members.removeFromBoard': 'Retirer du tableau',
  'members.workspaceParticipants': 'Participants de l’espace de travail',
  'members.guests': 'Invités',
  'members.activityTitle': 'Activité de {name}',
  'members.activityEmpty': 'Aucune activité sur ce tableau.',
  'permissions.title': 'Autorisations développeur',
  'permissions.devCreateCards': 'Le développeur peut créer des cartes',
  'permissions.devEditAssigned': 'Le développeur peut modifier les cartes assignées',
  'permissions.devArchiveAssigned': 'Le développeur peut archiver les cartes assignées',
  'permissions.devJoinCard': 'Le développeur peut rejoindre des cartes externes',
  'permissions.devCreateLists': 'Le développeur peut créer des listes',
  'hotkeys.hint': 'Raccourcis : Ctrl+K',
  'hotkeys.aria': 'Raccourcis',
  'command.title': 'Commandes',
  'command.placeholder': 'Rechercher des commandes',
  'command.empty': 'Aucune commande trouvée',
  'command.createCard': 'Créer une carte',
  'command.createList': 'Créer une liste',
  'command.createBoard': 'Créer un tableau',
  'command.goProfile': 'Aller au profil',
  'command.goMyCards': 'Aller à mes cartes',
  'command.goFaq': 'Ouvrir la FAQ',
  'myCards.title': 'Mes cartes',
  'myCards.loading': 'Chargement des cartes...',
  'myCards.loadError': 'Impossible de charger les cartes.',
  'myCards.emptyAssigned': 'Aucune carte assignée pour l’instant.',
  'myCards.emptyList': 'Aucune carte à afficher.',
  'myCards.boardFallback': 'Tableau sans titre',
  'myCards.boardUnavailable': 'Le tableau est indisponible.',
  'myCards.boardArchived': 'Le tableau est archivé.',
  'landing.hero.line1': 'Capturez,',
  'landing.hero.line2': 'organisez',
  'landing.hero.line3': 'et accomplissez vos tâches',
  'landing.hero.line4': 'partout.',
  'landing.copy.line1': 'Laissez le chaos derrière vous —',
  'landing.copy.line2': 'libérez votre potentiel et',
  'landing.copy.line3': 'boostez votre productivité avec Boardly.',
  'landing.cta.openApp': 'Ouvrir les tableaux',
  'landing.cta.signUp': 'Inscrivez-vous gratuitement !',
  'faq.title': 'FAQ',
  'faq.q1': 'Comment créer un nouveau tableau ?',
  'faq.a1': 'Cliquez sur "+ Nouveau tableau" sur la page des tableaux.',
  'faq.q2': 'Comment ajouter une liste ?',
  'faq.a2': 'Cliquez sur "+ Ajouter une liste" dans la barre d’outils.',
  'faq.q3': 'Comment inviter des membres ?',
  'faq.a3': 'Ouvrez Partager et ajoutez des personnes par nom ou email.',
  'faq.q4': 'Où voir mes cartes ?',
  'faq.a4': 'Ouvrez Mes cartes dans le menu supérieur.',
  'profile.tabsLabel': 'Sections du profil',
  'profile.tabs.profile': 'Profil',
  'profile.tabs.activity': 'Activité',
  'profile.tabs.settings': 'Paramètres',
  'profile.authRequiredTitle': 'Authentification requise',
  'profile.authRequiredHint': 'Connectez-vous pour voir votre profil.',
  'profile.avatarAlt': 'Avatar de l’utilisateur',
  'profile.avatar.change': 'Changer l’avatar',
  'profile.avatar.remove': 'Supprimer l’avatar',
  'profile.sections.profile': 'Profil',
  'profile.sections.activity': 'Activité',
  'profile.sections.settings': 'Paramètres',
  'profile.settings.subtitle': 'Gérez les paramètres de votre compte',
  'profile.activity.subtitle': 'Suivez votre activité et celle des autres sur vos tableaux',
  'profile.settings.general': 'Général',
  'profile.settings.language': 'Langue',
  'profile.settings.clearCache': 'Vider le cache',
  'profile.settings.cacheDescription': 'Supprime le cache du site et les données temporaires',
  'profile.settings.notifications': 'Notifications',
  'profile.settings.desktopNotifications': 'Notifications Gmail',
  'profile.settings.assignedToTask': 'Assigné à une tâche',
  'profile.settings.dueDateApproaching': 'Date d’échéance proche',
  'profile.settings.addedToBoard': 'Ajouté à un tableau',
  'profile.settings.manageEmail': 'Gérer les préférences e-mail',
  'profile.settings.appearance': 'Apparence',
  'profile.settings.theme': 'Thème',
  'profile.settings.dark': 'Sombre',
  'profile.settings.light': 'Clair',
  'profile.settings.defaultBoardView': 'Vue de tableau par défaut',
  'profile.settings.kanban': 'Kanban',
  'profile.settings.calendar': 'Calendrier',
  'profile.settings.manageIntegrations': 'Gérer les intégrations',
  'profile.settings.security': 'Sécurité',
  'profile.settings.twoFactor': 'Authentification à deux facteurs',
  'profile.settings.requireVerification': 'Exiger la vérification de connexion',
  'profile.settings.additionalVerification': 'Vérification e-mail supplémentaire pour les nouvelles connexions',
  'profile.settings.sessionTimeout': 'Délai d’inactivité',
  'profile.settings.sessionTimeout1h': 'Après 1 heure d’inactivité',
  'profile.settings.saveChanges': 'Enregistrer les modifications',
  'profile.settings.cacheCleared': 'Cache vidé',
  'profile.settings.comingSoon': 'Bientôt disponible',
  'profile.emailPrefs.title': 'Préférences e-mail',
  'profile.emailPrefs.subtitle': 'Choisissez les e-mails que vous souhaitez recevoir',
  'profile.emailPrefs.enableEmail': 'Notifications e-mail',
  'profile.emailPrefs.assignedToTask': 'Assigné à une tâche',
  'profile.emailPrefs.dueDateApproaching': 'Date d’échéance proche',
  'profile.emailPrefs.addedToBoard': 'Ajouté à un tableau',
  'profile.integrations.title': 'Intégrations',
  'profile.integrations.subtitle': 'Connectez des services à Boardly',
  'profile.integrations.connect': 'Connecter',
  'profile.integrations.slack': 'Alertes Slack et actions rapides',
  'profile.integrations.calendar': 'Synchroniser les échéances avec le calendrier',
  'profile.integrations.github': 'Lier les tâches aux dépôts',
  'profile.fields.firstName': 'Prénom',
  'profile.fields.lastName': 'Nom',
  'profile.fields.organization': 'Organisation',
  'profile.fields.nickname': 'Nom d’utilisateur',
  'profile.fields.theme': 'Thème',
  'profile.fields.themeToggle': 'Bascule du thème',
  'profile.fields.language': 'Langue',
  'profile.fields.emailNotifications': 'Notifications email',
  'profile.notifications.on': 'Activées',
  'profile.notifications.off': 'Désactivées',
  'profile.theme.dark': 'Sombre',
  'profile.theme.light': 'Clair',
  'profile.saveSettings': 'Enregistrer les paramètres',
  'profile.saving': 'Enregistrement...',
  'profile.activity.empty': 'Aucune activité pour le moment.',
  'profile.activity.loadMore': 'Charger plus',
  'profile.activity.type': 'Type : {type}',
  'profile.logoutAll': 'Déconnecter tous les appareils',
  'profile.logoutAllHint': 'Bientôt',
  'profile.errors.requiredName': 'Le prénom et le nom sont requis.',
  'profile.errors.saveFailed': 'Impossible d’enregistrer le profil.',
  'profile.errors.imageOnly': 'Seuls les fichiers image sont pris en charge.',
  'profile.errors.avatarUploadFailed': 'Échec du téléversement de l’avatar.',
  'profile.errors.avatarRemoveFailed': 'Échec de la suppression de l’avatar.',
  'profile.errors.activityLoad': 'Échec du chargement de l’activité.',
  'profile.toast.saved': 'Profil enregistré',
  'profile.toast.avatarUpdated': 'Avatar mis à jour',
  'profile.toast.avatarRemoved': 'Avatar supprimé',
  'profile.time.justNow': 'à l’instant',
  'profile.time.minutesAgo': 'il y a {count} min',
  'profile.time.hoursAgo': 'il y a {count} h',
  'profile.time.daysAgo': 'il y a {count} j',
  'profile.tabs.privacy': 'Politique de confidentialité',
  'profile.backToMain': 'Retour à la page principale',
  'profile.header.title': 'Paramètres du profil',
  'profile.header.subtitle': 'Gérez vos informations personnelles',
  'profile.privacy.title': 'Profil de politique de confidentialité',
  'profile.privacy.subtitle': 'Protégez vos informations personnelles',
  'profile.section.personalInfo': 'Infos personnelles',
  'profile.section.passwordChange': 'Changement de mot de passe',
  'profile.section.workInfo': 'Infos professionnelles',
  'profile.section.access': 'Accès',
  'profile.fields.email': 'E-mail',
  'profile.fields.currentPassword': 'Mot de passe actuel',
  'profile.fields.bio': 'Bio',
  'profile.fields.public': 'Public',
  'profile.placeholders.organization': 'Rôle / Entreprise',
  'profile.placeholders.bio': 'Parlez-nous de vous',
  'profile.actions.changePassword': 'Changer le mot de passe',
  'profile.actions.deactivate': 'Désactiver votre compte',
  'profile.userFallback': 'Utilisateur',
  'profile.confirmDelete': 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
  'profile.deactivate.title': '!ATTENTION!',
  'profile.deactivate.message': 'Cette action est irréversible. Êtes-vous sûr de vouloir désactiver votre compte ?',
  'profile.deactivate.confirm': 'Désactiver',
  'profile.deactivate.close': 'Fermer',
  'activity.context.onBoard': 'sur le tableau {board}',
  'activity.context.toList': 'vers {list}',
  'activity.context.fromList': 'depuis {list}',
  'activity.context.inList': 'dans {list}',
  'activity.context.inChecklist': 'dans la checklist {checklist}',
  'activity.context.onCard': 'sur la carte {card}',
  'activity.noDate': 'sans date',
  'activity.create_board': '{actor} a créé le tableau {board}',
  'activity.rename_board': '{actor} a renommé le tableau {board}',
  'activity.update_board': '{actor} a mis à jour le tableau {board}',
  'activity.archive_board': '{actor} a archivé le tableau {board}',
  'activity.unarchive_board': '{actor} a restauré le tableau {board}',
  'activity.create_list': '{actor} a ajouté la liste {list}{context}',
  'activity.rename_list': '{actor} a renommé la liste {list}',
  'activity.move_list': '{actor} a déplacé la liste {list}{context}',
  'activity.archive_list': '{actor} a archivé la liste {list}',
  'activity.unarchive_list': '{actor} a restauré la liste {list}',
  'activity.copy_list': '{actor} a copié la liste {source} → {target}',
  'activity.create_card': '{actor} a ajouté la carte {card}{context}',
  'activity.move_card': '{actor} a déplacé la carte {card}{from}{to}',
  'activity.archive_card': '{actor} a archivé la carte {card}{context}',
  'activity.unarchive_card': '{actor} a restauré la carte {card}{context}',
  'activity.update_card': '{actor} a mis à jour la carte {card}',
  'activity.update_card_description': '{actor} a mis à jour la description de la carte {card}',
  'activity.update_card_due_date': '{actor} a changé l\'échéance de la carte {card} de {before} à {after}',
  'activity.copy_card': '{actor} a copié la carte {source} → {target}',
  'activity.complete_card': 'Le membre {actor} a marqué cette carte comme terminée',
  'activity.uncomplete_card': 'Le membre {actor} a retiré la marque de fin de cette carte',
  'activity.checklist.unchecked': '{actor} a marqué {item} comme non terminé{checklist}{card}',
  'activity.checklist.checked': '{actor} a marqué {item} comme terminé{checklist}{card}',
  'activity.add_checklist_item': '{actor} a ajouté la sous-tâche {item}{checklist}{card}',
  'activity.update_checklist_item': '{actor} a mis à jour la sous-tâche {item}{checklist}{card}',
  'activity.add_comment': '{actor} a ajouté le commentaire {comment}{card}',
  'activity.labels.added': 'a ajouté les étiquettes : {labels}',
  'activity.labels.removed': 'a supprimé les étiquettes : {labels}',
  'activity.labels.updated': 'a mis à jour les étiquettes',
  'activity.update_card_labels': '{actor} {changes} pour la carte {card}',
  'activity.create_label': '{actor} a créé l\'étiquette {label}{context}',
  'activity.update_label': '{actor} a mis à jour l\'étiquette {label}{context}',
  'activity.delete_label': '{actor} a supprimé l\'étiquette {label}{context}',
  'activity.update_profile': '{actor} a mis à jour le profil',
  'activity.update_avatar': '{actor} a mis à jour l\'avatar',
  'activity.remove_avatar': '{actor} a supprimé l\'avatar',
  'activity.default': '{actor} a effectué l\'action {target}',
  'privacy.summaryTitle': 'Cette politique de confidentialité vise à vous aider à comprendre :',
  'privacy.body.p1': 'Your privacy matters to us. This privacy policy explains how Boardly, and our corporate affiliates collect, use, share, and protect your information when you use our products, services, websites, or otherwise interact with us. We offer a wide range of products, including our cloud and software products. We refer to all of these products, together with our other services and websites, as "Services" in this privacy policy.',
  'privacy.body.p2': 'This privacy policy also explains your choices surrounding how we use information about you, including how you can object to certain uses and how you can access and update certain information. If you do not agree with this privacy policy, do not access or use our Services.',
  'privacy.footer.accessibility': 'Accessibilité',
  'privacy.footer.choices': 'Vos choix de confidentialité',
  'privacy.footer.policy': 'Politique de confidentialité',
  'privacy.footer.terms': 'Conditions',
  'privacy.footer.data': 'Données de sortie',
  'privacy.footer.security': 'Sécurité',
  'errors.boardUpdate': 'Échec de la mise à jour du tableau : {message}',
  'errors.listsLoad': 'Échec du chargement des listes : {message}',
  'errors.cardsLoad': 'Échec du chargement des cartes : {message}',
  'confirm.deleteCard': 'Supprimer cette carte ?',
  'prompt.copyLink': 'Copier ce lien :',
  'toast.membersUpdateFailed': 'Impossible d’actualiser les membres.',
  'toast.cardsReloadFailed': 'Impossible d’actualiser les cartes.',
  'toast.joinFailed': 'Impossible de rejoindre le tableau.',
  'toast.checklistSaveFailed': 'Impossible d’enregistrer la checklist.',
  'toast.checklistDeleteFailed': 'Impossible de supprimer la checklist.',
  'toast.checklistItemAddFailed': 'Impossible d’ajouter un élément.',
  'toast.labelCreateFailed': 'Impossible de créer l’étiquette.',
  'toast.commentAddFailed': 'Impossible d’ajouter le commentaire.',
  'toast.commentDeleteFailed': 'Impossible de supprimer le commentaire.',
  'toast.attachmentAdded': 'Pièce jointe ajoutée',
  'toast.attachmentAddFailed': 'Impossible d’ajouter la pièce jointe.',
  'toast.attachmentDeleteFailed': 'Impossible de supprimer la pièce jointe.',
  'toast.memberAddFailed': 'Impossible d’ajouter le membre.',
  'toast.memberRoleFailed': 'Impossible de changer le rôle.',
  'toast.memberRemoveFailed': 'Impossible de supprimer le membre.',
  'toast.inviteUnavailable': 'Lien d’invitation indisponible.',
  'toast.cardSaveFailed': 'Impossible d’enregistrer la carte.',
  'toast.cardCopied': 'Carte copiée',
  'toast.cardCopyFailed': 'Impossible de copier la carte.',
  'toast.listCopied': 'Liste copiée',
  'toast.listCopying': 'Copie de la liste...',
  'toast.listCopyFailed': 'Impossible de copier la liste.',
  'toast.listMoveFailed': 'Impossible de déplacer la liste.',
  'toast.cardCreateFailed': 'Impossible de créer la carte.',
  'toast.cardMoveFailed': 'Impossible de déplacer la carte.',
  'toast.cardDeleteFailed': 'Impossible de supprimer la carte.',
  'toast.cardArchiveFailed': 'Impossible de mettre à jour l’archivage de la carte.',
  'toast.boardCreateFailed': 'Impossible de créer le tableau.',
  'toast.boardUpdateFailed': 'Impossible de mettre à jour le tableau.',
  'toast.boardArchiveFailed': 'Impossible de mettre à jour l’archivage du tableau.',
  'toast.listArchiveFailed': 'Impossible de mettre à jour l’archivage de la liste.',
  'toast.listCreateFailed': 'Impossible de créer la liste.',
  'toast.listRenameFailed': 'Impossible de renommer la liste.',
};

translations.es = {
  ...baseEn,
  'nav.board': 'Tablero',
  'nav.myCards': 'Mis tarjetas',
  'nav.profile': 'Perfil',
  'nav.faq': 'FAQ',
  'nav.help': 'Ayuda',
  'nav.community': 'Comunidad',
  'nav.logout': 'Cerrar sesión',
  'nav.greeting': 'Hola, {name}',
  'nav.menu': 'Menú',
  'nav.language': 'Idioma',
  'help.title': '¿Cómo podemos ayudarte?',
  'help.subtitle': 'Encuentra respuestas en los recursos de soporte de Boardly.',
  'help.featured.title': 'Contenido destacado',
  'help.featured.item1': '¿Qué son los esquemas de permisos en Boardly?',
  'help.featured.item2': 'Controla cómo los usuarios acceden a las aplicaciones',
  'help.featured.item3': 'Cambiar las direcciones de correo de la cuenta de Atlassian',
  'help.featured.item4': 'Desactivar una cuenta administrada',
  'help.featured.item5': 'Verificar un dominio para gestionar cuentas',
  'help.featured.item6': 'Configurar SAML single sign-on con un proveedor de identidad',
  'help.featured.item7': 'Dar permisos de administrador a los usuarios',
  'help.featured.item8': 'Entender el aprovisionamiento de usuarios',
  'help.featured.item9': 'Direcciones IP y dominios para apps en la nube de Boardly',
  'help.resources.title': 'Explorar recursos',
  'help.resources.community.title': 'Comunidad',
  'help.resources.community.body': 'Encuentra respuestas, soporte e inspiración de otros usuarios de Boardly.',
  'help.resources.community.link': 'Visitar la comunidad de Boardly',
  'help.resources.status.title': 'Estado del sistema',
  'help.resources.status.body': 'Comprueba el estado de nuestras apps y servicios en la nube.',
  'help.resources.status.link': 'Ver estado del sistema',
  'help.resources.suggestions.title': 'Sugerencias e informes de errores',
  'help.resources.suggestions.body': 'Consulta sugerencias de funciones y reportes de errores existentes.',
  'help.resources.suggestions.link': 'Ver sugerencias y errores',
  'help.resources.marketplace.title': 'Apps del Marketplace',
  'help.resources.marketplace.body': 'Encuentra funciones para personalizar tus apps.',
  'help.resources.marketplace.link': 'Ver Marketplace',
  'help.resources.billing.title': 'Facturación y licencias',
  'help.resources.billing.body': 'Consulta las FAQ sobre facturación y licencias.',
  'help.resources.billing.link': 'Ver FAQ',
  'help.resources.training.title': 'Formación y certificación',
  'help.resources.training.body': 'Desarrolla nuevas habilidades, mejora el trabajo de tu equipo y tu carrera.',
  'help.resources.training.link': 'Ver formación',
  'help.resources.developers.title': 'Desarrolladores',
  'help.resources.developers.body': 'Documentación de API y guías para desarrollar apps e integraciones.',
  'help.resources.developers.link': 'Ver documentación para desarrolladores',
  'help.resources.enterprise.title': 'Enterprise',
  'help.resources.enterprise.body': 'Conoce Boardly Enterprise y los productos Data Center.',
  'help.resources.enterprise.link': 'Ver documentación de Enterprise',
  'help.resources.government.title': 'Soporte Government Cloud',
  'help.resources.government.body': 'Soporte técnico y de migración para proyectos Government de Boardly.',
  'help.resources.government.link': 'Inicia sesión para contactar con soporte',
  'help.resources.success.title': 'Success Central',
  'help.resources.success.body': 'Ayuda para adoptar tus apps con contenidos de Boardly y socios.',
  'help.resources.success.link': 'Ver Success Central',
  'help.contact.title': '¿No encuentras la ayuda que necesitas?',
  'help.contact.button': 'Contactar soporte',
  'help.footer.copyright': 'Copyright © 2026 Boardly',
  'help.footer.accessibility': 'Accesibilidad',
  'help.footer.privacyChoices': 'Tus opciones de privacidad',
  'help.footer.privacyPolicy': 'Política de privacidad',
  'help.footer.terms': 'Términos',
  'help.footer.impressum': 'Impressum',
  'help.footer.security': 'Seguridad',
  'community.title': 'Crea tu mejor vida laboral, juntos',
  'community.subtitle': 'Aprende, conéctate y crece con la comunidad Boardly.',
  'community.getStarted.title': 'Comenzar',
  'community.getStarted.link': 'Encontrar respuestas',
  'community.getStarted.forums.title': 'Foros',
  'community.getStarted.forums.body': 'Haz preguntas y recibe ayuda de expertos y colegas.',
  'community.getStarted.learning.title': 'Aprendizaje',
  'community.getStarted.learning.body': 'Guías, tutoriales y mejores prácticas.',
  'community.getStarted.events.title': 'Eventos',
  'community.getStarted.events.body': 'Únete a sesiones y conoce a la comunidad en vivo.',
  'community.getStarted.champions.title': 'Campeones',
  'community.getStarted.champions.body': 'Conéctate con usuarios avanzados y embajadores.',
  'community.advice.title': 'Obtén consejos y conéctate',
  'community.advice.body': 'Los foros de la comunidad son un excelente lugar para obtener respuestas de expertos y colegas. Encuentra soluciones o haz tus propias preguntas.',
  'community.back': 'Atrás',
  'community.kicker.forums': 'Foros de la comunidad',
  'community.learning.title': 'Mejora tus habilidades con aprendizaje flexible',
  'community.learning.body': 'Nuestros cursos gratuitos bajo demanda te ayudan a aprender apps de Atlassian y trabajar más rápido. Sube de nivel con formación dirigida por instructores y certificaciones de Atlassian.',
  'community.learning.longBody': 'Desarrolla experiencia práctica con rutas de aprendizaje estructuradas, ejemplos reales y buenas prácticas guiadas. Desde fundamentos hasta flujos avanzados, estos recursos ayudan a tu equipo a aplicar el conocimiento más rápido, mejorar la colaboración y lograr mejores resultados.',
  'community.redesign.hero.title': 'Organiza tus tareas y resuelvelas desde cualquier lugar.',
  'community.redesign.hero.subtitle': 'Organiza proyectos, aumenta la productividad y trabaja aun mas eficientemente con nuestra app.',
  'community.redesign.hero.cta': 'Registrate gratis!',
  'community.redesign.preview.todo.title': 'Por hacer',
  'community.redesign.preview.todo.task1': 'Disenar la pagina de inicio de sesion',
  'community.redesign.preview.todo.task2': 'Crear tablero de tareas',
  'community.redesign.preview.todo.task3': 'Configurar notificaciones',
  'community.redesign.preview.progress.title': 'En progreso',
  'community.redesign.preview.progress.task': 'Implementar drag and drop',
  'community.redesign.preview.done.title': 'Hecho',
  'community.redesign.basicFunctions': 'Funciones basicas',
  'community.redesign.sources.title': 'Fuentes de productividad',
  'community.redesign.sources.subtitle': 'Trabaja con mas eficiencia usando tableros, mapas y automatizacion, incluso en movimiento.',
  'community.redesign.sources.imageAlt': 'Vista previa del tablero de tareas',
  'community.redesign.moveTasks.title': 'Mover tareas',
  'community.redesign.moveTasks.body': 'Mueve tareas facilmente con drag and drop.',
  'community.redesign.actions.heading': 'De mensajes a acciones',
  'community.redesign.actions.subtitle': 'Reune notificaciones importantes en un solo lugar y conviertelas en tareas productivas.',
  'community.redesign.actions.messages.title': 'Tus mensajes de Slack',
  'community.redesign.actions.messages.body': 'Convierte mensajes entrantes en tareas en segundos.',
  'community.redesign.actions.automation.title': 'Usa automatizacion',
  'community.redesign.actions.automation.body': 'Automatiza tareas con recomendaciones inteligentes.',
  'community.redesign.actions.communicate.title': 'Comunicate al instante',
  'community.redesign.actions.communicate.body': 'Comunicate con tu equipo en tiempo real.',
  'community.redesign.more.heading': 'Haz mas con Boardly',
  'community.redesign.more.subtitle': 'Personaliza la app con integraciones, automatizacion y ajustes de flujo de trabajo.',
  'community.redesign.more.integrations.title': 'Integraciones',
  'community.redesign.more.integrations.body': 'Conecta tus herramientas favoritas.',
  'community.redesign.more.automation.title': 'Automatizacion',
  'community.redesign.more.automation.body': 'Configura acciones automaticas.',
  'community.redesign.more.customization.title': 'Personalizacion',
  'community.redesign.more.customization.body': 'Ajusta los tableros a tus necesidades.',
  'community.redesign.more.mobile.title': 'Movil',
  'community.redesign.more.mobile.body': 'Trabaja desde cualquier lugar con una sola app.',
  'community.redesign.signup.title': 'Comienza con Boardly hoy',
  'community.redesign.signup.note': 'Al ingresar mi correo, acepto los terminos y la',
  'community.redesign.signup.privacy': 'Politica de privacidad',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.search': 'Buscar',
  'common.loading': 'Cargando...',
  'common.error': 'Ocurrió un error',
  'common.actionFailed': 'No se pudo completar la acción. Inténtalo de nuevo.',
  'common.retry': 'Reintentar',
  'common.close': 'Cerrar',
  'common.add': 'Agregar',
  'common.assigned': 'Asignado',
  'common.notAssigned': 'No asignado',
  'common.create': 'Crear',
  'common.update': 'Actualizar',
  'common.copyLink': 'Copiar enlace',
  'common.share': 'Compartir',
  'common.clear': 'Limpiar',
  'common.noConnection': 'Sin conexión',
  'common.saving': 'Guardando...',
  'common.unknown': 'desconocido',
  'common.linkCopied': 'Enlace copiado',
  'common.copySuffix': ' (copia)',
  'common.copy': 'Copiar',
  'common.copying': 'Copiando...',
  'common.edit': 'Editar',
  'common.creating': 'Creando...',
  'common.confirmDelete': '¿Eliminar?',
  'common.redirecting': 'Redirigiendo...',
  'common.or': 'o',
  'auth.welcome': 'Bienvenido',
  'auth.createAccount': 'Crear cuenta',
  'auth.joinBoardly': 'Únete a Boardly y gestiona tareas de forma eficiente.',
  'auth.enterDetails': 'Introduce tus datos para iniciar sesión.',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellido',
  'auth.email': 'Correo',
  'auth.username': 'Nombre de usuario',
  'auth.password': 'Contraseña',
  'auth.placeholderFirstName': 'Juan',
  'auth.placeholderLastName': 'Pérez',
  'auth.placeholderUsername': 'Tu usuario',
  'auth.placeholderPassword': '********',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.processing': 'Procesando...',
  'auth.signUp': 'Registrarse',
  'auth.signIn': 'Iniciar sesión',
  'auth.hasAccount': '¿Ya tienes cuenta?',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.googleError': 'No se pudo iniciar sesión con Google.',
  'auth.loginError': 'Error de autenticación.',
  'auth.registerSuccessTitle': '¡Registro completado!',
  'auth.registerSuccessHint': 'Enviamos un correo de confirmación a {email}. Revisa tu bandeja de entrada.',
  'auth.backToLogin': 'Volver a iniciar sesión',
  'auth.organizationOptional': 'Organización (opcional)',
  'auth.usernameOrEmail': 'Usuario o correo',
  'auth.policyPrefix': 'Acepto la',
  'auth.policyLink': 'política de privacidad',
  'auth.googleSignIn': 'Iniciar sesión con Google',
  'auth.invalidEmail': 'Correo electrónico no válido.',
  'auth.passwordTooShort': 'La contraseña debe tener al menos {min} caracteres.',
  'auth.policyRequired': 'Acepta la política de privacidad.',
  'activation.loadingTitle': 'Activando cuenta...',
  'activation.loadingHint': 'Por favor espera.',
  'activation.successTitle': '¡Cuenta activada! 🎉',
  'activation.successHint': 'Ahora puedes iniciar sesión.',
  'activation.signIn': 'Iniciar sesión',
  'activation.errorTitle': 'Fallo de activación',
  'activation.errorHint': 'El enlace es inválido o ha expirado.',
  'activation.back': 'Volver',
  'auth.preview.todoTitle': 'Por hacer',
  'auth.preview.todoCard': 'Diseño de la página de inicio',
  'auth.preview.progressTitle': 'En progreso',
  'auth.preview.progressCard': 'Implementar drag & drop',
  'auth.preview.doneTitle': 'Hecho',
  'auth.preview.doneCard': 'Creación del tablero',
  'passwordReset.title': 'Restablecer contraseña',
  'passwordReset.description': 'Introduce tu email y te enviaremos un enlace de restablecimiento.',
  'passwordReset.successTitle': '¡Email enviado!',
  'passwordReset.successHint': 'Revisa tu bandeja (o la consola de Django) para el enlace.',
  'passwordReset.successDetail': 'Enviamos instrucciones a {email}. Revisa tu bandeja de entrada y spam.',
  'passwordReset.backToLogin': 'Volver a iniciar sesión',
  'passwordReset.emailLabel': 'Email',
  'passwordReset.emailPlaceholder': 'name@example.com',
  'passwordReset.submit': 'Restablecer contraseña',
  'passwordReset.sending': 'Enviando...',
  'passwordReset.remembered': 'Ya recuerdo mi contraseña',
  'passwordReset.error': 'No se encontró un usuario con ese email o ocurrió un error.',
  'resetConfirm.title': 'Nueva contraseña',
  'resetConfirm.description': 'Crea una nueva contraseña segura para tu cuenta.',
  'resetConfirm.successTitle': '¡Éxito!',
  'resetConfirm.successHint': 'La contraseña se cambió. Redirigiendo al inicio de sesión...',
  'resetConfirm.successAction': 'Iniciar sesión con la nueva contraseña',
  'resetConfirm.newPasswordLabel': 'Nueva contraseña',
  'resetConfirm.newPasswordPlaceholder': 'Mínimo 8 caracteres',
  'resetConfirm.confirmPasswordLabel': 'Confirmar contraseña',
  'resetConfirm.confirmPasswordPlaceholder': 'Repite la contraseña',
  'resetConfirm.submit': 'Cambiar contraseña',
  'resetConfirm.saving': 'Guardando...',
  'resetConfirm.errorMismatch': 'Las contraseñas no coinciden',
  'resetConfirm.errorPassword': 'Contraseña: {message}',
  'resetConfirm.errorInvalidLink': 'El enlace es inválido o ha expirado.',
  'resetConfirm.errorUnknown': 'Ocurrió un error desconocido. Inténtalo de nuevo.',
  'lang.uk': 'Ucraniano',
  'lang.en': 'Inglés',
  'lang.pl': 'Polaco',
  'lang.de': 'Alemán',
  'lang.fr': 'Francés',
  'lang.es': 'Español',
  'board.archive': 'Archivar tablero',
  'board.archiveConfirm': '¿Archivar este tablero?',
  'board.archivedSuffix': '(archivado)',
  'board.create.newButton': '+ Nuevo tablero',
  'board.create.titlePlaceholder': 'Nombre del tablero',
  'board.create.titleLabel': 'Nombre del tablero',
  'board.create.titleInputPlaceholder': 'Introduce un título...',
  'board.empty.title': 'Crea tu primer tablero',
  'board.empty.subtitle': 'Agrega un tablero para comenzar.',
  'board.menu': 'Menú del tablero',
  'board.menu.changeBackground': 'Cambiar fondo',
  'board.menu.members': 'Miembros',
  'board.menu.archived': 'Elementos archivados',
  'board.menu.inviteTitle': 'Invitar',
  'board.account.title': 'Cuenta',
  'board.account.changeAccount': 'Cambiar cuenta',
  'board.account.profile': 'Perfil',
  'board.account.settings': 'Configuración',
  'board.account.backgrounds': 'Fondos',
  'board.account.logout': 'Cerrar sesión',
  'board.filters': 'Filtros',
  'board.select.title': 'Elegir tablero',
  'board.settings': 'Configuración del tablero',
  'board.error.loadDetails': 'No se pudieron cargar los detalles del tablero.',
  'board.unarchive': 'Restaurar tablero',
  'board.unarchiveConfirm': '¿Restaurar este tablero?',
  'board.deleteConfirm': '¿Eliminar el tablero?',
  'board.delete': 'Eliminar tablero',
  'board.leave': 'Salir del tablero',
  'board.joining': 'Uniéndose al tablero...',
  'board.background.title': 'Fondo del tablero',
  'board.background.upload': 'Subir imagen',
  'board.background.reset': 'Restablecer',
  'board.background.apply': 'Aplicar',
  'board.background.urlPlaceholder': 'Pega la URL de la imagen...',
  'board.background.colorSelected': 'Color seleccionado',
  'board.background.gradientSelected': 'Degradado seleccionado',
  'board.background.imageSelected': 'Imagen seleccionada',
  'board.background.invalidFile': 'Elige un archivo de imagen.',
  'board.background.tooLarge': 'Archivo demasiado grande (máx. {size} MB).',
  'board.background.uploadHint': 'PNG, JPG - hasta 5 MB - mínimo 1920 por 1080',
  'board.background.colors': 'Colores',
  'board.background.gradients': 'Degradados',
  'board.background.images': 'Imágenes',
  'board.background.default': 'Predeterminado',
  'board.background.slate': 'Pizarra',
  'board.background.charcoal': 'Carbón',
  'board.background.indigo': 'Índigo',
  'board.background.emerald': 'Esmeralda',
  'board.background.warmLight': 'Claro cálido',
  'board.background.gradient.sunset': 'Atardecer',
  'board.background.gradient.ocean': 'Océano',
  'board.background.gradient.forest': 'Bosque',
  'board.background.gradient.blush': 'Rubor',
  'board.background.gradient.night': 'Noche',
  'board.background.gradient.dawn': 'Amanecer',
  'toolbar.searchPlaceholder': 'Buscar en el tablero',
  'toolbar.actions': 'Acciones del tablero',
  'toolbar.matches': 'coincidencias',
  'toolbar.noMatches': 'Sin resultados',
  'filters.title': 'Filtros',
  'filters.membersLabel': 'Miembros',
  'filters.membersAll': 'Todos los miembros',
  'filters.labelsLabel': 'Etiquetas',
  'filters.labelsAll': 'Todas las etiquetas',
  'filters.dueLabel': 'Fecha límite',
  'filters.dueAny': 'Cualquier fecha',
  'filters.dueOverdue': 'Atrasadas',
  'filters.dueToday': 'Para hoy',
  'filters.dueWeek': 'Para esta semana',
  'filters.dueNone': 'Sin fecha límite',
  'filters.completedLabel': 'Estado',
  'filters.completedAll': 'Todas',
  'filters.completedOnly': 'Completadas',
  'filters.incompleteOnly': 'Incompletas',
  'filters.reset': 'Restablecer',
  'filters.apply': 'Aplicar',
  'archive.cards': 'Tarjetas archivadas',
  'archive.lists': 'Listas archivadas',
  'archive.showCards': 'Mostrar tarjetas archivadas',
  'archive.hideCards': 'Ocultar tarjetas archivadas',
  'archive.showLists': 'Mostrar listas archivadas',
  'archive.hideLists': 'Ocultar listas archivadas',
  'archive.badge': 'Archivado',
  'list.addButton': '+ Agregar lista',
  'list.create.placeholder': 'Nombre de la lista',
  'list.create.submit': 'Crear lista',
  'list.empty.noneTitle': 'No hay listas',
  'list.empty.noneSubtitle': 'Crea tu primera lista para agregar tarjetas.',
  'list.empty.archivedTitle': 'Listas archivadas',
  'list.empty.archivedSubtitle': 'Activa la vista de archivo para verlas.',
  'list.empty.showArchived': 'Mostrar listas archivadas',
  'list.menu': 'Menú de la lista',
  'list.menu.addCard': 'Agregar tarjeta',
  'list.menu.move': 'Mover lista',
  'list.menu.moveAll': 'Mover todas las tarjetas de esta lista',
  'list.menu.sort': 'Ordenar por...',
  'list.menu.subscribe': 'Suscribirse',
  'list.menu.unsubscribe': 'Cancelar suscripción',
  'list.menu.movePrompt': 'Introduce la nueva posición de la lista',
  'list.menu.moveAllPrompt': 'Introduce el ID de la lista destino para mover todas las tarjetas',
  'list.menu.sortPrompt': 'Elige el orden',
  'list.menu.sortByDue': 'Por fecha límite',
  'list.menu.sortByTitle': 'Por título',
  'list.menu.comingSoon': 'Disponible pronto',
  'list.menu.automation': 'Automatización',
  'list.menu.automationAdd': 'Cuando se agrega una tarjeta a la lista...',
  'list.menu.automationDaily': 'Cada día, ordenar por...',
  'list.menu.automationRule': 'Crear regla',
  'list.menu.archiveAllCards': 'Archivar todas las tarjetas de esta lista',
  'list.menu.devCanAddCards': 'El desarrollador puede agregar tarjetas',
  'list.menu.devCannotAddCards': 'El desarrollador no puede agregar tarjetas',
  'list.rename': 'Renombrar',
  'list.copy': 'Copiar lista',
    'list.archive': 'Archivar lista',
    'list.unarchive': 'Restaurar lista',
    'list.color.title': 'Cambiar color',
    'list.color.none': 'Sin color',
    'list.collapse': 'Colapsar',
  'list.moveLeft': 'Mover a la izquierda',
  'list.moveRight': 'Mover a la derecha',
  'list.position': 'Posición',
  'list.archiveConfirm': '¿Archivar esta lista?',
  'list.archiveAllCardsConfirm': '¿Archivar todas las tarjetas de esta lista?',
  'list.unarchiveConfirm': '¿Restaurar esta lista?',
  'card.create.newButton': '+ Nueva tarjeta',
  'card.create.placeholder': 'Título de la tarjeta...',
  'card.descriptionPlaceholder': 'Añadir descripción',
  'card.descriptionTitle': 'Descripción',
  'card.descriptionEmpty': 'Sin descripción.',
  'card.dueDate': 'Fecha límite',
  'card.dueDateRemove': 'Quitar fecha límite',
  'card.dueDatePreview': 'Seleccionado: {date}',
  'card.dueDateRequired': 'Selecciona una fecha límite',
  'card.empty': 'Sin tarjetas',
  'card.menu': 'Menú de la tarjeta',
  'card.menu.move': 'Mover',
  'card.menu.copy': 'Copiar',
  'card.menu.share': 'Compartir',
  'card.menu.mirror': 'Espejo',
  'card.menu.template': 'Crear plantilla',
  'card.menu.subscribe': 'Suscribirse',
  'card.menu.copyLinkPrompt': 'Copia este enlace manualmente',
  'card.menu.archive': 'Archivar',
  'card.menu.delete': 'Eliminar',
  'card.move.title': 'Mover tarjeta',
  'card.move.list': 'Lista',
  'card.move.position': 'Posición',
  'card.move.button': 'Mover',
  'card.moveToList': 'Mover a la lista',
  'card.copy': 'Copiar tarjeta',
  'card.archive': 'Archivar',
  'card.unarchive': 'Restaurar',
  'card.inList': 'En la lista',
  'card.members': 'Miembros',
  'card.completedBadge': 'HECHO',
  'card.private': 'Tarjeta privada',
  'card.overdue.days': '(Atrasado {count} días)',
  'card.overdue.hours': '(Atrasado {count} h)',
  'card.overdue.minutes': '(Atrasado {count} min)',
  'card.moveUp': 'Mover arriba',
  'card.moveDown': 'Mover abajo',
  'card.moveLeft': 'Mover a la izquierda',
  'card.moveRight': 'Mover a la derecha',
  'card.sidebar.participation': 'Participación',
  'card.sidebar.join': 'Unirse',
  'card.sidebar.leave': 'Salir',
  'card.joinError': 'No se pudo unirse a la tarjeta.',
  'card.sidebar.add': 'Agregar',
  'card.sidebar.actions': 'Acciones',
  'card.cover.title': 'Portada',
  'card.cover.remove': 'Quitar portada',
  'card.colorTitle': 'Color de la tarjeta',
  'card.colorHint': 'Elige un color o restablece el predeterminado.',
  'card.color.none': 'Sin color',
  'card.color.sun': 'Sol',
  'card.color.rose': 'Rosa',
  'card.color.sky': 'Cielo',
  'card.color.violet': 'Violeta',
  'card.color.emerald': 'Esmeralda',
  'card.color.teal': 'Turquesa',
  'card.color.slate': 'Pizarra',
  'card.quick.add': 'Agregar',
  'card.quick.addHint': 'Agrega desde el panel derecho',
  'card.quick.dates': 'Fechas',
  'card.quick.checklist': 'Lista',
  'card.quick.attach': 'Adjunto',
  'card.quick.members': 'Miembros',
  'card.quick.comingSoon': 'Próximamente',
  'card.watch': 'Seguir',
  'card.add.title': 'Añadir a la tarjeta',
  'card.add.labels': 'Etiquetas',
  'card.add.labelsHint': 'Desplázate a las etiquetas abajo',
  'card.add.dates': 'Fechas',
  'card.add.checklist': 'Lista',
  'card.add.members': 'Miembros',
  'card.add.attachments': 'Adjuntos',
  'card.cover.size': 'Tamaño',
  'card.cover.size.full': 'Completa',
  'card.cover.size.header': 'Encabezado',
  'card.cover.colors': 'Colores',
  'card.cover.colorblind': 'Activar modo daltónico',
  'card.cover.colorblind.enable': 'Activar modo daltónico',
  'card.cover.colorblind.disable': 'Desactivar modo daltónico',
  'checklist.title': 'Lista de verificación',
  'checklist.titlePlaceholder': 'Título de la lista',
  'checklist.itemPlaceholder': 'Nueva tarea',
  'checklist.add': 'Agregar lista',
  'checklist.hint': 'La lista se guarda automáticamente al añadir elementos.',
  'checklist.empty': 'La checklist aún no se ha creado.',
  'checklist.copy.title': 'Copiar elementos',
  'checklist.copy.selectCard': 'Selecciona una tarjeta',
  'checklist.createPopoverTitle': 'Agregar una lista',
  'checklist.nameLabel': 'Nombre',
  'checklist.copy.fromLabel': 'Copiar elemento desde...',
  'checklist.copy.none': 'Falta',
  'checklist.copy.emptySource': 'La tarjeta seleccionada no tiene elementos para copiar.',
  'checklist.copy.append': 'Agregar al final',
  'checklist.copy.replace': 'Reemplazar todo',
  'attachments.title': 'Adjuntos',
  'attachments.empty': 'No hay adjuntos.',
  'attachments.add': 'Agregar archivo',
  'comments.title': 'Comentarios',
  'comments.activityTitle': 'Comentarios y actividad',
  'comments.showDetails': 'Mostrar detalles',
  'comments.hideDetails': 'Ocultar detalles',
  'comments.empty': 'No hay comentarios.',
  'comments.add': 'Agregar comentario',
  'comments.answer': 'Responder',
  'comments.send': 'Enviar',
  'comments.react': 'Reaccionar',
  'comments.addReaction': 'Agregar reacción',
  'comments.reactionPicker': 'Selector de emoji',
  'comment.placeholder': 'Escribe un comentario...',
  'labels.title': 'Etiquetas',
  'labels.empty': 'No hay etiquetas.',
  'labels.newPlaceholder': 'Nueva etiqueta',
  'labels.add': 'Agregar etiqueta',
  'labels.newPrompt': 'Nombre de la nueva etiqueta:',
  'labels.deleteConfirm': '¿Eliminar esta etiqueta? Se quitará de todas las tarjetas.',
  'labels.hint': 'Las etiquetas se guardan al hacer clic en {action}.',
  'members.title': 'Miembros',
  'members.modalTitle': 'Miembros del tablero',
  'members.inviteTitle': 'Invitar',
  'members.searchPlaceholder': 'Nombre, usuario o email',
  'members.addListTitle': 'Agregar una lista',
  'members.searchParticipants': 'Buscar participantes',
  'members.boardMembersTitle': 'Miembros del tablero',
  'members.searching': 'Buscando...',
  'members.refreshing': 'Actualizando la lista de miembros...',
  'members.empty': 'No se encontraron usuarios.',
  'members.inviteEmail': 'Invitar por email',
  'members.adding': 'Agregando...',
  'members.removing': 'Eliminando...',
  'members.roleOwner': 'Propietario',
  'members.roleAdmin': 'Administrador',
  'members.roleMember': 'Miembro',
  'members.roleDeveloper': 'Desarrollador',
  'members.roleViewer': 'Espectador',
  'members.roleLabel': 'Rol',
  'members.permissionsHint': 'Solo el propietario o los administradores pueden agregar miembros.',
  'members.viewerCannotBeAssigned': 'Los espectadores no pueden asignarse a tarjetas.',
  'members.shareAria': 'Compartir',
  'members.more': 'Más {count}',
  'members.viewActivity': 'Ver actividad del tablero',
  'members.makeAdmin': 'Hacer administrador',
  'members.removeAdmin': 'Quitar administrador',
  'members.removeFromBoard': 'Eliminar del tablero',
  'members.workspaceParticipants': 'Participantes del espacio de trabajo',
  'members.guests': 'Invitados',
  'members.activityTitle': 'Actividad de {name}',
  'members.activityEmpty': 'No hay actividad en este tablero.',
  'permissions.title': 'Permisos de desarrollador',
  'permissions.devCreateCards': 'El desarrollador puede crear tarjetas',
  'permissions.devEditAssigned': 'El desarrollador puede editar tarjetas asignadas',
  'permissions.devArchiveAssigned': 'El desarrollador puede archivar tarjetas asignadas',
  'permissions.devJoinCard': 'El desarrollador puede unirse a tarjetas ajenas',
  'permissions.devCreateLists': 'El desarrollador puede crear listas',
  'hotkeys.hint': 'Atajos: Ctrl+K',
  'hotkeys.aria': 'Atajos de teclado',
  'command.title': 'Comandos',
  'command.placeholder': 'Buscar comandos',
  'command.empty': 'No se encontraron comandos',
  'command.createCard': 'Crear tarjeta',
  'command.createList': 'Crear lista',
  'command.createBoard': 'Crear tablero',
  'command.goProfile': 'Ir al perfil',
  'command.goMyCards': 'Ir a mis tarjetas',
  'command.goFaq': 'Abrir FAQ',
  'myCards.title': 'Mis tarjetas',
  'myCards.loading': 'Cargando tarjetas...',
  'myCards.loadError': 'No se pudieron cargar las tarjetas.',
  'myCards.emptyAssigned': 'Aún no tienes tarjetas asignadas.',
  'myCards.emptyList': 'No hay tarjetas para mostrar.',
  'myCards.boardFallback': 'Tablero sin título',
  'myCards.boardUnavailable': 'El tablero no está disponible.',
  'myCards.boardArchived': 'El tablero está archivado.',
  'landing.hero.line1': 'Captura,',
  'landing.hero.line2': 'organiza',
  'landing.hero.line3': 'y completa tareas',
  'landing.hero.line4': 'en cualquier lugar.',
  'landing.copy.line1': 'Deja el caos atrás —',
  'landing.copy.line2': 'libera tu potencial y',
  'landing.copy.line3': 'aumenta tu productividad con Boardly.',
  'landing.cta.openApp': 'Ir a tableros',
  'landing.cta.signUp': '¡Regístrate gratis!',
  'faq.title': 'FAQ',
  'faq.q1': '¿Cómo creo un nuevo tablero?',
  'faq.a1': 'Haz clic en "+ Nuevo tablero" en la página de tableros.',
  'faq.q2': '¿Cómo agrego una lista?',
  'faq.a2': 'Haz clic en "+ Agregar lista" en la barra del tablero.',
  'faq.q3': '¿Cómo invito miembros?',
  'faq.a3': 'Abre Compartir y agrega personas por nombre o email.',
  'faq.q4': '¿Dónde veo mis tarjetas?',
  'faq.a4': 'Abre Mis tarjetas en el menú superior.',
  'profile.tabsLabel': 'Secciones del perfil',
  'profile.tabs.profile': 'Perfil',
  'profile.tabs.activity': 'Actividad',
  'profile.tabs.settings': 'Configuración',
  'profile.authRequiredTitle': 'Autenticación requerida',
  'profile.authRequiredHint': 'Inicia sesión para ver tu perfil.',
  'profile.avatarAlt': 'Avatar de usuario',
  'profile.avatar.change': 'Cambiar avatar',
  'profile.avatar.remove': 'Eliminar avatar',
  'profile.sections.profile': 'Perfil',
  'profile.sections.activity': 'Actividad',
  'profile.sections.settings': 'Configuración',
  'profile.settings.subtitle': 'Administra la configuración de tu cuenta',
  'profile.activity.subtitle': 'Sigue tu actividad y la de otros en tus tableros',
  'profile.settings.general': 'General',
  'profile.settings.language': 'Idioma',
  'profile.settings.clearCache': 'Borrar caché',
  'profile.settings.cacheDescription': 'Elimina la caché del sitio y los datos temporales',
  'profile.settings.notifications': 'Notificaciones',
  'profile.settings.desktopNotifications': 'Notificaciones de Gmail',
  'profile.settings.assignedToTask': 'Asignado a una tarea',
  'profile.settings.dueDateApproaching': 'Se acerca la fecha de vencimiento',
  'profile.settings.addedToBoard': 'Añadido a un tablero',
  'profile.settings.manageEmail': 'Gestionar preferencias de email',
  'profile.settings.appearance': 'Apariencia',
  'profile.settings.theme': 'Tema',
  'profile.settings.dark': 'Oscuro',
  'profile.settings.light': 'Claro',
  'profile.settings.defaultBoardView': 'Vista de tablero predeterminada',
  'profile.settings.kanban': 'Kanban',
  'profile.settings.calendar': 'Calendario',
  'profile.settings.manageIntegrations': 'Gestionar integraciones',
  'profile.settings.security': 'Seguridad',
  'profile.settings.twoFactor': 'Autenticación de dos factores',
  'profile.settings.requireVerification': 'Requerir verificación de inicio de sesión',
  'profile.settings.additionalVerification': 'Verificación de email adicional para nuevos accesos',
  'profile.settings.sessionTimeout': 'Tiempo de espera de sesión',
  'profile.settings.sessionTimeout1h': 'Después de 1 hora de inactividad',
  'profile.settings.saveChanges': 'Guardar cambios',
  'profile.settings.cacheCleared': 'Caché borrada',
  'profile.settings.comingSoon': 'Próximamente',
  'profile.emailPrefs.title': 'Preferencias de correo',
  'profile.emailPrefs.subtitle': 'Elige qué correos quieres recibir',
  'profile.emailPrefs.enableEmail': 'Notificaciones por correo',
  'profile.emailPrefs.assignedToTask': 'Asignado a una tarea',
  'profile.emailPrefs.dueDateApproaching': 'Se acerca la fecha de vencimiento',
  'profile.emailPrefs.addedToBoard': 'Añadido a un tablero',
  'profile.integrations.title': 'Integraciones',
  'profile.integrations.subtitle': 'Conecta servicios para trabajar con Boardly',
  'profile.integrations.connect': 'Conectar',
  'profile.integrations.slack': 'Alertas en Slack y acciones rápidas',
  'profile.integrations.calendar': 'Sincronizar plazos con el calendario',
  'profile.integrations.github': 'Vincular tareas con repositorios',
  'profile.fields.firstName': 'Nombre',
  'profile.fields.lastName': 'Apellido',
  'profile.fields.organization': 'Organización',
  'profile.fields.nickname': 'Nombre de usuario',
  'profile.fields.theme': 'Tema',
  'profile.fields.themeToggle': 'Interruptor de tema',
  'profile.fields.language': 'Idioma',
  'profile.fields.emailNotifications': 'Notificaciones por email',
  'profile.notifications.on': 'Activadas',
  'profile.notifications.off': 'Desactivadas',
  'profile.theme.dark': 'Oscuro',
  'profile.theme.light': 'Claro',
  'profile.saveSettings': 'Guardar ajustes',
  'profile.saving': 'Guardando...',
  'profile.activity.empty': 'No hay actividad por ahora.',
  'profile.activity.loadMore': 'Cargar más',
  'profile.activity.type': 'Tipo: {type}',
  'profile.logoutAll': 'Cerrar sesión en todos los dispositivos',
  'profile.logoutAllHint': 'Próximamente',
  'profile.errors.requiredName': 'Nombre y apellido son obligatorios.',
  'profile.errors.saveFailed': 'No se pudo guardar el perfil.',
  'profile.errors.imageOnly': 'Solo se admiten archivos de imagen.',
  'profile.errors.avatarUploadFailed': 'No se pudo subir el avatar.',
  'profile.errors.avatarRemoveFailed': 'No se pudo eliminar el avatar.',
  'profile.errors.activityLoad': 'No se pudo cargar la actividad.',
  'profile.toast.saved': 'Perfil guardado',
  'profile.toast.avatarUpdated': 'Avatar actualizado',
  'profile.toast.avatarRemoved': 'Avatar eliminado',
  'profile.time.justNow': 'justo ahora',
  'profile.time.minutesAgo': 'hace {count} min',
  'profile.time.hoursAgo': 'hace {count} h',
  'profile.time.daysAgo': 'hace {count} días',
  'profile.tabs.privacy': 'Política de privacidad',
  'profile.backToMain': 'Volver a la página principal',
  'profile.header.title': 'Configuración del perfil',
  'profile.header.subtitle': 'Administra tu información personal',
  'profile.privacy.title': 'Perfil de política de privacidad',
  'profile.privacy.subtitle': 'Protege tu información personal',
  'profile.section.personalInfo': 'Información personal',
  'profile.section.passwordChange': 'Cambio de contraseña',
  'profile.section.workInfo': 'Información laboral',
  'profile.section.access': 'Acceso',
  'profile.fields.email': 'Correo',
  'profile.fields.currentPassword': 'Contraseña actual',
  'profile.fields.bio': 'Biografía',
  'profile.fields.public': 'Público',
  'profile.placeholders.organization': 'Rol / Empresa',
  'profile.placeholders.bio': 'Cuéntanos sobre ti',
  'profile.actions.changePassword': 'Cambiar contraseña',
  'profile.actions.deactivate': 'Desactivar tu cuenta',
  'profile.userFallback': 'Usuario',
  'profile.confirmDelete': '¿Seguro que quieres eliminar tu cuenta? Esta acción no se puede deshacer.',
  'profile.deactivate.title': '!ATENCIÓN!',
  'profile.deactivate.message': 'Esta acción no se puede deshacer. ¿Seguro que quieres desactivar tu cuenta?',
  'profile.deactivate.confirm': 'Desactivar',
  'profile.deactivate.close': 'Cerrar',
  'activity.context.onBoard': 'en el tablero {board}',
  'activity.context.toList': 'a {list}',
  'activity.context.fromList': 'desde {list}',
  'activity.context.inList': 'en {list}',
  'activity.context.inChecklist': 'en la lista de verificación {checklist}',
  'activity.context.onCard': 'en la tarjeta {card}',
  'activity.noDate': 'sin fecha',
  'activity.create_board': '{actor} creó el tablero {board}',
  'activity.rename_board': '{actor} renombró el tablero {board}',
  'activity.update_board': '{actor} actualizó el tablero {board}',
  'activity.archive_board': '{actor} archivó el tablero {board}',
  'activity.unarchive_board': '{actor} restauró el tablero {board}',
  'activity.create_list': '{actor} añadió la lista {list}{context}',
  'activity.rename_list': '{actor} renombró la lista {list}',
  'activity.move_list': '{actor} movió la lista {list}{context}',
  'activity.archive_list': '{actor} archivó la lista {list}',
  'activity.unarchive_list': '{actor} restauró la lista {list}',
  'activity.copy_list': '{actor} copió la lista {source} → {target}',
  'activity.create_card': '{actor} añadió la tarjeta {card}{context}',
  'activity.move_card': '{actor} movió la tarjeta {card}{from}{to}',
  'activity.archive_card': '{actor} archivó la tarjeta {card}{context}',
  'activity.unarchive_card': '{actor} restauró la tarjeta {card}{context}',
  'activity.update_card': '{actor} actualizó la tarjeta {card}',
  'activity.update_card_description': '{actor} actualizó la descripción de la tarjeta {card}',
  'activity.update_card_due_date': '{actor} cambió la fecha límite de la tarjeta {card} de {before} a {after}',
  'activity.copy_card': '{actor} copió la tarjeta {source} → {target}',
  'activity.complete_card': 'El miembro {actor} marcó esta tarjeta como completada',
  'activity.uncomplete_card': 'El miembro {actor} quitó la marca de completado de esta tarjeta',
  'activity.checklist.unchecked': '{actor} marcó {item} como no hecho{checklist}{card}',
  'activity.checklist.checked': '{actor} marcó {item} como hecho{checklist}{card}',
  'activity.add_checklist_item': '{actor} añadió la subtarea {item}{checklist}{card}',
  'activity.update_checklist_item': '{actor} actualizó la subtarea {item}{checklist}{card}',
  'activity.add_comment': '{actor} añadió el comentario {comment}{card}',
  'activity.labels.added': 'añadió etiquetas: {labels}',
  'activity.labels.removed': 'eliminó etiquetas: {labels}',
  'activity.labels.updated': 'actualizó etiquetas',
  'activity.update_card_labels': '{actor} {changes} para la tarjeta {card}',
  'activity.create_label': '{actor} creó la etiqueta {label}{context}',
  'activity.update_label': '{actor} actualizó la etiqueta {label}{context}',
  'activity.delete_label': '{actor} eliminó la etiqueta {label}{context}',
  'activity.update_profile': '{actor} actualizó el perfil',
  'activity.update_avatar': '{actor} actualizó el avatar',
  'activity.remove_avatar': '{actor} eliminó el avatar',
  'activity.default': '{actor} realizó la acción {target}',
  'privacy.summaryTitle': 'Esta política de privacidad está pensada para ayudarte a entender:',
  'privacy.body.p1': 'Your privacy matters to us. This privacy policy explains how Boardly, and our corporate affiliates collect, use, share, and protect your information when you use our products, services, websites, or otherwise interact with us. We offer a wide range of products, including our cloud and software products. We refer to all of these products, together with our other services and websites, as "Services" in this privacy policy.',
  'privacy.body.p2': 'This privacy policy also explains your choices surrounding how we use information about you, including how you can object to certain uses and how you can access and update certain information. If you do not agree with this privacy policy, do not access or use our Services.',
  'privacy.footer.accessibility': 'Accesibilidad',
  'privacy.footer.choices': 'Tus opciones de privacidad',
  'privacy.footer.policy': 'Política de privacidad',
  'privacy.footer.terms': 'Términos',
  'privacy.footer.data': 'Datos de salida',
  'privacy.footer.security': 'Seguridad',
  'errors.boardUpdate': 'No se pudo actualizar el tablero: {message}',
  'errors.listsLoad': 'No se pudieron cargar las listas: {message}',
  'errors.cardsLoad': 'No se pudieron cargar las tarjetas: {message}',
  'confirm.deleteCard': '¿Eliminar esta tarjeta?',
  'prompt.copyLink': 'Copia este enlace:',
  'toast.membersUpdateFailed': 'No se pudieron actualizar los miembros.',
  'toast.cardsReloadFailed': 'No se pudieron actualizar las tarjetas.',
  'toast.joinFailed': 'No se pudo unir al tablero.',
  'toast.checklistSaveFailed': 'No se pudo guardar la lista.',
  'toast.checklistDeleteFailed': 'No se pudo eliminar la lista.',
  'toast.checklistItemAddFailed': 'No se pudo agregar el elemento.',
  'toast.labelCreateFailed': 'No se pudo crear la etiqueta.',
  'toast.commentAddFailed': 'No se pudo agregar el comentario.',
  'toast.commentDeleteFailed': 'No se pudo eliminar el comentario.',
  'toast.attachmentAdded': 'Adjunto agregado',
  'toast.attachmentAddFailed': 'No se pudo agregar el adjunto.',
  'toast.attachmentDeleteFailed': 'No se pudo eliminar el adjunto.',
  'toast.memberAddFailed': 'No se pudo agregar el miembro.',
  'toast.memberRoleFailed': 'No se pudo cambiar el rol.',
  'toast.memberRemoveFailed': 'No se pudo eliminar el miembro.',
  'toast.inviteUnavailable': 'El enlace de invitación no está disponible.',
  'toast.cardSaveFailed': 'No se pudo guardar la tarjeta.',
  'toast.cardCopied': 'Tarjeta copiada',
  'toast.cardCopyFailed': 'No se pudo copiar la tarjeta.',
  'toast.listCopied': 'Lista copiada',
  'toast.listCopying': 'Copiando lista...',
  'toast.listCopyFailed': 'No se pudo copiar la lista.',
  'toast.listMoveFailed': 'No se pudo mover la lista.',
  'toast.cardCreateFailed': 'No se pudo crear la tarjeta.',
  'toast.cardMoveFailed': 'No se pudo mover la tarjeta.',
  'toast.cardDeleteFailed': 'No se pudo eliminar la tarjeta.',
  'toast.cardArchiveFailed': 'No se pudo actualizar el archivo de la tarjeta.',
  'toast.boardCreateFailed': 'No se pudo crear el tablero.',
  'toast.boardUpdateFailed': 'No se pudo actualizar el tablero.',
  'toast.boardArchiveFailed': 'No se pudo actualizar el archivo del tablero.',
  'toast.listArchiveFailed': 'No se pudo actualizar el archivo de la lista.',
  'toast.listCreateFailed': 'No se pudo crear la lista.',
  'toast.listRenameFailed': 'No se pudo renombrar la lista.',
};

export const normalizeLocale = (value?: string | null): Locale => {
  if (!value) return 'uk';
  const code = value.toLowerCase().split('-')[0];
  if (SUPPORTED_LOCALES.includes(code as Locale)) {
    return code as Locale;
  }
  return 'uk';
};

export const getInitialLocale = (): Locale => {
  if (typeof window === 'undefined') return 'uk';
  const stored = window.localStorage.getItem('locale');
  if (stored && SUPPORTED_LOCALES.includes(stored as Locale)) {
    return stored as Locale;
  }
  return normalizeLocale(window.navigator.language);
};
